{
  "common": {
    "loading": "লোড হচ্ছে...",
    "error": "ত্রুটি",
    "retry": "পুনরায় চেষ্টা করুন",
    "cancel": "বাতিল",
    "save": "সংরক্ষণ করুন",
    "saving": "সংরক্ষণ হচ্ছে...",
    "close": "বন্ধ করুন",
    "back": "পিছনে",
    "next": "পরবর্তী",
    "search": "খুঁজুন",
    "watchNow": "এখনই দেখুন",
    "playNow": "এখনই চালান",
    "play": "চালান",
    "moreInfo": "আরও তথ্য",
    "seeAll": "সব দেখুন",
    "new": "নতুন",
    "live": "লাইভ",
    "recommended": "প্রস্তাবিত",
    "edit": "সম্পাদনা করুন",
    "delete": "মুছুন",
    "add": "যোগ করুন",
    "enabled": "সক্রিয়",
    "disabled": "নিষ্ক্রিয়",
    "invalidDate": "অবৈধ তারিখ",
    "appName": "🏠 Bayit+",
    "appVersion": "🏠 Bayit+ v1.0.0",
    "slogan": "আপনার বাড়ি। যেকোনো জায়গায়।",
    "ok": "ঠিক আছে",
    "success": "সফল",
    "warning": "সতর্কতা",
    "confirm": "নিশ্চিত করুন",
    "yes": "হ্যাঁ",
    "no": "না",
    "apply": "প্রয়োগ করুন",
    "errors": {
      "unexpected": "একটি অপ্রত্যাশিত ত্রুটি হয়েছে"
    },
    "send": "পাঠান",
    "done": "সম্পন্ন",
    "all": "সব",
    "reset": "রিসেট করুন",
    "deleting": "মুছে ফেলা হচ্ছে...",
    "noResults": "কোনো ফলাফল পাওয়া যায়নি",
    "tryDifferentSearch": "অন্য অনুসন্ধান শব্দ চেষ্টা করুন",
    "previous": "পূর্ববর্তী",
    "actions": "কার্যক্রম",
    "pageOf": "পৃষ্ঠা {{page}} / {{total}}",
    "noData": "কোনো ডেটা নেই",
    "filters": "ফিল্টার",
    "clear": "পরিষ্কার করুন",
    "clearSelection": "[bn] Clear",
    "expand": "বিস্তারিত দেখুন",
    "collapse": "সংক্ষিপ্ত করুন",
    "upgrade": "প্রিমিয়ামে আপগ্রেড করুন",
    "skip": "এড়িয়ে যান",
    "thisContent": "[bn] this content",
    "backToHome": "[bn] Back to Home",
    "dismiss": "[bn] Dismiss",
    "goBack": "[bn] Go Back",
    "pause": "[bn] Pause",
    "tryAgain": "[bn] Try Again",
    "refresh": "রিফ্রেশ"
  },
  "culturalContext": {
    "loading": "ব্যাখ্যা লোড হচ্ছে...",
    "loadError": "ব্যাখ্যা লোড করতে ব্যর্থ",
    "related": "সম্পর্কিত তথ্যসূত্র"
  },
  "demo": {
    "banner": "ডেমো মোড",
    "bannerSubtext": "মক ডেটা ব্যবহার করা হচ্ছে",
    "days": {
      "sunday": "রবিবার",
      "monday": "সোমবার",
      "tuesday": "মঙ্গলবার",
      "wednesday": "বুধবার",
      "thursday": "বৃহস্পতিবার",
      "friday": "শুক্রবার",
      "saturday": "শনিবার"
    },
    "shabbat": "শাব্বাত",
    "until_shabbat": "শাব্বাত পর্যন্ত",
    "search_interpretation": "[bn] Search for \"{{query}}\"",
    "suggestions": {
      "0": "[bn] Fauda",
      "1": "[bn] Shtisel",
      "2": "[bn] Tehran",
      "3": "[bn] The Arbitrator",
      "4": "[bn] Labour"
    },
    "premium_plan": "প্রিমিয়াম",
    "assistant_response": "[bn] I recommend Fauda - an excellent thriller series!",
    "morning_greeting": "[bn] Good morning! Today the weather is nice, there are some important news from Israel, and I've selected content especially for you."
  },
  "hero": {
    "watch": "দেখুন",
    "moreInfo": "আরও তথ্য",
    "addToList": "তালিকায় যোগ করুন"
  },
  "login": {
    "title": "স্বাগতম",
    "subtitle": "Bayit+ চালিয়ে যেতে সাইন ইন করুন",
    "tagline": "USA-তে আপনার বাড়ি",
    "email": "ইমেইল",
    "emailPlaceholder": "আপনার ইমেইল লিখুন",
    "password": "পাসওয়ার্ড",
    "passwordPlaceholder": "আপনার পাসওয়ার্ড লিখুন",
    "submit": "সাইন ইন করুন",
    "loggingIn": "সাইন ইন হচ্ছে...",
    "or": "অথবা",
    "forgotPassword": "পাসওয়ার্ড ভুলে গেছেন?",
    "continueWithGoogle": "Google দিয়ে চালিয়ে যান",
    "noAccount": "অ্যাকাউন্ট নেই?",
    "signUp": "সাইন আপ করুন",
    "register": "নিবন্ধন করুন",
    "name": "নাম",
    "termsNotice": "[bn] By signing in, you agree to our Terms of Service and Privacy Policy",
    "errors": {
      "emailRequired": "ইমেইল প্রয়োজন",
      "passwordRequired": "পাসওয়ার্ড প্রয়োজন",
      "loginFailed": "লগইন ব্যর্থ।",
      "googleFailed": "[bn] Google sign-in failed. Please try again.",
      "fillAllFields": "সব ফিল্ড পূরণ করুন"
    },
    "qrInstructions": "[bn] Scan the code with your phone for quick login",
    "methodQR": "[bn] QR Code",
    "methodVoice": "[bn] Voice",
    "methodTraditional": "[bn] Email",
    "qrTitle": "[bn] Scan to Login",
    "qrDescription": "[bn] Scan this QR code with your phone to login without typing",
    "expiresIn": "[bn] Expires in 5 minutes",
    "companionConnected": "[bn] Phone connected!",
    "authenticating": "[bn] Logging you in...",
    "sessionExpired": "[bn] Session expired",
    "refreshQR": "[bn] Generate New Code",
    "generatingQR": "[bn] Generating QR code...",
    "howItWorks": "[bn] How it works:",
    "step1": "[bn] Open camera on your phone",
    "step2": "[bn] Scan the QR code above",
    "step3": "[bn] Login on your phone",
    "step4": "[bn] TV logs in automatically!",
    "voicePlaceholder": "[bn] Type your response...",
    "send": "[bn] Send",
    "createAccount": "[bn] Create Account",
    "bayitThinking": "[bn] Bayit is thinking...",
    "unexpectedError": "[bn] An unexpected error occurred"
  },
  "tvLogin": {
    "invalidQR": "[bn] Invalid QR code. Please scan again from your TV.",
    "sessionInvalid": "[bn] This QR code has expired. Please generate a new one on your TV.",
    "verificationFailed": "[bn] Failed to verify session. Please try again.",
    "fillAllFields": "[bn] Please fill in all fields",
    "loginFailed": "[bn] Login failed. Please check your credentials.",
    "notLoggedIn": "[bn] You are not logged in on this device.",
    "enterCredentials": "[bn] Please enter your credentials to authorize your TV.",
    "authFailed": "[bn] Authorization failed.",
    "verifying": "[bn] Verifying...",
    "verifyingDescription": "[bn] Connecting to your TV...",
    "loginTitle": "[bn] Login to Your TV",
    "loginDescription": "[bn] Enter your credentials to authorize your TV",
    "authorizing": "[bn] Authorizing...",
    "authorizingDescription": "[bn] Logging you in on your TV...",
    "authorizeTV": "[bn] Authorize TV",
    "success": "[bn] Success!",
    "successDescription": "[bn] Your TV is now logged in. You can close this page.",
    "goToHome": "[bn] Go to Home",
    "error": "[bn] Something went wrong",
    "tryAgain": "[bn] Try Again",
    "securityNote": "[bn] Your credentials are sent securely and are never stored on the TV.",
    "footer": "[bn] Having trouble? Make sure you scanned a fresh QR code from your TV.",
    "almostThere": "[bn] Almost there!",
    "authenticating": "[bn] Authenticating...",
    "connected": "[bn] Connected",
    "expired": "[bn] Code Expired",
    "expiredMessage": "[bn] Your sign-in code has expired. Please request a new one.",
    "header": "[bn] Sign In to TV",
    "pleaseSignIn": "[bn] Please sign in on your phone or computer",
    "signInButton": "[bn] Sign In",
    "signInToTV": "[bn] Sign In to TV",
    "subtitle": "[bn] Enter the code shown on your TV screen",
    "tvSignedIn": "[bn] TV signed in successfully"
  },
  "googleLogin": {
    "cancelledError": "[bn] Google sign-in was cancelled",
    "missingCode": "[bn] Authentication code is missing",
    "loginError": "[bn] Error signing in with Google",
    "redirecting": "[bn] Redirecting to login page...",
    "connecting": "[bn] Connecting with Google..."
  },
  "register": {
    "title": "অ্যাকাউন্ট তৈরি করুন",
    "subtitle": "আপনার পছন্দের কন্টেন্ট দেখতে Bayit+-এ যোগ দিন",
    "name": "পুরো নাম",
    "namePlaceholder": "রাহুল দাস",
    "email": "ইমেইল",
    "emailPlaceholder": "your@email.com",
    "password": "পাসওয়ার্ড",
    "passwordPlaceholder": "কমপক্ষে ৮টি অক্ষর",
    "confirmPassword": "পাসওয়ার্ড নিশ্চিত করুন",
    "confirmPasswordPlaceholder": "আবার পাসওয়ার্ড লিখুন",
    "submit": "সাইন আপ করুন",
    "registering": "[bn] Signing up...",
    "acceptTerms": "আমি সম্মত",
    "termsOfService": "সেবার শর্তাবলী",
    "and": "এবং",
    "privacyPolicy": "গোপনীয়তা নীতি",
    "continueWithGoogle": "[bn] Sign up with Google",
    "haveAccount": "ইতিমধ্যে অ্যাকাউন্ট আছে?",
    "signIn": "সাইন ইন করুন",
    "fullName": "[bn] Full Name",
    "loginLink": "[bn] Login",
    "placeholders": {
      "fullName": "[bn] John Doe",
      "email": "[bn] your@email.com",
      "password": "[bn] At least 8 characters",
      "confirmPassword": "[bn] Enter password again"
    },
    "errors": {
      "nameRequired": "[bn] Name is required",
      "emailRequired": "[bn] Email is required",
      "passwordRequired": "[bn] Password is required",
      "passwordTooShort": "[bn] Password must be at least 8 characters",
      "passwordMismatch": "[bn] Passwords do not match",
      "acceptTerms": "[bn] You must accept the Terms of Service and Privacy Policy",
      "fillAllFields": "[bn] Please fill in all fields",
      "registrationFailed": "[bn] Registration failed. Please try again.",
      "googleFailed": "[bn] Sign up with Google failed. Please try again."
    }
  },
  "nav": {
    "home": "হোম",
    "vod": "VOD",
    "liveTV": "লাইভ TV",
    "epg": "TV গাইড",
    "radio": "রেডিও",
    "podcasts": "পডকাস্ট",
    "flows": "ফ্লো",
    "judaism": "ইহুদি ধর্ম",
    "children": "শিশু",
    "profile": "প্রোফাইল",
    "search": "খুঁজুন",
    "settings": "সেটিংস",
    "favorites": "প্রিয়",
    "watchlist": "ওয়াচলিস্ট",
    "downloads": "ডাউনলোড",
    "recordings": "আমার রেকর্ডিং",
    "widgets": "উইজেট",
    "help": "সাহায্য",
    "discover": "[bn] Discover",
    "account": "অ্যাকাউন্ট",
    "subscribe": "সাবস্ক্রাইব করুন",
    "plans": "[bn] Plans",
    "admin": "অ্যাডমিন",
    "games": "গেমস",
    "friends": "বন্ধুরা",
    "glossary": "শব্দকোষ",
    "missions": "মিশন",
    "audiobooks": "অডিওবুক",
    "playlist": "প্লেলিস্ট",
    "zehAniHub": "জেহ আনি",
    "support": "সহায়তা",
    "discoverHub": "AI আবিষ্কার",
    "listen": "শুনুন",
    "byoc": "আমার উৎস",
    "household": "পরিবার",
    "messages": "বার্তা",
    "myContent": "আমার বিষয়বস্তু",
    "social": "সামাজিক"
  },
  "epg": {
    "title": "TV গাইড",
    "subtitle": "লাইভ TV প্রোগ্রাম সময়সূচী",
    "gridView": "গ্রিড ভিউ",
    "listView": "তালিকা ভিউ",
    "israelTime": "ইসরায়েল সময়",
    "localTime": "স্থানীয় সময়",
    "il": "[bn] IL",
    "local": "[bn] Local",
    "jumpToNow": "এখনে যান",
    "goBack": "[bn] ← {{hours}}h",
    "goForward": "[bn] {{hours}}h →",
    "toggleTimezone": "[bn] Toggle Timezone",
    "errorTitle": "TV গাইড লোড করতে ব্যর্থ",
    "errorLoading": "[bn] Could not load TV guide data",
    "noPrograms": "কোনো প্রোগ্রাম নেই",
    "noChannels": "কোনো চ্যানেল নেই",
    "recordProgram": "[bn] Record Program",
    "channel": "[bn] Channel",
    "enableSubtitles": "[bn] Enable Subtitles",
    "subtitleLanguage": "[bn] Subtitle Language",
    "storageEstimate": "[bn] Storage Estimate",
    "availableSpace": "[bn] Available Space",
    "lowStorage": "[bn] Low Storage Warning",
    "lowStorageMessage": "[bn] You're running low on storage space. Consider deleting old recordings.",
    "scheduleRecording": "[bn] Schedule Recording",
    "scheduledRecordingNotSupported": "[bn] Scheduled recordings are not yet supported. Only immediate recordings are available.",
    "recordingFailed": "[bn] Failed to start/schedule recording",
    "smartSearch": "[bn] Smart Search",
    "smartSearchSubtitle": "[bn] Ask questions in natural language",
    "smartSearchPlaceholder": "[bn] e.g., Show me all shows with actress Tali Sharon tonight",
    "searchPlaceholder": "[bn] Search programs, channels, actors...",
    "premiumRequired": "[bn] Premium Feature",
    "premiumRequiredMessage": "[bn] Smart Search uses AI to understand your questions. Upgrade to Premium to access this feature.",
    "searchWithAI": "[bn] Search with AI",
    "searching": "[bn] Searching...",
    "tryThese": "[bn] Try these examples",
    "exampleQuery1": "[bn] Show me all shows with actress Tali Sharon tonight",
    "exampleQuery2": "[bn] What comedy shows are airing this week?",
    "exampleQuery3": "[bn] Find documentaries about history on Channel 11",
    "exampleQuery4": "[bn] Show me all news programs tomorrow morning",
    "aiDisclaimer": "[bn] Powered by Claude AI. Results may vary based on program data availability.",
    "interpretationTitle": "[bn] What I understood",
    "noResultsFound": "[bn] No programs found matching your query"
  },
  "home": {
    "continueWatching": "দেখা চালিয়ে যান",
    "featuredContent": "ফিচার্ড",
    "liveTV": "লাইভ TV",
    "allChannels": "সব চ্যানেল",
    "liveChannels": "লাইভ চ্যানেল",
    "showOnlyWithSubtitles": "[bn] Show only with subtitles",
    "israeliMovies": "ইসরায়েলি সিনেমা",
    "israeli-movies": "[bn] Israeli Movies",
    "israeli-series": "[bn] Israeli Series",
    "action": "[bn] Action & Thriller",
    "comedy": "কমেডি",
    "drama": "ড্রামা",
    "documentaries": "ডকুমেন্টারি",
    "loadingContent": "কন্টেন্ট লোড হচ্ছে...",
    "liveNow": "এখন লাইভ",
    "trendingInIsrael": "[bn] Trending in Israel",
    "jerusalemConnection": "[bn] Jerusalem Connection",
    "telAvivConnection": "[bn] Tel Aviv Connection",
    "categories": "বিভাগ",
    "nearYou": "কাছাকাছি ইসরায়েলীয়",
    "betaExclusive": "বিটা এক্সক্লুসিভ",
    "carousel": {
      "fauda": {
        "title": "[bn] Fauda",
        "subtitle": "[bn] Season 4 - Now Streaming",
        "description": "[bn] The hit Israeli series returns for a fourth season full of suspense and action"
      },
      "shtisel": {
        "title": "[bn] Shtisel",
        "subtitle": "[bn] All Seasons Available",
        "description": "[bn] Follow the Shtisel family in the ultra-Orthodox neighborhood of Jerusalem"
      },
      "tehran": {
        "title": "[bn] Tehran",
        "subtitle": "[bn] Season 2",
        "description": "[bn] A Mossad agent deep in Iran on a dangerous mission"
      },
      "live": {
        "title": "[bn] Live - Kan 11",
        "subtitle": "[bn] Watch Now",
        "description": "[bn] News, current affairs and quality content"
      }
    },
    "enableLocation": "[bn] Enable Location",
    "locationPermissionDeniedDescription": "[bn] Location access was denied. Enable it in Settings to see content near you.",
    "locationPermissionDescription": "[bn] Allow location access to discover content near you.",
    "openSettings": "[bn] Open Settings"
  },
  "search": {
    "title": "খুঁজুন",
    "subtitle": "সিনেমা, সিরিজ, চ্যানেল, রেডিও এবং পডকাস্ট খুঁজুন",
    "placeholder": "কন্টেন্ট খুঁজুন...",
    "voicePlaceholder": "[bn] Speak now...",
    "searching": "খুঁজছে...",
    "listening": "শুনছে...",
    "noResults": "কোনো ফলাফল নেই",
    "noResultsHint": "[bn] Try different keywords or change your filters",
    "tryDifferent": "[bn] Try different search terms",
    "resultsFor": "[bn] results for",
    "resultsFound": "[bn] {{count}} results found for \"{{query}}\"",
    "recentSearches": "সাম্প্রতিক অনুসন্ধান",
    "clearAll": "সব মুছুন",
    "trending": "[bn] Trending Searches",
    "promptTitle": "[bn] What are you looking for?",
    "promptDescription": "[bn] Search for your favorite content or use voice search",
    "filters": {
      "all": "সব",
      "vod": "সিনেমা ও সিরিজ",
      "live": "চ্যানেল",
      "radio": "রেডিও",
      "podcast": "পডকাস্ট",
      "moviesAndSeries": "[bn] Movies & Series",
      "channels": "[bn] Channels",
      "podcasts": "[bn] Podcasts"
    },
    "suggestions": {
      "movies": "[bn] Movies",
      "series": "[bn] Series",
      "liveTV": "[bn] Live TV",
      "news": "[bn] News",
      "sports": "[bn] Sports",
      "kids": "[bn] Kids"
    }
  },
  "liveTV": {
    "title": "লাইভ TV",
    "channels": "চ্যানেল",
    "nowPlaying": "এখন চলছে",
    "loadError": "চ্যানেল লোড করতে ব্যর্থ",
    "categories": {
      "all": "সব",
      "news": "সংবাদ",
      "sports": "খেলাধুলা",
      "entertainment": "বিনোদন",
      "kids": "শিশু",
      "documentary": "ডকুমেন্টারি"
    }
  },
  "listen": {
    "title": "শুনুন",
    "subtitle": "রেডিও, পডকাস্ট ও অডিওবুক",
    "tab": {
      "radio": "রেডিও",
      "podcasts": "পডকাস্ট",
      "audiobooks": "অডিওবুক"
    }
  },
  "radio": {
    "title": "রেডিও",
    "categories": {
      "all": "সব",
      "music": "সংগীত",
      "news": "সংবাদ",
      "talk": "টক",
      "jewish": "ইহুদি"
    },
    "noStations": "কোনো রেডিও স্টেশন নেই",
    "tryLater": "পরে আবার চেষ্টা করুন",
    "playing": "চলছে",
    "fmSuffix": "FM"
  },
  "podcasts": {
    "title": "পডকাস্ট",
    "episodes": "পর্ব",
    "categories": {
      "all": "সব",
      "general": "সাধারণ",
      "news": "সংবাদ",
      "politics": "রাজনীতি",
      "tech": "প্রযুক্তি",
      "business": "ব্যবসা",
      "jewish": "ইহুদি",
      "entertainment": "বিনোদন",
      "sports": "খেলাধুলা",
      "history": "ইতিহাস",
      "educational": "শিক্ষামূলক"
    },
    "noPodcasts": "কোনো পডকাস্ট নেই",
    "tryLater": "[bn] Try again later",
    "playLatest": "[bn] Play Latest"
  },
  "vod": {
    "title": "সিনেমা ও সিরিজ",
    "movies": "সিনেমা",
    "series": "সিরিজ",
    "searchPlaceholder": "সিনেমা ও সিরিজ খুঁজুন...",
    "noMovies": "কোনো সিনেমা নেই",
    "noSeries": "কোনো সিরিজ নেই",
    "loadError": "কন্টেন্ট লোড করতে ব্যর্থ",
    "showOnlyWithSubtitles": "[bn] Show only with subtitles",
    "categories": {
      "all": "সব",
      "drama": "ড্রামা",
      "comedy": "কমেডি",
      "action": "অ্যাকশন",
      "documentary": "ডকুমেন্টারি",
      "kids": "শিশু"
    },
    "allCategories": "[bn] All",
    "emptyTitle": "[bn] No Content Available",
    "emptyDescription": "[bn] Try selecting another category",
    "allContent": "[bn] All Content",
    "noContent": "[bn] No content available",
    "noContentInCategory": "[bn] No content found in this category"
  },
  "account": {
    "title": "আমার অ্যাকাউন্ট",
    "profile": "প্রোফাইল",
    "settings": "সেটিংস",
    "subscription": "সাবস্ক্রিপশন",
    "manageSubscription": "[bn] Manage Subscription",
    "personalDetails": "[bn] Personal Details",
    "billing": "[bn] Billing & Payment",
    "logout": "লগআউট",
    "login": "লগইন",
    "register": "[bn] Register",
    "email": "[bn] Email",
    "password": "[bn] Password",
    "name": "[bn] Name",
    "guest": "অতিথি",
    "premium": "প্রিমিয়াম",
    "basic": "বেসিক"
  },
  "flows": {
    "title": "[bn] Flows",
    "subtitle": "[bn] Personalized content experiences for every moment",
    "activeNow": "[bn] Active Now",
    "start": "[bn] Start",
    "skipToday": "[bn] Skip Today",
    "systemFlows": "[bn] Ready-Made Flows",
    "customFlows": "[bn] My Flows",
    "system": "[bn] System",
    "noCustomFlows": "[bn] No custom flows yet",
    "createHint": "[bn] Create your first personalized flow",
    "createCustom": "[bn] Create Custom Flow",
    "createFlow": "[bn] Create Flow",
    "editFlow": "[bn] Edit Flow",
    "type": "[bn] Type",
    "systemFlow": "[bn] System Flow",
    "customFlow": "[bn] Custom Flow",
    "schedule": "[bn] Schedule",
    "content": "[bn] Content",
    "items": "[bn] items",
    "aiGenerated": "[bn] AI Generated",
    "autoPlay": "[bn] Auto Play",
    "aiEnabled": "[bn] AI Curation",
    "shabbatTrigger": "[bn] Shabbat Evening",
    "manual": "[bn] Manual",
    "flowName": "[bn] Flow Name",
    "flowNamePlaceholder": "[bn] e.g., My Morning Routine",
    "description": "[bn] Description",
    "descriptionPlaceholder": "[bn] What is this flow for?",
    "startTime": "[bn] Start Time",
    "endTime": "[bn] End Time",
    "actions": "[bn] Actions",
    "details": "[bn] Details",
    "createFlowDesc": "[bn] Design your personalized content experience",
    "editFlowDesc": "[bn] Update your flow settings and content",
    "basicInfo": "[bn] Basic Information",
    "options": "[bn] Options",
    "autoPlayDesc": "[bn] Automatically play next item when current one ends",
    "aiEnabledDesc": "[bn] Let AI curate content based on your preferences",
    "startFlow": "[bn] Start Flow",
    "deleteFlow": "[bn] Delete Flow",
    "custom": "[bn] Custom",
    "morning": "[bn] Morning",
    "evening": "[bn] Evening",
    "shabbat": "[bn] Shabbat",
    "addContent": "[bn] Add Content",
    "contentPicker": {
      "title": "[bn] Add Content to Flow",
      "tabs": {
        "live": "[bn] Live TV",
        "radio": "[bn] Radio",
        "vod": "[bn] On Demand",
        "podcast": "[bn] Podcasts"
      },
      "search": "[bn] Search content...",
      "selected": "[bn] {{count}} selected",
      "addSelected": "[bn] Add Selected",
      "noResults": "[bn] No content found",
      "alreadyAdded": "[bn] Already in flow",
      "loadMore": "[bn] Load More"
    },
    "flowItems": {
      "title": "[bn] Flow Content",
      "empty": "[bn] No content yet. Click Add Content to get started.",
      "count": "[bn] {{count}} items",
      "remove": "[bn] Remove",
      "moveUp": "[bn] Move Up",
      "moveDown": "[bn] Move Down",
      "order": "[bn] Order",
      "confirmRemove": "[bn] Click again to confirm removal",
      "maxReached": "[bn] Maximum {{max}} items reached",
      "more": "[bn] more items"
    },
    "days": {
      "sunday": "[bn] Sunday",
      "monday": "[bn] Monday",
      "tuesday": "[bn] Tuesday",
      "wednesday": "[bn] Wednesday",
      "thursday": "[bn] Thursday",
      "friday": "[bn] Friday",
      "saturday": "[bn] Saturday",
      "sundayShort": "[bn] Sun",
      "mondayShort": "[bn] Mon",
      "tuesdayShort": "[bn] Tue",
      "wednesdayShort": "[bn] Wed",
      "thursdayShort": "[bn] Thu",
      "fridayShort": "[bn] Fri",
      "saturdayShort": "[bn] Sat",
      "selectAll": "[bn] Select All",
      "deselectAll": "[bn] Deselect All",
      "title": "[bn] Active Days",
      "everyday": "[bn] Every day",
      "everyDay": "[bn] Every day",
      "weekdays": "[bn] Weekdays",
      "weekends": "[bn] Weekends",
      "noneSelected": "[bn] No days selected",
      "selectedCount": "[bn] {{count}} days selected"
    },
    "trigger": {
      "type": "[bn] Trigger Type",
      "time": "[bn] Time-based",
      "shabbat": "[bn] Shabbat Evening",
      "holiday": "[bn] Holiday",
      "skipShabbat": "[bn] Skip on Shabbat",
      "skipShabbatDesc": "[bn] Don't run this flow on Friday evening or Saturday",
      "shabbatOffset": "[bn] Minutes before candle lighting",
      "shabbatOffsetDesc": "[bn] How many minutes before Shabbat should this flow start?",
      "calculatedTime": "[bn] Calculated time",
      "thisWeek": "[bn] This week: {{day}} at {{time}}",
      "comingSoon": "[bn] Holiday triggers coming soon",
      "locationBased": "[bn] Times based on your location"
    },
    "examples": {
      "title": "[bn] Example Flows",
      "subtitle": "[bn] Tap to use as a template",
      "morningRoutine": {
        "name": "[bn] Morning Routine",
        "desc": "[bn] Start your day with news, weather, and uplifting content"
      },
      "eveningWindDown": {
        "name": "[bn] Evening Wind Down",
        "desc": "[bn] Relax with calming music and light entertainment"
      },
      "shabbatPrep": {
        "name": "[bn] Shabbat Preparation",
        "desc": "[bn] Set the mood for Shabbat with special content"
      },
      "coffeeBreak": {
        "name": "[bn] Coffee Break",
        "desc": "[bn] Quick entertainment for a short break"
      },
      "sunsetVibes": {
        "name": "[bn] Sunset Vibes",
        "desc": "[bn] Weekend relaxation with music and ambient content"
      }
    },
    "aiBrief": "[bn] AI Brief",
    "aiBriefDesc": "[bn] Get a personalized AI-generated summary before the flow starts",
    "aiBriefEnabled": "[bn] AI Brief Enabled",
    "validation": {
      "nameRequired": "[bn] Flow name is required",
      "startTimeRequired": "[bn] Start time is required",
      "endTimeRequired": "[bn] End time is required",
      "timeRange": "[bn] End time must be after start time",
      "daysRequired": "[bn] Select at least one day",
      "contentRequired": "[bn] Add content or enable AI"
    },
    "tv": {
      "useCompanion": "[bn] For full customization, use the Bayit+ app on your phone or visit bayit.plus on your computer."
    }
  },
  "profile": {
    "title": "আমার প্রোফাইল",
    "profileDetails": "[bn] Profile Details",
    "name": "নাম",
    "notSet": "সেট করা হয়নি",
    "email": "ইমেইল",
    "editProfile": "প্রোফাইল সম্পাদনা করুন",
    "notificationSettings": "[bn] Notification Settings",
    "security": "[bn] Security",
    "changePassword": "[bn] Change Password",
    "updatePassword": "[bn] Update your password",
    "connectedDevices": "[bn] Connected Devices",
    "manageDevices": "[bn] Manage devices connected to your account",
    "twoFactorAuth": "[bn] Two-Factor Authentication",
    "addExtraSecurity": "[bn] Add an extra layer of security",
    "address": {
      "line1": "[bn] 123 Main Street",
      "line2": "[bn] Tel Aviv, Israel 6100000"
    },
    "free": "[bn] Free",
    "premiumPrice": "[bn] $7.99/month",
    "familyPrice": "[bn] $12.99/month",
    "remaining": "[bn] remaining",
    "tabs": {
      "personal": "[bn] Personal",
      "overview": "[bn] Overview",
      "subscription": "[bn] Subscription",
      "notifications": "[bn] Notifications",
      "security": "[bn] Security",
      "ai": "[bn] AI & Voice",
      "voice": "[bn] Voice & Accessibility"
    },
    "subscription": {
      "currentPlan": "[bn] Current Plan",
      "renewsOn": "[bn] Renews on",
      "manageSubscription": "[bn] Manage Subscription",
      "cancelSubscription": "[bn] Cancel Subscription",
      "noActivePlan": "[bn] No active subscription",
      "selectPlan": "[bn] Select a Plan"
    },
    "notifications": "[bn] Notifications",
    "ai": {
      "title": "[bn] AI & Personalization",
      "description": "[bn] Configure AI-powered features",
      "assistant": "[bn] AI Assistant",
      "assistantDesc": "[bn] Personalized recommendations and help",
      "chatbot": "[bn] AI Assistant",
      "chatbotEnabled": "[bn] Enable AI Assistant",
      "chatbotEnabledDesc": "[bn] Get help navigating content",
      "saveHistory": "[bn] Save Conversation History",
      "saveHistoryDesc": "[bn] Remember previous conversations",
      "recommendations": "[bn] Recommendations",
      "personalizedRecs": "[bn] Personalized Recommendations",
      "personalizedRecsDesc": "[bn] Content suggestions based on history",
      "privacy": "[bn] Privacy & Data",
      "privacyDesc": "[bn] Your data is encrypted and secure",
      "dataConsent": "[bn] Usage Analytics",
      "dataConsentDesc": "[bn] Help improve AI features",
      "privacyNote": "[bn] Your data is encrypted and secure"
    },
    "voice": {
      "title": "[bn] Voice Control",
      "description": "[bn] Hands-free navigation",
      "enabled": "[bn] Voice Commands",
      "enabledDesc": "[bn] Control the app with your voice",
      "tts": "[bn] Text-to-Speech",
      "ttsDesc": "[bn] AI responses read aloud",
      "wakeWord": "[bn] Wake Word Detection",
      "wakeWordDesc": "[bn] Say \"Bayit\" to activate",
      "operationMode": "[bn] Operation Mode",
      "operationModeDesc": "[bn] Choose how you interact with the app",
      "voiceSearch": "[bn] Voice Search",
      "voiceSearchEnabled": "[bn] Enable voice search",
      "voiceSearchEnabledDesc": "[bn] Search for content using your voice",
      "constantListening": "[bn] Always Listening Mode",
      "constantListeningDesc": "[bn] Continuously listen for voice commands without pressing a button",
      "constantListeningPrivacy": "[bn] Audio is only sent to servers when speech is detected",
      "holdButtonMode": "[bn] Hold Button to Talk",
      "holdButtonModeDesc": "[bn] Press and hold the microphone button instead of always listening",
      "sensitivity": "[bn] Voice Detection Sensitivity",
      "sensitivityDesc": "[bn] Adjust how responsive the voice detection is",
      "sensitivityLow": "[bn] Low (fewer false triggers)",
      "sensitivityMedium": "[bn] Medium (balanced)",
      "sensitivityHigh": "[bn] High (most responsive)",
      "silenceThreshold": "[bn] Silence Detection",
      "silenceThresholdDesc": "[bn] How long to wait after speaking before processing",
      "language": "[bn] Voice language",
      "accessibility": "[bn] Accessibility",
      "autoSubtitle": "[bn] Auto-enable subtitles",
      "autoSubtitleDesc": "[bn] Automatically show subtitles when playing content",
      "highContrast": "[bn] High contrast mode",
      "highContrastDesc": "[bn] Increase contrast for better visibility",
      "textSize": "[bn] Text size",
      "textSizeSmall": "[bn] Small",
      "textSizeMedium": "[bn] Medium",
      "textSizeLarge": "[bn] Large",
      "voiceOnlyInfo": "[bn] Voice Only Mode",
      "voiceOnlyDetails": "[bn] Say \"Hi Bayit\" to activate. Remote control disabled. Navigate entirely with voice commands.",
      "hybridInfo": "[bn] Hybrid Mode",
      "hybridDetails": "[bn] Use voice or remote control. Voice feedback on non-voice actions.",
      "classicInfo": "[bn] Classic Mode",
      "classicDetails": "[bn] All voice features disabled. Remote control only.",
      "textToSpeech": "[bn] Voice Responses",
      "ttsEnabled": "[bn] Enable voice responses",
      "ttsEnabledDesc": "[bn] App will speak responses to your voice commands",
      "ttsVolume": "[bn] Voice Volume",
      "ttsSpeed": "[bn] Speaking Speed",
      "hybridFeedback": "[bn] Interactive Feedback",
      "voiceFeedback": "[bn] Voice feedback on actions",
      "voiceFeedbackDesc": "[bn] Get voice confirmation when you use the remote or click buttons",
      "feedbackExample": "[bn] Example: Click a movie → App says \"Playing [Movie Name]\""
    },
    "dropdown": {
      "myProfile": "[bn] My Profile",
      "subscription": "[bn] Subscription",
      "favorites": "[bn] Favorites",
      "downloads": "[bn] Downloads",
      "signOut": "[bn] Sign Out"
    },
    "guest": "[bn] Guest",
    "morningRitual": "[bn] Morning Ritual",
    "watchlist": "[bn] Watchlist",
    "favorites": "[bn] Favorites",
    "downloads": "[bn] Downloads",
    "settings": "[bn] Settings",
    "language": "[bn] Language",
    "admin": "[bn] Admin",
    "watchTime": "[bn] Watch Time",
    "minutes": "[bn] minutes",
    "hours": "[bn] hours",
    "logout": "লগ আউট",
    "premium": "প্রিমিয়াম",
    "basic": "বেসিক",
    "upgrade": "প্রিমিয়ামে আপগ্রেড করুন",
    "memberSince": "[bn] Member since",
    "aiAssistant": "[bn] AI Assistant",
    "voiceSettings": "[bn] Voice",
    "subscriptionButton": "[bn] Subscription",
    "recentActivity": "[bn] Recent Activity",
    "justNow": "[bn] Just now",
    "hoursAgo": "[bn] {{hours}} hours ago",
    "yesterday": "[bn] Yesterday",
    "noRecentActivity": "[bn] No recent activity",
    "accountInfo": "[bn] Account Information",
    "role": "[bn] Role",
    "accountSecurity": "[bn] Account Security",
    "securityNote": "[bn] Your account is secured with encrypted authentication",
    "lastLogin": "[bn] Last login",
    "dangerZone": "[bn] Danger Zone",
    "invalidImageType": "[bn] Please select a valid image file (JPEG, PNG, WebP, or GIF)",
    "imageTooLarge": "[bn] Image is too large. Maximum size is 5MB.",
    "uploadSuccess": "[bn] Avatar updated successfully!",
    "uploadFailed": "[bn] Failed to upload avatar. Please try again.",
    "complimentaryPremium": "বিনামূল্যে প্রিমিয়াম অ্যাক্সেস",
    "emailVerified": "ইমেল যাচাই করা হয়েছে",
    "emailUnverified": "ইমেল যাচাই করা হয়নি",
    "phoneVerified": "ফোন যাচাই করা হয়েছে",
    "phoneUnverified": "ফোন যাচাই করা হয়নি",
    "completeVerification": "সমস্ত বৈশিষ্ট্য আনলক করতে যাচাই সম্পূর্ণ করুন",
    "unlockPremium": "প্রিমিয়াম বৈশিষ্ট্য আনলক করুন",
    "unlockPremiumDescription": "একচেটিয়া বিষয়বস্তু এবং বৈশিষ্ট্য উপভোগ করতে আপগ্রেড করুন"
  },
  "voiceMode": {
    "voiceOnly": "[bn] Voice Only",
    "voiceOnlyDesc": "[bn] No remote control - full voice navigation",
    "hybrid": "[bn] Hybrid",
    "hybridDesc": "[bn] Voice + Remote - voice feedback on actions",
    "classic": "[bn] Classic",
    "classicDesc": "[bn] No voice - remote control only"
  },
  "settings": {
    "title": "সেটিংস",
    "language": "ভাষা",
    "appLanguage": "অ্যাপ ভাষা",
    "selectLanguage": "ভাষা নির্বাচন করুন",
    "languages": {
      "en": "ইংরেজি",
      "he": "হিব্রু",
      "es": "স্প্যানিশ",
      "zh": "中文",
      "fr": "ফরাসি",
      "it": "ইতালীয়",
      "hi": "হিন্দি",
      "ta": "তামিল",
      "bn": "বাংলা",
      "ja": "日本語"
    },
    "chatTranslation": "[bn] Chat Translation",
    "autoTranslate": "[bn] Auto-translate messages",
    "autoTranslateDescription": "[bn] Automatically translate chat messages to your preferred language",
    "notifications": "বিজ্ঞপ্তি",
    "pushNotifications": "[bn] Push Notifications",
    "playback": "প্লেব্যাক",
    "quality": "মান",
    "subtitles": "সাবটাইটেল",
    "autoplay": "অটোপ্লে",
    "appearance": "চেহারা",
    "darkMode": "ডার্ক মোড",
    "privacy": "গোপনীয়তা",
    "privacyPolicy": "গোপনীয়তা নীতি",
    "termsOfService": "সেবার শর্তাবলী",
    "about": "সম্পর্কে",
    "display": "[bn] Display",
    "homePageSections": "[bn] Home Page Sections",
    "configureSections": "[bn] Configure which sections appear on your home page",
    "visibleSections": "[bn] Visible Sections",
    "hiddenSections": "[bn] Hidden Sections",
    "dragToReorder": "[bn] Drag to reorder",
    "tapToHide": "[bn] Tap to hide",
    "tapToShow": "[bn] Tap to show",
    "resetToDefault": "[bn] Reset to Default",
    "resetConfirmMessage": "[bn] Are you sure you want to reset home page sections to their default configuration?",
    "sectionHidden": "[bn] Section hidden",
    "sectionShown": "[bn] Section shown",
    "replayTour": "ফিচার ট্যুর আবার দেখুন"
  },
  "help": {
    "subtitle": "[bn] How can we help you?",
    "email": "[bn] Email Support",
    "phone": "[bn] Phone Support",
    "chat": "[bn] Live Chat",
    "chatAvailable": "[bn] Available 24/7",
    "openTooltip": "[bn] Open help tooltip",
    "openHelp": "[bn] Open help menu",
    "howTo": "[bn] How to use",
    "relatedArticles": "[bn] Related articles",
    "stillNeedHelp": "[bn] Still need help?",
    "contactSupport": "[bn] Contact Support",
    "previous": "[bn] Previous",
    "next": "[bn] Next",
    "getStarted": "[bn] Get Started",
    "skipTutorial": "[bn] Skip tutorial",
    "actions": {
      "search": "[bn] Search Help",
      "docs": "[bn] Documentation",
      "faq": "[bn] FAQ",
      "support": "[bn] Contact Support",
      "tutorial": "[bn] View Tutorial"
    },
    "search": {
      "placeholder": "[bn] Search help...",
      "noResults": "[bn] No results found for \"{{query}}\"",
      "noResultsHint": "[bn] Try different keywords or browse categories",
      "recent": "[bn] Recent",
      "popular": "[bn] Popular"
    },
    "categories": {
      "getting-started": "[bn] Getting Started",
      "features": "[bn] Features",
      "judaism": "[bn] Judaism",
      "platform-guides": "[bn] Platform Guides",
      "account": "[bn] Account",
      "troubleshooting": "[bn] Troubleshooting",
      "parents": "[bn] For Parents",
      "admin": "[bn] Admin Guide",
      "developer": "[bn] Developer API"
    },
    "faq": {
      "title": "[bn] Frequently Asked Questions",
      "q1": "[bn] How do I change my subscription plan?",
      "a1": "[bn] Go to Settings > Subscription to view and change your current plan. You can upgrade or downgrade at any time.",
      "q2": "[bn] How do I download content for offline viewing?",
      "a2": "[bn] Tap the download icon on any content to save it for offline viewing. Downloads are available on mobile devices only.",
      "q3": "[bn] Why isn't my video playing?",
      "a3": "[bn] Check your internet connection. If the problem persists, try clearing the app cache or restarting the app.",
      "q4": "[bn] How do I cancel my subscription?",
      "a4": "[bn] You can cancel your subscription anytime through Settings > Subscription > Cancel Plan. You'll continue to have access until the end of your billing period."
    },
    "onboarding": {
      "welcome": {
        "title": "[bn] Welcome to Bayit+",
        "description": "[bn] Your home for Israeli entertainment, anywhere in the world"
      },
      "liveTv": {
        "title": "[bn] Live TV",
        "description": "[bn] Watch Israeli channels live, including news, sports, and entertainment"
      },
      "vod": {
        "title": "[bn] On-Demand Content",
        "description": "[bn] Browse movies, series, and documentaries anytime"
      },
      "voice": {
        "title": "[bn] Voice Control",
        "description": "[bn] Say 'Bayit' to control the app with your voice"
      },
      "profiles": {
        "title": "[bn] Family Profiles",
        "description": "[bn] Create profiles for each family member with personalized recommendations"
      }
    }
  },
  "voice": {
    "panelTitle": "ভয়েস সহকারী",
    "typeCommand": "একটি কমান্ড টাইপ করুন...",
    "controlExecuted": "সম্পাদিত: {{action}}",
    "timerSet": "{{amount}} {{unit}} এর জন্য টাইমার সেট করা হয়েছে",
    "chatPending": "আপনার বার্তা প্রক্রিয়া করা হচ্ছে...",
    "suggestion": {
      "watchLive": "লাইভ টিভি দেখুন",
      "search": "কন্টেন্ট অনুসন্ধান করুন",
      "listenRadio": "রেডিও শুনুন"
    },
    "error": {
      "micDenied": "মাইক্রোফোন অ্যাক্সেস অস্বীকৃত",
      "notSupported": "এই ব্রাউজারে ভয়েস কমান্ড সমর্থিত নয়",
      "recognitionFailed": "বুঝতে পারিনি। আবার চেষ্টা করুন।"
    }
  },
  "errors": {
    "networkError": "নেটওয়ার্ক ত্রুটি",
    "loadingFailed": "লোড করা ব্যর্থ",
    "tryAgain": "পুনরায় চেষ্টা করুন",
    "offline": {
      "title": "ইন্টারনেট সংযোগ নেই",
      "message": "আপনি বর্তমানে অফলাইনে আছেন।",
      "ttsMessage": "[bn] No internet connection. You are now in offline mode."
    },
    "online": {
      "title": "সংযোগ পুনরুদ্ধার",
      "message": "আপনি আবার অনলাইনে আছেন।",
      "ttsMessage": "[bn] Internet connection restored."
    },
    "api": {
      "badRequest": "[bn] Something went wrong. Please try again.",
      "unauthorized": "[bn] Please log in to continue.",
      "forbidden": "[bn] You do not have permission to access this content.",
      "notFound": "[bn] The content you are looking for is not available.",
      "rateLimit": "[bn] You are making too many requests. Please wait a moment.",
      "serverError": "[bn] Our servers are having issues. Please try again later.",
      "unknown": "[bn] Something went wrong. Please try again.",
      "networkTimeout": "[bn] Unable to connect to our servers. Please check your connection.",
      "offlineMessage": "[bn] You are offline. Please check your internet connection.",
      "requestFailed": "[bn] Something went wrong. Please try again."
    },
    "voice": {
      "permissionDenied": "[bn] Microphone access is required for voice commands. Please enable it in Settings.",
      "recognitionFailed": "[bn] I didn't understand that. Please try again.",
      "commandFailed": "[bn] Voice command failed. Please try again."
    },
    "widget": {
      "loadFailed": "[bn] Unable to load widget. Please try again."
    },
    "buttons": {
      "ok": "[bn] OK",
      "retry": "[bn] Retry",
      "cancel": "[bn] Cancel"
    },
    "title": "[bn] Error",
    "networkUnavailable": "[bn] Network unavailable",
    "no_audio_url": "অডিও URL উপলব্ধ নেই",
    "connection_failed": "সংযোগ ব্যর্থ",
    "quota_exceeded": "কোটা অতিক্রম করেছে",
    "server_error": "সার্ভার ত্রুটি"
  },
  "player": {
    "loading": "লোড হচ্ছে...",
    "retry": "পুনরায় চেষ্টা করুন",
    "error": "ভিডিও চালাতে ত্রুটি",
    "back": "← পিছনে",
    "liveBadge": "লাইভ",
    "noStream": "স্ট্রিম নেই",
    "loadError": "[bn] Failed to load stream",
    "settings": "সেটিংস",
    "subtitles": "[bn] Subtitles",
    "playbackSpeed": "[bn] Playback Speed",
    "quality": "মান",
    "auto": "অটো",
    "previousChapter": "[bn] Previous chapter",
    "nextChapter": "[bn] Next chapter",
    "skipBackward": "[bn] Skip backward 30 seconds",
    "skipForward": "[bn] Skip forward 30 seconds",
    "restart": "পুনরায় শুরু করুন",
    "subtitlesOff": "বন্ধ",
    "speed": "গতি",
    "subscription": {
      "requiredTitle": "[bn] Subscription Required",
      "requiredMessage": "[bn] requires a paid subscription",
      "upgradeInfo": "[bn] Upgrade your subscription to access premium content",
      "upgrade": "[bn] Upgrade Now"
    },
    "ai": {
      "dub": "Dub",
      "dubbing": "ডাবিং",
      "featuresTitle": "AI বৈশিষ্ট্য",
      "languagePrimary": "প্রাথমিক",
      "languageSecondary": "গৌণ (ঐচ্ছিক)",
      "languageTitle": "AI ভাষা",
      "liveTranslate": "লাইভ অনুবাদ",
      "selectLanguage": "ভাষা নির্বাচন করুন",
      "split": "বিভক্ত করুন",
      "togglePanel": "AI প্যানেল টগল করুন",
      "translate": "অনুবাদ করুন",
      "trivia": "ট্রিভিয়া",
      "triviaToggle": "[bn] Trivia"
    },
    "catchup": {
      "description": "শুরুটা মিস করেছেন? এখন পর্যন্ত কী হয়েছে তার AI-চালিত সারাংশ পান।",
      "generateSummary": "সারাংশ তৈরি করুন",
      "summaryTitle": "সারাংশ",
      "title": "ক্যাচ আপ",
      "keyPoints": "[bn] Key Points",
      "transcript": "[bn] Transcript"
    },
    "chat": {
      "title": "লাইভ চ্যাট",
      "messagePlaceholder": "একটি বার্তা টাইপ করুন..."
    },
    "companion": {
      "noContext": "এই বিষয়বস্তুর জন্য এখনো কোনো সাংস্কৃতিক প্রসঙ্গ উপলব্ধ নেই।",
      "quizComplete": "কুইজ সম্পূর্ণ",
      "quizRetry": "পুনরায় চেষ্টা করুন",
      "quizStart": "কুইজ শুরু করুন",
      "quizTitle": "আপনার জ্ঞান পরীক্ষা করতে প্রস্তুত?",
      "quizTryAgain": "আবার চেষ্টা করুন",
      "tabContext": "প্রসঙ্গ",
      "tabQuiz": "কুইজ",
      "tabVocabulary": "শব্দভান্ডার",
      "tapWords": "এখানে যোগ করতে সাবটাইটেলের শব্দগুলিতে ট্যাপ করুন",
      "title": "AI সঙ্গী",
      "loadError": "AI শেখার ডেটা লোড করতে ব্যর্থ"
    },
    "controls": {
      "audioTrack": "অডিও ট্র্যাক",
      "continueWatching": "দেখা চালিয়ে যান",
      "dismiss": "বাতিল করুন",
      "goBack": "ফিরে যান",
      "navigateBack": "পিছনে নেভিগেট করুন",
      "on": "ON",
      "pause": "বিরতি",
      "play": "চালান",
      "preview": "প্রিভিউ",
      "selected": "নির্বাচিত",
      "send": "পাঠান",
      "skip": "এড়িয়ে যান",
      "close": "[bn] Close",
      "exitFullscreen": "[bn] Exit Fullscreen",
      "fullscreen": "[bn] Fullscreen",
      "restart": "[bn] Restart",
      "skipBackward": "[bn] Skip Backward",
      "skipForward": "[bn] Skip Forward",
      "volume": "[bn] Volume"
    },
    "dubbing": {
      "notNow": "এখন নয়",
      "premiumMessage": "লাইভ ডাবিংয়ের জন্য Premium বা Beta 500 সাবস্ক্রিপশন প্রয়োজন",
      "premiumTitle": "প্রিমিয়াম বৈশিষ্ট্য",
      "upgrade": "আপগ্রেড করুন",
      "voiceTitle": "ডাবিং ভয়েস",
      "settings_title": "লাইভ ডাবিং সেটিংস",
      "target_language": "লক্ষ্য ভাষা"
    },
    "errors": {
      "streamLimitMessage": "আপনি {{maxStreams}} সমসাময়িক স্ট্রিমের সর্বোচ্চ সীমায় পৌঁছেছেন। অনুগ্রহ করে অন্য একটি স্ট্রিম বন্ধ করুন বা আপনার প্ল্যান আপগ্রেড করুন।",
      "streamLimitTitle": "স্ট্রিম সীমা পৌঁছেছে",
      "upgradePlan": "প্ল্যান আপগ্রেড করুন"
    },
    "audio_description": "অডিও বিবরণ",
    "dismiss": "বাতিল করুন",
    "scene_search": "দৃশ্য অনুসন্ধান",
    "search_placeholder": "একটি দৃশ্য অনুসন্ধান করুন...",
    "language_ratio": "ভাষা শেখার অনুপাত",
    "go_back": "ফিরে যান",
    "sleepTimer": {
      "title": "স্লিপ টাইমার",
      "subtitle": "নির্ধারিত সময়ের পরে প্লেব্যাক স্বয়ংক্রিয়ভাবে বিরতি দিন",
      "minutes": "{{count}} মিনিট",
      "customPlaceholder": "কাস্টম মিনিট",
      "set": "টাইমার সেট করুন",
      "remaining": "{{time}} এ স্লিপ",
      "extend": "+15 মিনিট",
      "cancel": "টাইমার বাতিল করুন",
      "off": "[bn] Off",
      "setTimer": "[bn] Set Sleep Timer"
    },
    "openSubs": {
      "title": "সাবটাইটেল অনুসন্ধান",
      "searchPlaceholder": "শিরোনাম দিয়ে অনুসন্ধান করুন...",
      "search": "অনুসন্ধান",
      "searchFailed": "অনুসন্ধান ব্যর্থ। আবার চেষ্টা করুন।",
      "downloads": "{{count}} ডাউনলোড",
      "noResults": "কোনো সাবটাইটেল পাওয়া যায়নি"
    },
    "dialogue": {
      "cancel": "[bn] Cancel",
      "close": "[bn] Close",
      "placeholder": "[bn] Type your message...",
      "selectCharacter": "[bn] Select Character",
      "send": "[bn] Send",
      "sharedSession": "[bn] Shared Session",
      "waitingForTurn": "[bn] Waiting for your turn...",
      "yourAvatar": "[bn] Your Avatar"
    },
    "interaction": {
      "next": "[bn] Next",
      "previous": "[bn] Previous",
      "skip": "এড়িয়ে যান",
      "start": "মিথস্ক্রিয়া শুরু করুন",
      "window": "মিথস্ক্রিয়া উইন্ডো: {{duration}} সেকেন্ড"
    },
    "pauseAsk": {
      "askAgain": "[bn] Ask Again",
      "placeholder": "[bn] Ask about this scene...",
      "resume": "[bn] Resume",
      "resumeMovie": "[bn] Resume Movie",
      "selectCharacter": "[bn] Select Character",
      "title": "[bn] Pause & Ask"
    },
    "phraseBreakdown": {
      "literal": "আক্ষরিক",
      "meaning": "অর্থ",
      "origin": "উৎপত্তি",
      "funFact": "মজার তথ্য",
      "usage": "ব্যবহার: {{level}}"
    },
    "translation": {
      "example": "উদাহরণ:",
      "arrow": "→"
    },
    "subtitleMode": {
      "title": "সাবটাইটেল মোড",
      "modes": {
        "regular": {
          "name": "সাধারণ",
          "description": "স্বরবর্ণ চিহ্ন ছাড়া প্রমাণ হিব্রু সাবটাইটেল"
        },
        "nikud": {
          "name": "নিকুদ",
          "description": "সহজ পাঠের জন্য স্বরবর্ণ চিহ্নসহ হিব্রু"
        },
        "shoresh": {
          "name": "শোরেশ",
          "description": "শব্দের উৎপত্তি হাইলাইট করে মূল-ভিত্তিক শিক্ষা"
        },
        "engrew": {
          "name": "এংগ্রু",
          "description": "হিব্রু প্রসঙ্গে ইংরেজি লিপ্যন্তর"
        },
        "heblish": {
          "name": "হেব্লিশ",
          "description": "হিব্রু শব্দ ও সাংস্কৃতিক প্রসঙ্গ সহ ইংরেজি"
        },
        "grammarFlip": {
          "name": "ব্যাকরণ উল্টানো",
          "description": "ইংরেজি শব্দ দিয়ে হিব্রু বাক্য গঠন"
        },
        "slangSynthesis": {
          "name": "স্ল্যাং সংশ্লেষণ",
          "description": "সাংস্কৃতিক অপভাষা ও বাগধারা ব্যাখ্যা"
        }
      }
    }
  },
  "empty": {
    "noContent": "[bn] No content available",
    "tryAnotherCategory": "[bn] Try selecting another category",
    "noPodcasts": "[bn] No podcasts available",
    "tryLater": "[bn] Try again later",
    "noResults": "[bn] No results found"
  },
  "content": {
    "play": "চালান",
    "addToList": "তালিকায় যোগ করুন",
    "inList": "তালিকায় আছে",
    "details": "বিবরণ",
    "synopsis": "সারাংশ",
    "genre": "জনরা",
    "genres": "[bn] Genres",
    "runtime": "সময়কাল",
    "released": "[bn] Released",
    "director": "পরিচালক",
    "starring": "[bn] Starring",
    "cast": "কাস্ট",
    "season": "সিজন",
    "seasons": "[bn] Seasons",
    "episode": "পর্ব",
    "episodes": "পর্বসমূহ",
    "ep": "[bn] Ep",
    "selectSeason": "[bn] Select Season",
    "noEpisodes": "[bn] No episodes available",
    "noEpisodesAvailable": "[bn] No episodes available to play",
    "loadingSeries": "[bn] Loading series information...",
    "votes": "[bn] votes",
    "rating": "রেটিং",
    "imdbRating": "[bn] IMDB Rating",
    "preview": "[bn] Preview",
    "previewPlaying": "[bn] Preview playing",
    "trailerPlaying": "[bn] Trailer playing",
    "watchTrailer": "ট্রেলার দেখুন",
    "youMayAlsoLike": "[bn] You May Also Like",
    "relatedContent": "সম্পর্কিত কন্টেন্ট",
    "notFound": "কন্টেন্ট পাওয়া যায়নি",
    "availableSubtitles": "[bn] Available Subtitles",
    "subtitleSelected": "[bn] Selected: {{language}}"
  },
  "breadcrumbs": {
    "series": "[bn] Series",
    "movie": "[bn] Movie",
    "watching": "[bn] Watching",
    "channel": "[bn] Channel",
    "station": "[bn] Station",
    "podcast": "[bn] Podcast",
    "watchlist": "[bn] Watchlist",
    "downloads": "[bn] Downloads"
  },
  "favorites": {
    "title": "প্রিয়",
    "items": "আইটেম",
    "empty": "কোনো প্রিয় নেই",
    "emptyHint": "আপনার প্রিয়তে আইটেম যোগ করুন"
  },
  "downloads": {
    "title": "ডাউনলোড",
    "items": "আইটেম",
    "storage": "[bn] Storage",
    "empty": "কোনো ডাউনলোড নেই",
    "emptyHint": "অফলাইনে দেখার জন্য কন্টেন্ট ডাউনলোড করুন",
    "paused": "[bn] Paused"
  },
  "watchlist": {
    "filters": {
      "all": "সব",
      "continue": "[bn] Continue Watching",
      "movies": "সিনেমা",
      "series": "সিরিজ",
      "kids": "শিশু",
      "judaism": "[bn] Judaism",
      "podcasts": "[bn] Podcasts",
      "radio": "[bn] Radio"
    },
    "title": "ওয়াচলিস্ট",
    "items": "আইটেম",
    "watched": "[bn] watched",
    "empty": "আপনার ওয়াচলিস্ট খালি",
    "emptyHint": "[bn] Start watching and items will appear here"
  },
  "widgets": {
    "empty": "[bn] No widgets yet",
    "emptyHint": "[bn] Your widgets will appear here",
    "emptyPersonal": "[bn] No personal widgets yet",
    "emptyPersonalHint": "[bn] Create your first personal widget or add system widgets above",
    "itemsTotal": "[bn] total widgets",
    "systemWidgets": "[bn] System Widgets",
    "systemWidgetsHint": "[bn] Browse and add widgets to your collection",
    "myWidgets": "[bn] My Personal Widgets",
    "myWidgetsHint": "[bn] Widgets you have created",
    "personalWidgets": "[bn] My Widgets",
    "noSystemWidgets": "[bn] No system widgets available",
    "added": "[bn] Added",
    "add": "[bn] Add",
    "remove": "[bn] Remove",
    "show": "[bn] Show",
    "hidden": "[bn] Hidden",
    "addToCollection": "[bn] Add to My Widgets",
    "removeFromCollection": "[bn] Remove from My Widgets",
    "contentTypes": {
      "liveChannel": "[bn] Live Channel",
      "iframe": "[bn] Web Content",
      "podcast": "[bn] Podcast",
      "radio": "[bn] Radio",
      "vod": "[bn] Video",
      "custom": "[bn] Custom",
      "widget": "[bn] Widget"
    },
    "form": {
      "title": "[bn] Create Widget",
      "basicInfo": "[bn] Basic Information",
      "titlePlaceholder": "[bn] Widget Title",
      "titleRequired": "[bn] Widget Title is required",
      "descriptionPlaceholder": "[bn] Description (optional)",
      "iconPlaceholder": "[bn] Icon emoji (e.g., 📺)",
      "content": "[bn] Content",
      "fromLibrary": "[bn] From Library",
      "iframe": "[bn] iFrame",
      "selectContent": "[bn] Select Content (Channels, Podcasts, Shows, etc.)",
      "iframeUrl": "[bn] iFrame URL",
      "iframeUrlRequired": "[bn] iFrame URL is required",
      "iframeTitle": "[bn] iFrame Title",
      "positionSize": "[bn] Position & Size",
      "behavior": "[bn] Behavior",
      "mutedByDefault": "[bn] Muted by Default",
      "closable": "[bn] Closable",
      "draggable": "[bn] Draggable",
      "widgetOrder": "[bn] Widget Order",
      "orderPlaceholder": "[bn] Order (0 = first)",
      "saveWidget": "[bn] Save Widget",
      "saving": "[bn] Saving...",
      "cancel": "[bn] Cancel",
      "change": "[bn] Change"
    }
  },
  "trending": {
    "title": "[bn] What's Trending in Israel",
    "noTopics": "[bn] No trending topics available",
    "topStory": "[bn] TOP STORY",
    "sources": "[bn] Sources",
    "categories": {
      "security": "[bn] Security",
      "politics": "[bn] Politics",
      "tech": "[bn] Tech",
      "culture": "[bn] Culture",
      "sports": "[bn] Sports",
      "economy": "[bn] Economy",
      "entertainment": "[bn] Entertainment",
      "weather": "[bn] Weather",
      "health": "[bn] Health",
      "general": "[bn] General"
    }
  },
  "cultures": {
    "title": "[bn] Select Your Culture",
    "select": "[bn] Select Culture",
    "selectCulture": "[bn] Choose Your Culture",
    "selectCultureDescription": "[bn] Select your cultural community to personalize your experience",
    "changeCulture": "[bn] Change Culture",
    "israeli": {
      "name": "[bn] Israeli",
      "description": "[bn] Israeli expat community content"
    },
    "chinese": {
      "name": "[bn] Chinese",
      "description": "[bn] Chinese community content"
    },
    "japanese": {
      "name": "[bn] Japanese",
      "description": "[bn] Japanese community content"
    },
    "korean": {
      "name": "[bn] Korean",
      "description": "[bn] Korean community content"
    },
    "indian": {
      "name": "[bn] Indian",
      "description": "[bn] Indian community content"
    }
  },
  "cultureTrending": {
    "whatsHotIn": "[bn] What's Hot in {{location}}",
    "noTopics": "[bn] No trending topics available",
    "sources": "[bn] Sources",
    "categories": {
      "security": "[bn] Security",
      "politics": "[bn] Politics",
      "tech": "[bn] Tech",
      "technology": "[bn] Technology",
      "culture": "[bn] Culture",
      "sports": "[bn] Sports",
      "economy": "[bn] Economy",
      "finance": "[bn] Finance",
      "entertainment": "[bn] Entertainment",
      "weather": "[bn] Weather",
      "health": "[bn] Health",
      "food": "[bn] Food",
      "fashion": "[bn] Fashion",
      "travel": "[bn] Travel",
      "history": "[bn] History",
      "expat": "[bn] Expat Life",
      "general": "[bn] General"
    }
  },
  "cultureClock": {
    "timeIn": "{{location}} সময়",
    "shabbat": "শাব্বাত",
    "weekend": "সপ্তাহান্ত"
  },
  "cultureCities": {
    "connectionTo": "[bn] {{city}} Connection",
    "explore": "[bn] Explore {{city}}",
    "noContent": "[bn] No content available for this city",
    "categories": {
      "all": "[bn] All",
      "history": "[bn] History",
      "culture": "[bn] Culture",
      "finance": "[bn] Finance",
      "tech": "[bn] Tech",
      "food": "[bn] Food",
      "expat": "[bn] Expat Life",
      "news": "[bn] News",
      "entertainment": "[bn] Entertainment"
    }
  },
  "clock": {
    "israel": "[bn] Israel",
    "local": "[bn] Local",
    "shabbatShalom": "[bn] Shabbat Shalom!",
    "erevShabbat": "[bn] Erev Shabbat",
    "candleLighting": "[bn] Candle Lighting",
    "parasha": "[bn] Parasha"
  },
  "ritual": {
    "title": "[bn] Morning Ritual",
    "greeting": "[bn] Good Morning!",
    "israelUpdate": "[bn] It's afternoon in Israel, news is reporting on ongoing developments",
    "recommendation": "[bn] We recommend starting with morning news then switching to radio",
    "preparingRitual": "[bn] Preparing your morning ritual...",
    "israelTime": "[bn] Israel Time",
    "day": "[bn] Day",
    "letsStart": "[bn] Let's Start",
    "skipToday": "[bn] Skip for Today",
    "finish": "[bn] Finish",
    "noContentNow": "[bn] No content available right now",
    "typeLive": "[bn] Live",
    "typeRadio": "[bn] Radio",
    "typeVideo": "[bn] Video"
  },
  "watchParty": {
    "title": "[bn] Watch Party",
    "create": "[bn] Create Party",
    "join": "[bn] Join Party",
    "active": "[bn] Party Active",
    "createTitle": "[bn] Create Watch Party",
    "joinTitle": "[bn] Join Party",
    "enterCode": "[bn] Enter Room Code",
    "roomCode": "[bn] Room Code",
    "copyCode": "[bn] Copy Code",
    "codeCopied": "[bn] Code Copied!",
    "participants": "[bn] Participants",
    "host": "[bn] Host",
    "you": "[bn] You",
    "leave": "[bn] Leave Party",
    "end": "[bn] End Party",
    "chat": "[bn] Chat",
    "sendMessage": "[bn] Send Message",
    "typeMessage": "[bn] Type a message...",
    "synced": "[bn] Synced",
    "syncing": "[bn] Syncing...",
    "hostPaused": "[bn] Host Paused",
    "userJoined": "[bn] {{name}} joined",
    "userLeft": "[bn] {{name}} left",
    "partyEnded": "[bn] The party has ended",
    "connecting": "[bn] Connecting...",
    "options": {
      "chatEnabled": "[bn] Enable Chat",
      "syncPlayback": "[bn] Sync Playback"
    },
    "errors": {
      "invalidCode": "[bn] Invalid code",
      "partyFull": "[bn] Party is full",
      "partyEnded": "[bn] Party has ended",
      "connectionError": "[bn] Connection error",
      "createFailed": "[bn] Failed to create party",
      "joinFailed": "[bn] Failed to join party"
    },
    "audio": {
      "mute": "[bn] Mute",
      "unmute": "[bn] Unmute",
      "speaking": "[bn] Speaking",
      "connecting": "[bn] Connecting to audio...",
      "noAudio": "[bn] Audio not available"
    },
    "textOnlyMode": "[bn] Text Chat Only",
    "endParty": "[bn] End Party"
  },
  "footer": {
    "brandDescription": "USA-তে আপনার বাড়ি। হিব্রুতে TV সম্প্রচার, VOD, রেডিও এবং পডকাস্ট।",
    "browse": "ব্রাউজ করুন",
    "account": "অ্যাকাউন্ট",
    "support": "সাপোর্ট",
    "legal": "আইনি",
    "location": "[bn] New York, USA",
    "links": {
      "home": "[bn] Home",
      "liveTV": "[bn] Live TV",
      "vod": "[bn] Movies & Series",
      "radio": "[bn] Radio",
      "podcasts": "[bn] Podcasts",
      "judaism": "[bn] Judaism",
      "profile": "[bn] My Profile",
      "favorites": "[bn] Favorites",
      "watchlist": "[bn] Watchlist",
      "subscribe": "[bn] Subscribe",
      "downloads": "[bn] Downloads",
      "help": "[bn] Help Center",
      "faq": "[bn] FAQ",
      "contact": "[bn] Contact Us",
      "feedback": "[bn] Feedback",
      "terms": "[bn] Terms of Service",
      "privacy": "[bn] Privacy Policy",
      "cookies": "[bn] Cookie Policy",
      "licenses": "[bn] Licenses"
    },
    "newsletter": {
      "title": "[bn] Stay Updated",
      "description": "[bn] Subscribe to our newsletter for the latest updates and exclusive content.",
      "placeholder": "[bn] Enter your email",
      "success": "[bn] Thanks for subscribing!"
    },
    "apps": {
      "title": "[bn] Get the App",
      "downloadOn": "[bn] Download on",
      "getItOn": "[bn] Get it on",
      "appStore": "[bn] App Store",
      "googlePlay": "[bn] Google Play"
    },
    "social": {
      "facebook": "[bn] Facebook",
      "twitter": "[bn] Twitter",
      "instagram": "[bn] Instagram",
      "youtube": "[bn] YouTube"
    },
    "copyright": "© {{year}} Bayit+. সর্বস্বত্ব সংরক্ষিত।",
    "poweredBy": "দ্বারা চালিত",
    "sitemap": "[bn] Sitemap",
    "accessibility": "[bn] Accessibility",
    "navigation": "[bn] Navigation",
    "liveTV": "[bn] Live TV",
    "moviesAndSeries": "[bn] Movies & Series",
    "radioStations": "[bn] Radio Stations",
    "myProfile": "[bn] My Profile",
    "subscriptions": "[bn] Subscriptions",
    "helpAndSupport": "[bn] Help & Support",
    "termsOfUse": "[bn] Terms of Use",
    "privacyPolicy": "[bn] Privacy Policy",
    "contactUs": "[bn] Contact Us"
  },
  "chapters": {
    "title": "[bn] Chapters",
    "noChapters": "[bn] No chapters available",
    "generating": "[bn] Generating chapters...",
    "jumpTo": "[bn] Jump to",
    "current": "[bn] Now",
    "categories": {
      "intro": "[bn] Introduction",
      "news": "[bn] News",
      "security": "[bn] Security",
      "politics": "[bn] Politics",
      "economy": "[bn] Economy",
      "sports": "[bn] Sports",
      "weather": "[bn] Weather",
      "culture": "[bn] Culture",
      "conclusion": "[bn] Conclusion"
    },
    "chapterLabel": "অধ্যায় {{number}}",
    "chapter_number": "অধ্যায় {{number}}"
  },
  "admin": {
    "brand": {
      "title": "Bayit+ অ্যাডমিন",
      "subtitle": "সিস্টেম ম্যানেজমেন্ট"
    },
    "backToApp": "অ্যাপে ফিরে যান",
    "refunds": {
      "subtitle": "রিফান্ড অনুরোধ পরিচালনা করুন",
      "approveModal": {
        "title": "অনুমোদন নিশ্চিত করুন",
        "message": "{{amount}} রিফান্ড অনুমোদন করবেন?"
      },
      "confirmApprove": "{{amount}} রিফান্ড অনুমোদন করবেন?",
      "confirmDelete": "রিফান্ড অনুরোধ মুছে ফেলবেন?",
      "rejectModal": {
        "title": "রিফান্ড অনুরোধ প্রত্যাখ্যান করুন",
        "message": "{{amount}} রিফান্ড প্রত্যাখ্যান করা হচ্ছে",
        "reasonLabel": "প্রত্যাখ্যানের কারণ",
        "reasonPlaceholder": "অনুগ্রহ করে প্রত্যাখ্যানের কারণ লিখুন...",
        "submitButton": "অনুরোধ প্রত্যাখ্যান করুন"
      },
      "status": {
        "pending": "মুলতুবি",
        "approved": "অনুমোদিত",
        "rejected": "প্রত্যাখ্যাত"
      },
      "columns": {
        "id": "ID",
        "user": "ব্যবহারকারী",
        "amount": "পরিমাণ",
        "reason": "কারণ",
        "status": "স্ট্যাটাস",
        "requestDate": "অনুরোধের তারিখ"
      },
      "stats": {
        "pendingTitle": "[bn] Pending Approval",
        "approvedTitle": "[bn] Approved",
        "rejectedTitle": "[bn] Rejected",
        "totalRefunded": "[bn] Total Refunded"
      },
      "emptyMessage": "[bn] No refund requests found",
      "errors": {
        "rejectReasonRequired": "[bn] Please enter rejection reason"
      },
      "title": "[bn] Refunds"
    },
    "plans": {
      "title": "প্ল্যান ম্যানেজমেন্ট",
      "subtitle": "সাবস্ক্রিপশন প্ল্যান কনফিগার এবং পরিচালনা করুন",
      "createButton": "নতুন প্ল্যান",
      "inactive": "নিষ্ক্রিয়",
      "subscribersLabel": "সাবস্ক্রাইবার:",
      "intervals": {
        "monthly": "মাস",
        "yearly": "বছর"
      },
      "trialDays": "{{days}} দিনের ট্রায়াল",
      "modal": {
        "editTitle": "প্ল্যান সম্পাদনা করুন",
        "createTitle": "নতুন প্ল্যান"
      },
      "form": {
        "nameEn": "নাম (ইংরেজি)",
        "nameHe": "নাম (হিব্রু)",
        "price": "মূল্য ($)",
        "interval": "বিলিং সময়কাল",
        "trialDays": "ট্রায়াল দিন",
        "features": "বৈশিষ্ট্য (প্রতি লাইনে একটি)",
        "active": "সক্রিয় প্ল্যান"
      },
      "errors": {
        "requiredFields": "নাম এবং মূল্য প্রয়োজন"
      },
      "confirmDelete": "\"{{name}}\" প্ল্যান মুছে ফেলবেন?"
    },
    "emailCampaigns": {
      "subtitle": "ইমেইল ক্যাম্পেইন তৈরি এবং পরিচালনা করুন",
      "createButton": "নতুন ক্যাম্পেইন",
      "searchPlaceholder": "ক্যাম্পেইন খুঁজুন...",
      "emptyMessage": "কোনো ক্যাম্পেইন পাওয়া যায়নি",
      "status": {
        "draft": "খসড়া",
        "active": "সক্রিয়",
        "scheduled": "নির্ধারিত",
        "completed": "সম্পন্ন"
      },
      "columns": {
        "name": "ক্যাম্পেইন নাম",
        "status": "স্ট্যাটাস",
        "sent": "পাঠানো হয়েছে",
        "opened": "খোলা হয়েছে",
        "clicked": "ক্লিক করা হয়েছে",
        "created": "তৈরি করা হয়েছে",
        "actions": "কার্যক্রম"
      },
      "editModal": {
        "title": "ক্যাম্পেইন সম্পাদনা করুন"
      },
      "sendTestEmail": "টেস্ট পাঠান",
      "confirmSend": "\"{{name}}\" ক্যাম্পেইন পাঠাবেন?",
      "confirmDelete": "\"{{name}}\" ক্যাম্পেইন মুছে ফেলবেন?",
      "testEmailSent": "টেস্ট ইমেইল পাঠানো হয়েছে!",
      "createModal": {
        "title": "নতুন ইমেইল ক্যাম্পেইন"
      },
      "form": {
        "name": "ক্যাম্পেইন নাম",
        "namePlaceholder": "যেমন, বছরের শেষ সেল",
        "subject": "ইমেইল বিষয়",
        "subjectPlaceholder": "প্রাপকদের কাছে দেখানো বিষয়",
        "body": "কন্টেন্ট",
        "bodyPlaceholder": "ইমেইল কন্টেন্ট...",
        "submitButton": "ক্যাম্পেইন তৈরি করুন",
        "requiredFields": "নাম এবং বিষয় প্রয়োজন"
      },
      "testModal": {
        "title": "টেস্ট ইমেইল পাঠান",
        "emailLabel": "ইমেইল ঠিকানা",
        "emailPlaceholder": "test@example.com",
        "submitButton": "টেস্ট পাঠান"
      },
      "errors": {
        "requiredFields": "নাম এবং বিষয় প্রয়োজন"
      }
    },
    "dashboard": {
      "subtitle": "সিস্টেম ওভারভিউ",
      "refresh": "রিফ্রেশ",
      "timeAgo": {
        "minutes": "[bn] {{count}} minutes ago",
        "hours": "[bn] {{count}} hours ago"
      },
      "title": "ড্যাশবোর্ড",
      "users": "ব্যবহারকারী",
      "revenue": "রাজস্ব",
      "subscriptions": "সাবস্ক্রিপশন",
      "recentActivity": "[bn] Recent Activity",
      "quickActions": "[bn] Quick Actions"
    },
    "common": {
      "all": "সব",
      "cancel": "বাতিল",
      "save": "সংরক্ষণ করুন",
      "active": "সক্রিয়",
      "back": "পিছনে",
      "filterAction": "অ্যাকশন",
      "filterResource": "রিসোর্স",
      "filterUser": "ব্যবহারকারী",
      "filterDateRange": "তারিখ পরিসীমা"
    },
    "stats": {
      "totalUsers": "মোট ব্যবহারকারী",
      "activeUsers": "সক্রিয় ব্যবহারকারী",
      "newToday": "আজ নতুন",
      "newThisWeek": "এই সপ্তাহে নতুন",
      "totalRevenue": "মোট রাজস্ব",
      "revenueToday": "আজকের রাজস্ব",
      "revenueMonth": "এই মাসের রাজস্ব",
      "arpu": "প্রতি ব্যবহারকারী গড় আয়",
      "activeSubscriptions": "সক্রিয় সাবস্ক্রিপশন",
      "churnRate": "চার্ন রেট"
    },
    "actions": {
      "new": "নতুন",
      "addUser": "ব্যবহারকারী যোগ করুন",
      "newCampaign": "নতুন ক্যাম্পেইন",
      "sendEmail": "ইমেইল পাঠান",
      "viewReports": "রিপোর্ট দেখুন"
    },
    "auditActions": {
      "user_created": "ব্যবহারকারী তৈরি হয়েছে",
      "user_updated": "ব্যবহারকারী আপডেট হয়েছে",
      "user_deleted": "ব্যবহারকারী মুছে ফেলা হয়েছে",
      "user_role_changed": "ব্যবহারকারী ভূমিকা পরিবর্তন হয়েছে",
      "campaign_created": "ক্যাম্পেইন তৈরি হয়েছে",
      "campaign_updated": "ক্যাম্পেইন আপডেট হয়েছে",
      "campaign_deleted": "ক্যাম্পেইন মুছে ফেলা হয়েছে",
      "campaign_activated": "ক্যাম্পেইন সক্রিয় হয়েছে",
      "subscription_created": "সাবস্ক্রিপশন তৈরি হয়েছে",
      "subscription_updated": "সাবস্ক্রিপশন আপডেট হয়েছে",
      "subscription_canceled": "সাবস্ক্রিপশন বাতিল হয়েছে",
      "subscription_deleted": "সাবস্ক্রিপশন মুছে ফেলা হয়েছে",
      "refund_processed": "রিফান্ড প্রক্রিয়াকৃত",
      "payment_received": "পেমেন্ট গৃহীত",
      "settings_updated": "সেটিংস আপডেট হয়েছে",
      "login": "লগইন",
      "logout": "লগআউট",
      "content_created": "কন্টেন্ট তৈরি হয়েছে",
      "content_updated": "কন্টেন্ট আপডেট হয়েছে",
      "content_deleted": "কন্টেন্ট মুছে ফেলা হয়েছে",
      "content_published": "কন্টেন্ট প্রকাশিত",
      "content_unpublished": "কন্টেন্ট অপ্রকাশিত",
      "category_created": "বিভাগ তৈরি হয়েছে",
      "category_updated": "বিভাগ আপডেট হয়েছে",
      "category_deleted": "বিভাগ মুছে ফেলা হয়েছে",
      "live_channel_created": "লাইভ চ্যানেল তৈরি হয়েছে",
      "live_channel_updated": "লাইভ চ্যানেল আপডেট হয়েছে",
      "live_channel_deleted": "লাইভ চ্যানেল মুছে ফেলা হয়েছে",
      "radio_station_created": "রেডিও স্টেশন তৈরি হয়েছে",
      "radio_station_updated": "রেডিও স্টেশন আপডেট হয়েছে",
      "radio_station_deleted": "রেডিও স্টেশন মুছে ফেলা হয়েছে",
      "podcast_created": "পডকাস্ট তৈরি হয়েছে",
      "podcast_updated": "পডকাস্ট আপডেট হয়েছে",
      "podcast_deleted": "পডকাস্ট মুছে ফেলা হয়েছে",
      "podcast_episode_created": "পডকাস্ট পর্ব তৈরি হয়েছে",
      "podcast_episode_updated": "পডকাস্ট পর্ব আপডেট হয়েছে",
      "podcast_episode_deleted": "পডকাস্ট পর্ব মুছে ফেলা হয়েছে",
      "content_imported": "কন্টেন্ট আমদানি হয়েছে",
      "widget_created": "উইজেট তৈরি হয়েছে",
      "widget_updated": "উইজেট আপডেট হয়েছে",
      "widget_deleted": "উইজেট মুছে ফেলা হয়েছে",
      "widget_published": "উইজেট প্রকাশিত",
      "widget_unpublished": "উইজেট অপ্রকাশিত"
    },
    "placeholder": {
      "userId": "ব্যবহারকারী ID লিখুন",
      "discount": "0"
    },
    "titles": {
      "users": "ব্যবহারকারী",
      "transactions": "লেনদেন",
      "subscriptions": "সাবস্ক্রিপশন",
      "refunds": "রিফান্ড",
      "plans": "প্ল্যান",
      "campaigns": "ক্যাম্পেইন",
      "auditLogs": "অডিট লগ",
      "pushNotifications": "পুশ বিজ্ঞপ্তি",
      "billing": "বিলিং",
      "marketing": "মার্কেটিং",
      "content": "কন্টেন্ট লাইব্রেরি",
      "categories": "বিভাগ",
      "liveChannels": "লাইভ চ্যানেল",
      "radioStations": "রেডিও স্টেশন",
      "podcasts": "পডকাস্ট",
      "settings": "সেটিংস"
    },
    "nav": {
      "dashboard": "ড্যাশবোর্ড",
      "users": "ব্যবহারকারী",
      "campaigns": "ক্যাম্পেইন",
      "billing": "বিলিং",
      "billingOverview": "ওভারভিউ",
      "transactions": "লেনদেন",
      "refunds": "রিফান্ড",
      "subscriptions": "সাবস্ক্রিপশন",
      "subscriptionsList": "সাবস্ক্রাইবার",
      "plans": "প্ল্যান",
      "marketing": "মার্কেটিং",
      "marketingDashboard": "ওভারভিউ",
      "emailCampaigns": "ইমেইল ক্যাম্পেইন",
      "pushNotifications": "পুশ বিজ্ঞপ্তি",
      "content": "কন্টেন্ট",
      "contentLibrary": "কন্টেন্ট লাইব্রেরি",
      "categories": "বিভাগ",
      "liveChannels": "লাইভ চ্যানেল",
      "radioStations": "রেডিও স্টেশন",
      "podcasts": "পডকাস্ট",
      "widgets": "উইজেট",
      "recordings": "রেকর্ডিং",
      "uploads": "আপলোড",
      "settings": "সেটিংস",
      "auditLogs": "অডিট লগ",
      "librarian": "লাইব্রেরিয়ান এজেন্ট",
      "featured": "ফিচার্ড"
    },
    "featured": {
      "title": "ফিচার্ড কন্টেন্ট",
      "subtitle": "হোমপেজ ক্যারোসেলের জন্য ফিচার্ড কন্টেন্ট পরিচালনা করুন",
      "empty": "কোনো ফিচার্ড কন্টেন্ট নেই",
      "emptyHint": "ফিচার্ড আইটেম হোমপেজে তাদের নিজ নিজ ক্যারোসেলে প্রদর্শিত হবে",
      "count": "{{count}} আইটেম",
      "confirmUnfeature": "ফিচার্ড থেকে সরাবেন?",
      "remove": "সরান",
      "unsavedChanges": "আপনার অসংরক্ষিত পরিবর্তন আছে",
      "section": {
        "title": "{{name}}",
        "itemCount": "{{count}} আইটেম",
        "itemCount_plural": "{{count}} আইটেম",
        "empty": "কোনো ফিচার্ড আইটেম নেই",
        "emptyHint": "ফিচার্ড আইটেম হোমপেজে {{name}} ক্যারোসেলে প্রদর্শিত হবে"
      },
      "saveButton": "{{count}} সেকশন সংরক্ষণ করুন",
      "saveButton_plural": "{{count}} সেকশন সংরক্ষণ করুন",
      "saving": "সংরক্ষণ হচ্ছে...",
      "saveSuccess": "ফিচার্ড কন্টেন্ট সফলভাবে আপডেট হয়েছে",
      "saveFailed": "ফিচার্ড কন্টেন্ট সংরক্ষণ করতে ব্যর্থ",
      "removeConfirm": "{{section}} থেকে সরাবেন?",
      "removeSuccess": "{{section}} থেকে সরানো হয়েছে"
    },
    "recordings": {
      "title": "রেকর্ডিং ম্যানেজমেন্ট",
      "subtitle": "প্ল্যাটফর্ম জুড়ে ব্যবহারকারী রেকর্ডিং পরিচালনা করুন",
      "totalRecordings": "মোট রেকর্ডিং",
      "totalStorage": "মোট স্টোরেজ",
      "totalUsers": "রেকর্ডিং সহ ব্যবহারকারী",
      "activeSessions": "সক্রিয় সেশন",
      "searchPlaceholder": "শিরোনাম, ব্যবহারকারী বা চ্যানেল দ্বারা খুঁজুন...",
      "user": "ব্যবহারকারী",
      "confirmDelete": "'{{title}}' রেকর্ডিং মুছে ফেলবেন? এই কাজ পূর্বাবস্থায় ফেরানো যাবে না।",
      "deleteRecording": "রেকর্ডিং মুছুন",
      "deleteSuccess": "রেকর্ডিং সফলভাবে মুছে ফেলা হয়েছে",
      "deleteFailed": "রেকর্ডিং মুছতে ব্যর্থ",
      "loadFailed": "রেকর্ডিং লোড করতে ব্যর্থ",
      "noRecordings": "কোনো রেকর্ডিং পাওয়া যায়নি",
      "noRecordingsHint": "সিস্টেমে এখনও কোনো ব্যবহারকারী রেকর্ডিং নেই।"
    },
    "uploads": {
      "title": "আপলোড ম্যানেজমেন্ট",
      "subtitle": "কন্টেন্ট আপলোড এবং স্বয়ংক্রিয় ফোল্ডার মনিটরিং পরিচালনা করুন",
      "activeUploads": "সক্রিয় আপলোড",
      "noActiveUploads": "কোনো সক্রিয় আপলোড নেই",
      "queuedUploads": "সারিবদ্ধ আপলোড",
      "queued": "সারিবদ্ধ",
      "andMore": "এবং আরো {{count}}টি",
      "monitoredFolders": "মনিটরড ফোল্ডার",
      "noMonitoredFolders": "কোনো মনিটরড ফোল্ডার কনফিগার করা নেই",
      "configureFoldersHelp": "স্বয়ংক্রিয় আপলোডের জন্য মনিটরড ফোল্ডার কনফিগার করতে 'ফোল্ডার যোগ করুন' ক্লিক করুন",
      "addFolder": "ফোল্ডার যোগ করুন",
      "editFolder": "ফোল্ডার সম্পাদনা করুন",
      "deleteFolder": "ফোল্ডার মুছুন",
      "confirmDelete": "এই ফোল্ডার মুছে ফেলবেন?",
      "triggerUpload": "আপলোড ট্রিগার করুন",
      "triggerUploadSuccess": "আপলোডের জন্য {{files_found}}টি নতুন ফাইল পাওয়া গেছে",
      "triggerUploadFailed": "আপলোড স্ক্যান ট্রিগার করতে ব্যর্থ",
      "noFilesFound": "মনিটরড ফোল্ডারে কোনো নতুন ফাইল পাওয়া যায়নি",
      "sessionIssue": "সেশন সমস্যা",
      "sessionIssueHelp": "আপনার সেশন মেয়াদ শেষ হয়ে থাকতে পারে। সংযোগ পুনরুদ্ধার করতে পৃষ্ঠা রিফ্রেশ করুন।",
      "sessionExpired": "সেশন মেয়াদ শেষ। অনুগ্রহ করে পৃষ্ঠা রিফ্রেশ করুন বা আবার লগ ইন করুন।",
      "unauthorized": "সেশন অবৈধ। অনুগ্রহ করে পৃষ্ঠা রিফ্রেশ করুন।",
      "endpointNotFound": "আপলোড সার্ভিস উপলব্ধ নেই। সার্ভার কনফিগারেশন পরীক্ষা করুন।",
      "timeout": "আপলোড স্ক্যান টাইমআউট হয়েছে। আবার চেষ্টা করুন বা মনিটরড ফোল্ডার পরীক্ষা করুন।",
      "wsDisconnected": "রিয়েল-টাইম আপডেট অক্ষম",
      "wsDisconnectedHelp": "WebSocket সংযোগ ব্যর্থ। সারির স্ট্যাটাস পুরানো হতে পারে। পৃষ্ঠা স্বয়ংক্রিয়-পুনঃচেষ্টা করবে।",
      "wsReconnecting": "রিয়েল-টাইম আপডেটে পুনঃসংযোগ হচ্ছে...",
      "uploadAlreadyRunning": "আপলোড স্ক্যান ইতিমধ্যে চলছে। বর্তমান আপলোড সম্পূর্ণ হওয়ার জন্য অপেক্ষা করুন।",
      "uploadsActiveNotice": "আপলোড চলছে ({{processing}} সক্রিয়, {{queued}} সারিবদ্ধ)। বর্তমান ব্যাচ সম্পূর্ণ না হওয়া পর্যন্ত নতুন স্ক্যান অক্ষম।",
      "clearQueue": "সারি সাফ করুন",
      "clearQueueConfirmTitle": "আপলোড সারি সাফ করবেন?",
      "clearQueueConfirmMessage": "এটি {{count}}টি সক্রিয় কাজ বাতিল করবে। এই কাজ পূর্বাবস্থায় ফেরানো যাবে না।",
      "clearQueueSuccess": "সারি সফলভাবে সাফ করা হয়েছে",
      "clearQueueFailed": "সারি সাফ করতে ব্যর্থ",
      "cancelUpload": "বাতিল",
      "cancelUploadConfirm": "এই আপলোড বাতিল করবেন?",
      "cancelUploadSuccess": "আপলোড বাতিল হয়েছে",
      "cancelUploadFailed": "আপলোড বাতিল করতে ব্যর্থ",
      "resetCache": "ক্যাশ রিসেট করুন",
      "cacheResetSuccess": "ক্যাশ সাফ হয়েছে: {{count}} ফাইল পরবর্তী স্ক্যানে পুনরায় স্ক্যান হবে",
      "cacheResetFailed": "ক্যাশ রিসেট করতে ব্যর্থ",
      "contentTypeFilters": "কন্টেন্ট টাইপ ফিল্টার",
      "contentTypeFiltersHelp": "ঐচ্ছিক - সব কন্টেন্ট টাইপ প্রক্রিয়া করতে সব আনচেক রাখুন",
      "moviesOnly": "শুধুমাত্র সিনেমা",
      "seriesOnly": "শুধুমাত্র সিরিজ",
      "audiobooksOnly": "শুধুমাত্র অডিওবুক",
      "type": "টাইপ",
      "lastScan": "শেষ স্ক্যান",
      "systemInfo": "আপলোড সিস্টেম তথ্য",
      "systemInfoText": "দ্রুত প্রক্রিয়াকরণের জন্য আপলোডের সময় স্থানীয় ভিডিও ফাইল থেকে স্বয়ংক্রিয়ভাবে সাবটাইটেল এক্সট্র্যাক্ট করে",
      "languagesInfo": "সমর্থিত সাবটাইটেল ভাষা: ইংরেজি (en), হিব্রু (he), স্প্যানিশ (es)",
      "queueStatus": "আপলোড সারি",
      "totalJobs": "মোট",
      "processing": "সক্রিয়",
      "completed": "সম্পন্ন",
      "skipped": "এড়িয়ে গেছে",
      "failed": "ব্যর্থ",
      "queuePaused": "সারি বিরতিতে আছে",
      "resumeQueue": "পুনরায় শুরু করুন",
      "activeUpload": "সক্রিয় আপলোড",
      "queuedItems": "সারিবদ্ধ",
      "noQueuedItems": "সারিতে কোনো আইটেম নেই",
      "addedAt": "যোগ করা হয়েছে",
      "recentCompleted": "সম্প্রতি সম্পন্ন",
      "stages": {
        "browserUpload": "সার্ভারে আপলোড হচ্ছে",
        "hashCalculation": "হ্যাশ গণনা হচ্ছে",
        "duplicateCheck": "ডুপ্লিকেট পরীক্ষা হচ্ছে",
        "metadataExtraction": "মেটাডেটা এক্সট্র্যাক্ট হচ্ছে",
        "gcsUpload": "ক্লাউডে আপলোড হচ্ছে",
        "databaseInsert": "ডাটাবেসে সংরক্ষণ হচ্ছে",
        "imdbLookup": "IMDB তথ্য আনা হচ্ছে",
        "subtitleExtraction": "সাবটাইটেল এক্সট্র্যাক্ট হচ্ছে",
        "completed": "সম্পন্ন",
        "failed": "ব্যর্থ",
        "skipped": "এড়িয়ে গেছে"
      },
      "form": {
        "name": "ফোল্ডার নাম",
        "namePlaceholder": "আমার মুভি ফোল্ডার",
        "path": "ফোল্ডার পাথ",
        "pathHelp": "ফোল্ডারে সার্ভার পাথ লিখুন (যেমন, /Volumes/USB Drive/Movies)",
        "contentType": "কন্টেন্ট টাইপ",
        "enabled": "সক্রিয়",
        "autoUpload": "স্বয়ংক্রিয় আপলোড"
      },
      "contentTypes": {
        "movie": "সিনেমা",
        "series": "সিরিজ",
        "audiobook": "অডিওবুক"
      },
      "errors": {
        "pathRequired": "ফোল্ডার পাথ প্রয়োজন"
      },
      "manualUpload": {
        "title": "ম্যানুয়াল আপলোড",
        "subtitle": "ফাইল টেনে আনুন বা একটি ফোল্ডার নির্বাচন করুন",
        "dropHere": "এখানে ফাইল ড্রপ করুন বা ব্রাউজ করতে ক্লিক করুন",
        "dropHereActive": "ফাইল যোগ করতে ড্রপ করুন",
        "selectFolder": "ফোল্ডার নির্বাচন করুন",
        "supportedFormats": "সমর্থিত ভিডিও ফাইল (mp4, mkv, avi, mov, webm)",
        "selectedFiles": "নির্বাচিত ফাইল",
        "noFilesSelected": "কোনো ফাইল নির্বাচন করা হয়নি",
        "clearAll": "সব সাফ করুন",
        "uploadSelected": "নির্বাচিত আপলোড করুন",
        "selectContentType": "আপলোডের জন্য কন্টেন্ট টাইপ নির্বাচন করুন",
        "uploadingFiles": "{{count}}টি ফাইল সারিতে যোগ করা হচ্ছে...",
        "uploadSuccess": "সফলভাবে {{count}}টি ফাইল সারিতে যোগ করা হয়েছে",
        "uploadFailed": "সারিতে ফাইল যোগ করতে ব্যর্থ",
        "fileSize": "আকার",
        "removeFile": "সরান",
        "invalidFileType": "অবৈধ ফাইল টাইপ। শুধুমাত্র ভিডিও ফাইল সমর্থিত।",
        "filesCount": "{{count}}টি ফাইল নির্বাচিত",
        "pendingRestore": "পূর্ববর্তী সেশন থেকে {{count}}টি ফাইল মুলতুবি",
        "pendingRestoreHint": "আপনার আপলোড সারি পুনরুদ্ধার করতে একই ফাইল ড্রপ বা নির্বাচন করুন"
      }
    },
    "librarian": {
      "title": "লাইব্রেরিয়ান এজেন্ট",
      "subtitle": "স্বায়ত্তশাসিত AI-চালিত কন্টেন্ট লাইব্রেরি ম্যানেজমেন্ট",
      "loading": "লাইব্রেরিয়ান এজেন্ট লোড হচ্ছে...",
      "loadingConfig": "কনফিগারেশন লোড হচ্ছে...",
      "refresh": "রিফ্রেশ",
      "errors": {
        "configError": "কনফিগারেশন ত্রুটি",
        "configNotLoaded": "কনফিগারেশন লোড হয়নি",
        "failedToLoad": "লাইব্রেরিয়ান ডেটা লোড করতে ব্যর্থ",
        "failedToLoadConfig": "লাইব্রেরিয়ান কনফিগারেশন লোড করতে ব্যর্থ",
        "failedToTrigger": "অডিট ট্রিগার করতে ব্যর্থ। অনুগ্রহ করে আবার চেষ্টা করুন।",
        "failedToLoadDetails": "রিপোর্ট বিবরণ লোড করতে ব্যর্থ।",
        "failedToRollback": "অ্যাকশন রোলব্যাক করতে ব্যর্থ।",
        "failedToClearReports": "অডিট রিপোর্ট সাফ করতে ব্যর্থ। অনুগ্রহ করে আবার চেষ্টা করুন।",
        "failedToPause": "অডিট পজ করতে ব্যর্থ",
        "failedToResume": "অডিট পুনরায় শুরু করতে ব্যর্থ",
        "failedToCancel": "অডিট বাতিল করতে ব্যর্থ",
        "failedToInterject": "AI এজেন্টে বার্তা পাঠাতে ব্যর্থ",
        "auditAlreadyRunning": "একটি অডিট ইতিমধ্যে চলছে। নতুন শুরু করার আগে এটি সম্পূর্ণ হওয়া বা বাতিল করার জন্য অপেক্ষা করুন।",
        "budgetExceeded": "মাসিক বাজেট সীমা অতিক্রম করেছে। অডিট চালানো যাচ্ছে না।",
        "contactAdmin": "সঠিক কনফিগারেশন ছাড়া লাইব্রেরিয়ান পৃষ্ঠা লোড করা যাচ্ছে না।\nঅনুগ্রহ করে আপনার অ্যাডমিনিস্ট্রেটরের সাথে যোগাযোগ করুন।"
      },
      "stats": {
        "systemHealth": "সিস্টেম স্বাস্থ্য",
        "totalAudits": "মোট অডিট (৩০দ)",
        "last30Days": "গত ৩০ দিন",
        "issuesFixed": "সমস্যা সমাধান",
        "lastAudit": "শেষ অডিট",
        "never": "কখনো না",
        "unknown": "অজানা"
      },
      "health": {
        "excellent": "চমৎকার",
        "good": "ভালো",
        "fair": "মোটামুটি",
        "poor": "খারাপ",
        "unknown": "অজানা"
      },
      "quickActions": {
        "title": "রান কনফিগারেশন",
        "subtitle": "অডিট কনফিগার এবং ট্রিগার করুন",
        "auditMode": "অডিট মোড",
        "auditModeHelp": "কী চেক করতে হবে তা বেছে নিন",
        "dryRun": "প্রিভিউ মোড",
        "dryRunHelp": "পরিবর্তন না করে কী পরিবর্তন হবে তা দেখান",
        "scopeFilters": "অডিট ক্ষমতা",
        "scopeFiltersHelp": "সক্ষম করার জন্য ক্ষমতা নির্বাচন করুন (একাধিক একত্রিত করা যায়)",
        "last24Hours": "শুধুমাত্র সাম্প্রতিক কন্টেন্ট",
        "last24HoursHelp": "গত ২৪ ঘণ্টায় যোগ করা কন্টেন্টে অডিট সীমাবদ্ধ করুন",
        "cybTitlesOnly": "নোংরা শিরোনাম পরিষ্কার করুন",
        "cybTitlesOnlyHelp": "শিরোনাম থেকে ফাইল এক্সটেনশন, কোয়ালিটি মার্কার এবং রিলিজ ট্যাগ সরান",
        "tmdbPostersOnly": "TMDB পোস্টার ও মেটাডেটা",
        "tmdbPostersOnlyHelp": "TMDB থেকে অনুপস্থিত পোস্টার, বিবরণ এবং মেটাডেটা আনুন",
        "openSubtitlesEnabled": "সাবটাইটেল অর্জন করুন",
        "openSubtitlesEnabledHelp": "OpenSubtitles থেকে অনুপস্থিত সাবটাইটেল ডাউনলোড করুন (HE/EN/ES)",
        "classifyOnly": "শ্রেণীবিন্যাস যাচাই করুন",
        "classifyOnlyHelp": "সিনেমা বনাম সিরিজ শ্রেণীবিন্যাস ত্রুটি পরীক্ষা এবং সংশোধন করুন",
        "purgeDuplicates": "ডুপ্লিকেট সরান",
        "purgeDuplicatesHelp": "ডুপ্লিকেট কন্টেন্ট আইটেম খুঁজুন এবং সরান",
        "auditType": "অডিট টাইপ",
        "auditTypeHelp": "নিয়ম-ভিত্তিক বা AI-চালিত অডিটের মধ্যে বেছে নিন",
        "dailyAudit": "দৈনিক অডিট",
        "dailyBadge": "নিয়ম-ভিত্তিক • দ্রুত • বিনামূল্যে",
        "dailyDescription": "গত ৭ দিনে পরিবর্তিত কন্টেন্টে পূর্বনির্ধারিত চেক চালায়। দ্রুত এবং অনুমানযোগ্য, কোনো AI খরচ নেই।",
        "aiAgentAudit": "AI এজেন্ট অডিট",
        "aiAgentBadge": "AI-চালিত • বুদ্ধিমান • বাজেট ব্যবহার করে",
        "aiAgentDescription": "স্বায়ত্তশাসিত AI এজেন্ট (Claude) কী চেক এবং ঠিক করতে হবে সে সম্পর্কে বুদ্ধিমান সিদ্ধান্ত নেয়। আরো ব্যাপক কিন্তু API বাজেট ব্যবহার করে।",
        "triggerDaily": "দৈনিক অডিট চালান",
        "triggerAI": "AI এজেন্ট অডিট চালান",
        "auditRunningNotice": "একটি অডিট বর্তমানে চলছে। সম্পূর্ণ হলে বাটন সক্রিয় হবে।",
        "budgetLabel": "AI এজেন্ট বাজেট সীমা: ${{budget}}",
        "budgetPerAudit": "প্রতি অডিট বাজেট",
        "monthlyBudgetUsed": "ব্যবহৃত বাজেট (৩০দ)",
        "monthlyBudgetLimit": "/ ${{limit}} মাসিক",
        "budgetWarning": "এই অডিট চালালে মাসিক বাজেট সীমা অতিক্রম হবে",
        "aiAuditSuccess": "AI এজেন্ট অডিট সফলভাবে ট্রিগার হয়েছে। {{dryRun}}",
        "dailyAuditSuccess": "দৈনিক অডিট সফলভাবে ট্রিগার হয়েছে। {{dryRun}}",
        "dryRunMode": "(ড্রাই রান মোড)",
        "rollbackSuccess": "অ্যাকশন সফলভাবে রোলব্যাক হয়েছে।"
      },
      "voice": {
        "title": "ভয়েস কন্ট্রোল",
        "description": "লাইব্রেরিয়ানকে কমান্ড দিতে আপনার কণ্ঠ ব্যবহার করুন। শুধু বাটন টিপুন এবং স্বাভাবিকভাবে কথা বলুন।",
        "pressToSpeak": "বলতে টিপুন",
        "listening": "শুনছে...",
        "transcript": "প্রতিলিপি",
        "processing": "আপনার কমান্ড প্রক্রিয়াকরণ হচ্ছে...",
        "speaking": "লাইব্রেরিয়ান উত্তর দিচ্ছে...",
        "examples": "উদাহরণ কমান্ড",
        "example1": "গত ২৪ ঘণ্টায় অনুপস্থিত পোস্টার পরীক্ষা করুন",
        "example2": "CYB শিরোনামের জন্য মেটাডেটা ঠিক করুন",
        "example3": "ভাঙা স্ট্রিমিং URL স্ক্যান করুন",
        "example4": "সিনেমা থেকে সাবটাইটেল এক্সট্র্যাক্ট করুন",
        "notSupported": "আপনার ব্রাউজারে ভয়েস রিকগনিশন সমর্থিত নয়। অনুগ্রহ করে Chrome, Edge বা Safari ব্যবহার করুন।",
        "notAvailable": "ভয়েস কন্ট্রোল উপলব্ধ নেই",
        "noSpeech": "কোনো কথা শনাক্ত হয়নি। অনুগ্রহ করে আবার চেষ্টা করুন।",
        "noMicrophone": "কোনো মাইক্রোফোন শনাক্ত হয়নি। অনুগ্রহ করে আপনার ডিভাইস পরীক্ষা করুন।",
        "microphoneBlocked": "মাইক্রোফোন অ্যাক্সেস ব্লক করা হয়েছে। অনুগ্রহ করে আপনার ব্রাউজার সেটিংসে এটি সক্ষম করুন।",
        "error": "স্পিচ রিকগনিশন ত্রুটি: {{error}}",
        "startFailed": "ভয়েস রিকগনিশন শুরু করতে ব্যর্থ। অনুগ্রহ করে আবার চেষ্টা করুন।",
        "commandFailed": "কমান্ড কার্যকর করতে ব্যর্থ। অনুগ্রহ করে আবার চেষ্টা করুন।"
      },
      "schedules": {
        "title": "নির্ধারিত অডিট",
        "subtitle": "দৈনিক এবং সাপ্তাহিক অডিট সময়সূচী কনফিগার করুন",
        "dailyTitle": "দৈনিক অডিট",
        "weeklyTitle": "সাপ্তাহিক AI অডিট",
        "schedule": "সময়সূচী",
        "time": "সময়",
        "mode": "মোড",
        "cost": "আনুমানিক খরচ",
        "status": "স্ট্যাটাস",
        "description": "বিবরণ",
        "viewInConsole": "ক্লাউড কনসোলে দেখুন",
        "modifyNote": "সময়সূচী পরিবর্তন করতে Google Cloud Console ব্যবহার করুন",
        "editTitle": "সময়সূচী সম্পাদনা করুন",
        "editNotAvailable": "সময়সূচী সম্পাদনা উপলব্ধ নেই",
        "editNotAvailableMessage": "সময়সূচী পরিবর্তনের জন্য Cloud Scheduler API ইন্টিগ্রেশন প্রয়োজন। সরাসরি Google Cloud Console-এ সময়সূচী পরিবর্তন করতে 'View in Cloud Console' বাটন ব্যবহার করুন।",
        "cronExpression": "Cron এক্সপ্রেশন",
        "cronHint": "ফরম্যাট: মিনিট ঘণ্টা দিন মাস সপ্তাহের দিন (যেমন, 0 2 * * * = প্রতিদিন ভোর ২:০০)",
        "patterns": {
          "daily": "প্রতিদিন {{hour}}:{{minute}}-এ",
          "weekly": "প্রতি {{day}} {{hour}}:{{minute}}-এ"
        },
        "days": {
          "sunday": "রবিবার",
          "monday": "সোমবার",
          "tuesday": "মঙ্গলবার",
          "wednesday": "বুধবার",
          "thursday": "বৃহস্পতিবার",
          "friday": "শুক্রবার",
          "saturday": "শনিবার"
        }
      },
      "reports": {
        "title": "সাম্প্রতিক অডিট রিপোর্ট",
        "emptyMessage": "এখনও কোনো অডিট রিপোর্ট নেই",
        "totalReports": "{{count}} রিপোর্ট",
        "clearAll": "সব সাফ করুন",
        "confirmClearAll": "আপনি কি সব অডিট রিপোর্ট সাফ করতে নিশ্চিত? এই কাজ পূর্বাবস্থায় ফেরানো যাবে না।",
        "clearedSuccessfully": "সব অডিট রিপোর্ট সফলভাবে সাফ করা হয়েছে",
        "viewLogs": "লগ দেখুন",
        "viewDetails": "বিবরণ দেখুন",
        "columns": {
          "date": "তারিখ",
          "type": "টাইপ",
          "duration": "সময়কাল",
          "status": "স্ট্যাটাস",
          "issues": "সমস্যা",
          "fixes": "সংশোধন",
          "actions": "কার্যক্রম"
        },
        "detailModal": {
          "title": "অডিট রিপোর্ট: {{id}}",
          "summary": "সারাংশ",
          "status": "স্ট্যাটাস",
          "executionTime": "এক্সিকিউশন সময়",
          "totalItems": "মোট আইটেম",
          "healthyItems": "সুস্থ আইটেম",
          "issuesFound": "পাওয়া সমস্যা",
          "totalIssues": "মোট পাওয়া সমস্যা",
          "seeInsightsBelow": "বিবরণের জন্য নিচে AI ইনসাইট দেখুন",
          "brokenStreams": "ভাঙা স্ট্রিম",
          "missingMetadata": "অনুপস্থিত মেটাডেটা",
          "misclassifications": "ভুল শ্রেণীবিন্যাস",
          "orphanedItems": "এতিম আইটেম",
          "fixesApplied": "প্রয়োগকৃত সংশোধন",
          "totalFixes": "{{count}} মোট সংশোধন",
          "aiInsights": "AI ইনসাইট"
        }
      },
      "logs": {
        "title": "এক্সিকিউশন লগ",
        "liveAuditLog": "লাইভ অডিট লগ",
        "executionLog": "অডিট এক্সিকিউশন লগ",
        "searchPlaceholder": "লগ খুঁজুন...",
        "noLogs": "কোনো লগ প্রদর্শনযোগ্য নেই",
        "noActiveAudit": "কোনো সক্রিয় অডিট নেই",
        "triggerAuditToSee": "এখানে লাইভ এক্সিকিউশন লগ দেখতে একটি অডিট ট্রিগার করুন",
        "auditType": "অডিট টাইপ",
        "started": "শুরু হয়েছে",
        "completed": "সম্পন্ন",
        "lastLog": "শেষ লগ",
        "staleWarning": "{{seconds}}s ধরে নতুন লগ নেই - কাজ প্রক্রিয়াকরণ বা আটকে থাকতে পারে",
        "pollingStatus": "পোলিং সক্রিয় • শেষ চেক করা হয়েছে",
        "connecting": "লাইভ অডিট লগে সংযোগ হচ্ছে...",
        "aiInsightPrefix": "AI ইনসাইট",
        "source": {
          "librarian": "লাইব্রেরিয়ান",
          "aiAgent": "AI এজেন্ট"
        },
        "levels": {
          "debug": "ডিবাগ",
          "info": "তথ্য",
          "warn": "সতর্কতা",
          "error": "ত্রুটি",
          "success": "সাফল্য",
          "trace": "ট্রেস"
        },
        "auditStarted": "অডিট শুরু হয়েছে",
        "brokenStreamsFound": "{{count}}টি ভাঙা স্ট্রিম পাওয়া গেছে",
        "missingMetadataFound": "{{count}}টি আইটেমে মেটাডেটা অনুপস্থিত",
        "misclassificationsFound": "{{count}}টি ভুল শ্রেণীবিন্যাসিত আইটেম পাওয়া গেছে",
        "orphanedItemsFound": "{{count}}টি এতিম আইটেম পাওয়া গেছে",
        "fixesApplied": "{{count}}টি সংশোধন প্রয়োগ করা হয়েছে",
        "auditCompleted": "অডিট {{status}} {{duration}}s-এ",
        "auditInitializing": "{{auditType}} অডিট শুরু হচ্ছে...",
        "dryRunMode": "DRY RUN মোডে চলছে - কোনো পরিবর্তন হবে না",
        "liveMode": "LIVE মোডে চলছে - পরিবর্তন প্রয়োগ হবে",
        "budgetSet": "বাজেট সীমা: ${{budget}}",
        "connectingToAgent": "Claude AI এজেন্টে সংযোগ হচ্ছে..."
      },
      "audit": {
        "types": {
          "aiAgent": "AI এজেন্ট",
          "dailyIncremental": "দৈনিক ইনক্রিমেন্টাল"
        },
        "pause": "পজ করুন",
        "resume": "পুনরায় শুরু করুন",
        "cancel": "বাতিল করুন",
        "interject": "মধ্যবর্তী বার্তা",
        "interjectTitle": "AI এজেন্টে বার্তা পাঠান",
        "interjectHint": "এই বার্তা পরবর্তী ইটারেশনে AI এজেন্ট কথোপকথনে ইনজেক্ট করা হবে। অতিরিক্ত প্রসঙ্গ প্রদান, ফোকাস পুনঃনির্দেশ বা নির্দিষ্ট নির্দেশনা দিতে এটি ব্যবহার করুন।",
        "interjectPlaceholder": "যেমন, শুধু সিনেমায় ফোকাস করুন, আপাতত সিরিজ এড়িয়ে যান...",
        "sendInterject": "পাঠান",
        "interjectSuccess": "AI এজেন্টে বার্তা সফলভাবে পাঠানো হয়েছে",
        "pauseSuccess": "অডিট সফলভাবে পজ করা হয়েছে",
        "resumeSuccess": "অডিট সফলভাবে পুনরায় শুরু হয়েছে",
        "cancelSuccess": "অডিট সফলভাবে বাতিল করা হয়েছে"
      },
      "progress": {
        "batch": "ব্যাচ {{current}} / {{total}}",
        "items": "{{processed}} / {{total}} আইটেম",
        "finishing": "শেষ হচ্ছে...",
        "finalizing": "রিপোর্ট তৈরি এবং সংশোধন প্রয়োগ করা হচ্ছে"
      },
      "activityLog": {
        "title": "কার্যকলাপ লগ",
        "subtitle": "{{count}}টি কার্যক্রম রেকর্ড করা হয়েছে",
        "filterByType": "টাইপ দ্বারা ফিল্টার করুন",
        "allActions": "সব কার্যক্রম",
        "content": "কন্টেন্ট",
        "noDescription": "কোনো বিবরণ নেই",
        "updatedFields": "{{fields}} আপডেট করা হয়েছে",
        "pagination": "পৃষ্ঠা {{page}} / {{totalPages}}",
        "issueType": "সমস্যার ধরন",
        "confidence": "আত্মবিশ্বাস",
        "autoApproved": "স্বয়ংক্রিয়-অনুমোদিত",
        "changes": "পরিবর্তন",
        "actionTypes": {
          "addPoster": "পোস্টার যোগ করুন",
          "updateMetadata": "মেটাডেটা আপডেট করুন",
          "recategorize": "পুনঃশ্রেণীবিন্যাস করুন",
          "fixUrl": "URL ঠিক করুন",
          "cleanTitle": "শিরোনাম পরিষ্কার করুন",
          "classify": "শ্রেণীবিন্যাস করুন"
        },
        "rollback": "রোলব্যাক",
        "rolledBack": "রোলব্যাক করা হয়েছে",
        "confirmRollback": {
          "title": "রোলব্যাক নিশ্চিত করুন",
          "message": "আপনি কি এই কার্যক্রম রোলব্যাক করতে নিশ্চিত? এটি আগের অবস্থা পুনরুদ্ধার করবে।"
        },
        "emptyMessage": "কোনো কার্যক্রম পাওয়া যায়নি"
      },
      "modal": {
        "confirmAI": {
          "title": "AI এজেন্ট অডিট ট্রিগার করবেন?",
          "message": "এটি ${{budget}} বাজেট সীমা সহ একটি স্বায়ত্তশাসিত AI এজেন্ট অডিট ট্রিগার করবে। এজেন্ট কী চেক এবং ঠিক করতে হবে সে সম্পর্কে সিদ্ধান্ত নেবে। {{dryRun}}",
          "dryRunNote": "DRY RUN মোডে চলছে (কোনো পরিবর্তন হবে না)।"
        },
        "cancel": "বাতিল",
        "confirm": "নিশ্চিত করুন",
        "close": "বন্ধ করুন",
        "retry": "পুনরায় চেষ্টা করুন"
      },
      "status": {
        "enabled": "সক্রিয়",
        "disabled": "নিষ্ক্রিয়",
        "completed": "অডিট সম্পূর্ণ",
        "failed": "অডিট ব্যর্থ",
        "in_progress": "চলমান",
        "partial": "আংশিকভাবে সম্পূর্ণ",
        "pending": "মুলতুবি",
        "running": "চলছে"
      },
      "auditTypes": {
        "daily_incremental": "দৈনিক ইনক্রিমেন্টাল",
        "ai_agent": "AI এজেন্ট"
      }
    },
    "widgets": {
      "title": "উইজেট",
      "subtitle": "লাইভ স্ট্রিম এবং এম্বেডের জন্য ফ্লোটিং ওভারলে উইজেট পরিচালনা করুন",
      "newWidget": "নতুন উইজেট",
      "editWidget": "উইজেট সম্পাদনা করুন",
      "columns": {
        "title": "শিরোনাম",
        "contentType": "কন্টেন্ট টাইপ",
        "targetRoles": "টার্গেট ভূমিকা",
        "targetPages": "টার্গেট পৃষ্ঠা",
        "status": "স্ট্যাটাস",
        "order": "ক্রম"
      },
      "contentTypes": {
        "liveChannel": "লাইভ চ্যানেল",
        "live": "লাইভ",
        "vod": "ভিডিও অন ডিমান্ড",
        "podcast": "পডকাস্ট",
        "radio": "রেডিও",
        "iframe": "Iframe"
      },
      "status": {
        "active": "সক্রিয়",
        "inactive": "নিষ্ক্রিয়"
      },
      "form": {
        "title": "উইজেট শিরোনাম",
        "description": "বিবরণ (ঐচ্ছিক)",
        "icon": "আইকন ইমোজি (ঐচ্ছিক)",
        "contentType": "কন্টেন্ট টাইপ",
        "selectChannel": "লাইভ চ্যানেল নির্বাচন করুন",
        "channelPlaceholder": "-- চ্যানেল নির্বাচন করুন --",
        "iframeUrl": "Iframe URL",
        "iframeTitle": "Iframe শিরোনাম (অ্যাক্সেসিবিলিটির জন্য)",
        "position": "ডিফল্ট অবস্থান",
        "behavior": "আচরণ",
        "mutedByDefault": "ডিফল্টে নিঃশব্দ",
        "closable": "বন্ধযোগ্য",
        "draggable": "টেনে নেওয়া যায়",
        "targetPages": "টার্গেট পৃষ্ঠা (কমা-বিভক্ত, খালি = সব)",
        "targetPagesPlaceholder": "/, /live, /vod",
        "order": "ক্রম"
      },
      "actions": {
        "save": "সংরক্ষণ করুন",
        "cancel": "বাতিল"
      },
      "confirmDelete": "আপনি কি এই উইজেট মুছতে নিশ্চিত?",
      "emptyMessage": "কোনো উইজেট পাওয়া যায়নি। শুরু করতে একটি তৈরি করুন।",
      "allPages": "সব পৃষ্ঠা",
      "allRoles": "সব",
      "errors": {
        "titleRequired": "শিরোনাম প্রয়োজন",
        "selectChannel": "অনুগ্রহ করে একটি লাইভ চ্যানেল নির্বাচন করুন",
        "iframeUrlRequired": "Iframe URL প্রয়োজন"
      }
    },
    "billing": {
      "subtitle": "রাজস্ব এবং পেমেন্ট ট্র্যাক করুন",
      "revenue": "রাজস্ব",
      "today": "আজ",
      "thisWeek": "এই সপ্তাহে",
      "thisMonth": "এই মাসে",
      "thisYear": "এই বছরে",
      "metrics": "প্রধান মেট্রিক্স",
      "totalTransactions": "মোট লেনদেন",
      "avgTransaction": "গড় লেনদেন",
      "pendingRefunds": "মুলতুবি রিফান্ড",
      "refundRate": "রিফান্ড রেট",
      "retention": "রিটেনশন",
      "retentionRate": "রিটেনশন রেট",
      "churnRate": "চার্ন রেট",
      "atRiskUsers": "ঝুঁকিপূর্ণ ব্যবহারকারী",
      "churnedUsers": "চার্নড ব্যবহারকারী",
      "quickLinks": "দ্রুত লিঙ্ক"
    },
    "marketing": {
      "recentCampaigns": "সাম্প্রতিক ক্যাম্পেইন",
      "audienceSegments": "অডিয়েন্স সেগমেন্ট",
      "emailMetrics": "ইমেইল মেট্রিক্স",
      "pushMetrics": "পুশ মেট্রিক্স",
      "quickActions": "দ্রুত কার্যক্রম"
    },
    "push": {
      "titlePlaceholder": "বিজ্ঞপ্তি শিরোনাম",
      "bodyPlaceholder": "বিজ্ঞপ্তি বার্তা"
    },
    "auditLogs": {
      "subtitle": "সব সিস্টেম কার্যক্রম ট্র্যাক করুন",
      "filter": "ফিল্টার",
      "export": "রপ্তানি",
      "all": "সব",
      "advancedFiltering": "উন্নত ফিল্টারিং",
      "actionType": "অ্যাকশন টাইপ",
      "clear": "সাফ করুন",
      "apply": "প্রয়োগ করুন",
      "noRecords": "কোনো রেকর্ড পাওয়া যায়নি",
      "columns": {
        "action": "অ্যাকশন",
        "user": "ব্যবহারকারী",
        "resource": "রিসোর্স",
        "details": "বিবরণ",
        "date": "তারিখ",
        "ip": "IP"
      },
      "changed": "পরিবর্তন হয়েছে",
      "actionFilters": {
        "user": "ব্যবহারকারী",
        "subscription": "সাবস্ক্রিপশন",
        "payment": "পেমেন্ট",
        "settings": "সেটিংস",
        "campaign": "ক্যাম্পেইন",
        "content": "কন্টেন্ট"
      }
    },
    "settings": {
      "subtitle": "সিস্টেম প্যারামিটার কনফিগার করুন",
      "saveChanges": "পরিবর্তন সংরক্ষণ করুন",
      "generalSettings": "সাধারণ সেটিংস",
      "supportEmail": "সাপোর্ট ইমেইল",
      "defaultPlan": "ডিফল্ট প্ল্যান",
      "termsUrl": "সেবার শর্তাবলী URL",
      "privacyUrl": "গোপনীয়তা নীতি URL",
      "userSettings": "ব্যবহারকারী সেটিংস",
      "maxDevices": "প্রতি অ্যাকাউন্টে সর্বোচ্চ ডিভাইস",
      "trialDays": "ট্রায়াল সময়কাল (দিন)",
      "maintenanceMode": "মেইনটেন্যান্স মোড",
      "maintenanceModeDesc": "সক্ষম করলে সিস্টেম ব্যবহারকারীদের জন্য অ্যাক্সেসযোগ্য হবে না",
      "featureFlags": "ফিচার ফ্ল্যাগ",
      "systemActions": "সিস্টেম অ্যাকশন",
      "clearCache": "ক্যাশ সাফ করুন",
      "resetAnalytics": "অ্যানালিটিক্স রিসেট করুন",
      "actionsWarning": "এই অ্যাকশনগুলি সিস্টেম পারফরম্যান্সকে প্রভাবিত করতে পারে। সতর্কতার সাথে ব্যবহার করুন।",
      "savingSuccess": "সেটিংস সফলভাবে সংরক্ষিত হয়েছে",
      "confirmClearCache": "ক্যাশ সাফ করবেন? এটি সাময়িকভাবে পারফরম্যান্সকে প্রভাবিত করতে পারে।",
      "cacheCleared": "ক্যাশ সফলভাবে সাফ করা হয়েছে",
      "confirmResetAnalytics": "অ্যানালিটিক্স ডেটা রিসেট করবেন? এই কাজ পূর্বাবস্থায় ফেরানো যাবে না!",
      "analyticsReset": "অ্যানালিটিক্স ডেটা রিসেট করা হয়েছে",
      "featureFlagLabels": {
        "new_player": "নতুন প্লেয়ার",
        "live_chat": "লাইভ চ্যাট",
        "downloads": "ডাউনলোড",
        "watch_party": "ওয়াচ পার্টি",
        "voice_search": "ভয়েস সার্চ",
        "ai_recommendations": "AI সুপারিশ"
      }
    },
    "content": {
      "title": "[bn] Content Library",
      "subtitle": "[bn] Manage movies, series, and video content",
      "importFree": "[bn] Import Free Content",
      "searchPlaceholder": "[bn] Search content...",
      "emptyMessage": "[bn] No content found",
      "confirmDelete": "[bn] Delete this content?",
      "confirmBatchDelete": "[bn] Are you sure you want to delete {{count}} item(s)?",
      "selectedItems": "[bn] {{count}} item(s) selected",
      "batchFeature": "[bn] Feature",
      "batchUnfeature": "[bn] Unfeature",
      "import": {
        "pageTitle": "[bn] Import Free Content",
        "subtitle": "[bn] Browse and import public content from free sources",
        "selectCategory": "[bn] Select category for imported movies:",
        "categoryPlaceholder": "[bn] Select a category...",
        "loading": "[bn] Loading sources...",
        "sourceTypes": {
          "vod": "[bn] Movies & VOD",
          "live_tv": "[bn] Live TV",
          "radio": "[bn] Radio",
          "podcasts": "[bn] Podcasts"
        },
        "items": "[bn] item",
        "itemsPlural": "[bn] items",
        "selectItems": "[bn] Please select at least one item to import",
        "selectCategory_vod": "[bn] Please select a category for VOD imports",
        "importing": "[bn] Importing {{count}}... {{percent}}%",
        "importButton": "[bn] Import {{count}} {{item}}",
        "noSources": "[bn] No Sources Available",
        "noSourcesDescription": "[bn] No free content sources are currently available for {{type}}"
      },
      "filters": {
        "title": "ফিল্টার",
        "contentType": "কন্টেন্ট টাইপ",
        "all": "সব",
        "allContent": "সব",
        "series": "সিরিজ",
        "movies": "সিনেমা",
        "podcasts": "পডকাস্ট",
        "radioStations": "রেডিও স্টেশন",
        "status": "স্ট্যাটাস",
        "allStatus": "সব স্ট্যাটাস",
        "subtitles": "সাবটাইটেল"
      },
      "podcastsComingSoon": "পডকাস্ট ম্যানেজমেন্ট শীঘ্রই আসছে। পডকাস্ট বিভাগ ব্যবহার করুন।",
      "radioComingSoon": "রেডিও স্টেশন ম্যানেজমেন্ট শীঘ্রই আসছে। রেডিও স্টেশন বিভাগ ব্যবহার করুন।",
      "showOnlyWithSubtitles": "[bn] Show only with subtitles",
      "status": {
        "published": "[bn] Published",
        "draft": "[bn] Draft"
      },
      "columns": {
        "title": "[bn] Title",
        "category": "[bn] Category",
        "year": "[bn] Year",
        "status": "[bn] Status",
        "views": "[bn] Views",
        "rating": "[bn] Rating",
        "streamUrl": "[bn] Stream URL",
        "epgSource": "[bn] EPG Source",
        "genre": "[bn] Genre",
        "episodeNumber": "[bn] Episode #",
        "description": "[bn] Description",
        "duration": "[bn] Duration",
        "publishedDate": "[bn] Published",
        "episodes": "[bn] Episodes",
        "order": "[bn] Order",
        "name": "[bn] Name",
        "slug": "[bn] Slug",
        "subtitles": "[bn] Subtitles"
      },
      "validation": {
        "titleRequired": "[bn] Title is required",
        "nameRequired": "[bn] Name is required",
        "streamUrlRequired": "[bn] Stream URL is required",
        "audioUrlRequired": "[bn] Audio URL is required"
      },
      "episodes_one": "[bn] episode",
      "episodes_other": "[bn] episodes",
      "noEpisodes": "[bn] No episodes found",
      "type": {
        "series": "[bn] Series",
        "movie": "[bn] Movie"
      },
      "toggleCarousel": "[bn] Toggle carousel",
      "editor": {
        "pageTitle": "[bn] Edit Content",
        "pageTitleNew": "[bn] Add Content",
        "sections": {
          "basicInfo": "[bn] Basic Information",
          "media": "[bn] Media",
          "streaming": "[bn] Streaming",
          "details": "[bn] Content Details",
          "publishing": "[bn] Publishing",
          "accessControl": "[bn] Access Control",
          "podcastDetails": "[bn] Podcast Details",
          "episodeDetails": "[bn] Episode Details",
          "stationDetails": "[bn] Station Details",
          "channelDetails": "[bn] Channel Details"
        },
        "fields": {
          "title": "[bn] Title",
          "titlePlaceholder": "[bn] Content title",
          "titleRequired": "[bn] Title is required",
          "year": "[bn] Year",
          "yearPlaceholder": "[bn] 2024",
          "description": "[bn] Description",
          "descriptionPlaceholder": "[bn] Content description",
          "thumbnail": "[bn] Thumbnail (3:4 aspect ratio)",
          "thumbnailUrl": "[bn] Thumbnail URL",
          "thumbnailUrlPlaceholder": "[bn] https://example.com/thumbnail.jpg",
          "backdrop": "[bn] Backdrop (16:9 aspect ratio)",
          "backdropUrl": "[bn] Backdrop URL",
          "posterCover": "[bn] Podcast Cover",
          "logo": "[bn] Logo",
          "channelLogo": "[bn] Channel Logo",
          "stationLogo": "[bn] Station Logo",
          "streamUrl": "[bn] Stream URL",
          "streamUrlRequired": "[bn] Stream URL is required",
          "streamType": "[bn] Stream Type",
          "drmProtected": "[bn] DRM Protected",
          "drmProtectedLabel": "[bn] This content requires DRM protection",
          "category": "[bn] Category",
          "categoryRequired": "[bn] Category is required",
          "duration": "[bn] Duration",
          "durationPlaceholder": "[bn] 1:30:00",
          "rating": "[bn] Rating",
          "ratingPlaceholder": "[bn] PG-13",
          "genre": "[bn] Genre",
          "genrePlaceholder": "[bn] Drama",
          "director": "[bn] Director",
          "directorPlaceholder": "[bn] Director name",
          "isSeries": "[bn] Series",
          "isSeriesLabel": "[bn] This is a series/multi-part content",
          "season": "[bn] Season",
          "episode": "[bn] Episode",
          "seriesId": "[bn] Series ID",
          "seriesIdPlaceholder": "[bn] series-identifier",
          "isPublished": "[bn] Publish",
          "isPublishedLabel": "[bn] Publish this content immediately",
          "isFeatured": "[bn] Feature",
          "isFeaturedLabel": "[bn] Feature this content on homepage",
          "requiresSubscription": "[bn] Required Subscription",
          "isKidsContent": "[bn] Kids Content",
          "isKidsContentLabel": "[bn] This is kids-friendly content",
          "author": "[bn] Author",
          "authorPlaceholder": "[bn] Podcast author",
          "podcastCategory": "[bn] Category",
          "podcastCategoryPlaceholder": "[bn] News, Science, etc.",
          "rssFeed": "[bn] RSS Feed URL",
          "rssFeedPlaceholder": "[bn] https://example.com/feed.xml",
          "website": "[bn] Website URL",
          "websitePlaceholder": "[bn] https://example.com",
          "episodeNumber": "[bn] Episode #",
          "seasonNumber": "[bn] Season #",
          "audioUrl": "[bn] Audio URL",
          "audioUrlRequired": "[bn] Audio URL is required",
          "audioUrlPlaceholder": "[bn] https://example.com/episode.mp3",
          "publishedAt": "[bn] Published Date",
          "epgSource": "[bn] EPG Source URL",
          "epgSourcePlaceholder": "[bn] https://example.com/epg.xml",
          "currentShow": "[bn] Current Show",
          "currentShowPlaceholder": "[bn] Show name",
          "nextShow": "[bn] Next Show",
          "nextShowPlaceholder": "[bn] Show name",
          "currentSong": "[bn] Current Song",
          "currentSongPlaceholder": "[bn] Song title",
          "isActive": "[bn] Active",
          "isActiveLabel": "[bn] Channel is active",
          "requiredSubscription": "[bn] Required Subscription",
          "publishedDate": "[bn] Published Date"
        },
        "subscriptionTiers": {
          "basic": "[bn] Basic",
          "premium": "[bn] Premium",
          "family": "[bn] Family"
        },
        "actions": {
          "save": "[bn] Save",
          "saving": "[bn] Saving...",
          "cancel": "[bn] Cancel"
        },
        "imageUpload": {
          "dropHere": "[bn] Drop image here or click to upload",
          "formats": "[bn] PNG, JPG, WebP up to {{maxSize}}MB",
          "uploading": "[bn] Uploading...",
          "success": "[bn] Image uploaded successfully",
          "orPasteUrl": "[bn] Or paste image URL",
          "urlPlaceholder": "[bn] https://example.com/image.jpg",
          "validateButton": "[bn] Add",
          "validating": "[bn] Validating...",
          "clear": "[bn] Remove image",
          "errors": {
            "imageOnly": "[bn] Please select an image file",
            "tooLarge": "[bn] File size must be less than {{maxSize}}MB",
            "uploadFailed": "[bn] Upload failed",
            "invalidUrl": "[bn] Invalid URL"
          }
        }
      },
      "categoryPicker": {
        "selectPlaceholder": "[bn] Select category...",
        "searchPlaceholder": "[bn] Search categories...",
        "loading": "[bn] Loading categories...",
        "noResults": "[bn] No categories found",
        "noCategories": "[bn] No categories available",
        "createNew": "[bn] Create new category",
        "errors": {
          "loadFailed": "[bn] Failed to load categories",
          "createFailed": "[bn] Failed to create category"
        },
        "modal": {
          "title": "[bn] Create New Category",
          "placeholder": "[bn] Category name (e.g., Movies, Series)",
          "creating": "[bn] Creating...",
          "create": "[bn] Create"
        }
      },
      "streamUrlInput": {
        "copyUrl": "[bn] Copy URL",
        "copied": "[bn] URL copied to clipboard",
        "streamType": "[bn] Stream Type",
        "validUrl": "[bn] URL is valid - detected as {{type}}",
        "errors": {
          "required": "[bn] Stream URL is required",
          "invalidFormat": "[bn] Invalid URL format"
        },
        "supportedFormats": {
          "title": "[bn] Supported formats:",
          "hls": "[bn] HLS: .m3u8 streams",
          "dash": "[bn] DASH: .mpd streams",
          "audio": "[bn] Audio: .mp3, .aac, or audio streams"
        }
      }
    },
    "categories": {
      "subtitle": "কন্টেন্ট বিভাগ পরিচালনা করুন",
      "emptyMessage": "কোনো বিভাগ পাওয়া যায়নি",
      "status": {
        "active": "সক্রিয়",
        "inactive": "নিষ্ক্রিয়"
      },
      "form": {
        "nameHebrew": "বিভাগ নাম (হিব্রু)",
        "nameEnglish": "বিভাগ নাম (ইংরেজি)",
        "slug": "স্লাগ"
      }
    },
    "liveChannels": {
      "subtitle": "লাইভ TV চ্যানেল পরিচালনা করুন",
      "emptyMessage": "কোনো লাইভ চ্যানেল পাওয়া যায়নি",
      "subtitleSettings": "লাইভ সাবটাইটেল সেটিংস",
      "form": {
        "name": "চ্যানেল নাম",
        "streamUrl": "স্ট্রিম URL",
        "epgSource": "EPG সোর্স URL (ঐচ্ছিক)",
        "currentShow": "বর্তমান শো",
        "order": "ক্রম",
        "supportsSubtitles": "লাইভ সাবটাইটেল সক্ষম করুন",
        "primaryLanguage": "প্রাথমিক ভাষা (সোর্স)",
        "targetLanguages": "উপলব্ধ অনুবাদ ভাষা",
        "targetLanguagesHelp": "ব্যবহারকারীরা রিয়েল-টাইমে কোন ভাষায় অনুবাদ করতে পারবে তা নির্বাচন করুন"
      }
    },
    "radioStations": {
      "subtitle": "রেডিও স্টেশন পরিচালনা করুন",
      "emptyMessage": "কোনো রেডিও স্টেশন পাওয়া যায়নি",
      "form": {
        "name": "স্টেশন নাম",
        "genre": "জনরা",
        "streamUrl": "স্ট্রিম URL",
        "currentShow": "বর্তমান শো (ঐচ্ছিক)",
        "currentSong": "বর্তমান গান (ঐচ্ছিক)",
        "order": "ক্রম"
      }
    },
    "podcasts": {
      "subtitle": "পডকাস্ট এবং পর্ব পরিচালনা করুন",
      "episodesSubtitle": "পর্ব পরিচালনা করুন",
      "emptyMessage": "কোনো পডকাস্ট পাওয়া যায়নি",
      "noEpisodes": "কোনো পর্ব পাওয়া যায়নি",
      "form": {
        "title": "পডকাস্ট শিরোনাম",
        "author": "লেখক",
        "description": "বিবরণ",
        "category": "বিভাগ",
        "rssFeed": "RSS ফিড URL",
        "website": "ওয়েবসাইট URL (ঐচ্ছিক)"
      },
      "episodes": {
        "form": {
          "title": "পর্ব শিরোনাম",
          "description": "বিবরণ",
          "episodeNumber": "পর্ব নম্বর",
          "seasonNumber": "সিজন নম্বর (ঐচ্ছিক)",
          "duration": "সময়কাল",
          "audioUrl": "অডিও URL (প্রয়োজন)",
          "publishedDate": "প্রকাশের তারিখ (YYYY-MM-DD)"
        }
      }
    },
    "users": {
      "subtitle": "ব্যবহারকারী এবং অ্যাকাউন্ট পরিচালনা করুন",
      "addUser": "ব্যবহারকারী যোগ করুন",
      "status": {
        "active": "সক্রিয়",
        "inactive": "নিষ্ক্রিয়",
        "blocked": "ব্লক করা"
      },
      "filters": {
        "all": "সব",
        "active": "সক্রিয়",
        "inactive": "নিষ্ক্রিয়",
        "blocked": "ব্লক করা"
      },
      "columns": {
        "name": "নাম",
        "role": "ভূমিকা",
        "subscription": "সাবস্ক্রিপশন",
        "noSubscription": "কোনো সাবস্ক্রিপশন নেই",
        "status": "স্ট্যাটাস",
        "created": "তৈরি করা হয়েছে",
        "actions": "কার্যক্রম"
      },
      "confirmDelete": "ব্যবহারকারী মুছুন",
      "confirmDeleteMessage": "আপনি কি {{name}} মুছতে নিশ্চিত? এই কাজ পূর্বাবস্থায় ফেরানো যাবে না।",
      "resetPassword": "পাসওয়ার্ড রিসেট করুন",
      "block": "ব্লক করুন",
      "unban": "আনব্যান করুন",
      "confirmResetPassword": "{{email}}-এ পাসওয়ার্ড রিসেট ইমেইল পাঠাবেন?",
      "resetPasswordSent": "পাসওয়ার্ড রিসেট ইমেইল পাঠানো হয়েছে",
      "recentActivity": "সাম্প্রতিক কার্যকলাপ",
      "noActivity": "কোনো কার্যকলাপ নেই",
      "notFound": "ব্যবহারকারী পাওয়া যায়নি",
      "backToList": "তালিকায় ফিরে যান",
      "banReason": "ব্যান কারণ",
      "banReasonPrompt": "ব্যান কারণ:",
      "confirmUnban": "ব্যবহারকারী আনব্যান করবেন?",
      "userDetails": "ব্যবহারকারী বিবরণ",
      "id": "ID",
      "registered": "নিবন্ধিত",
      "billingHistory": "বিলিং ইতিহাস",
      "noPayments": "কোনো পেমেন্ট নেই"
    },
    "campaigns": {
      "subtitle": "কুপন কোড এবং ডিসকাউন্ট পরিচালনা করুন",
      "expired": "মেয়াদ শেষ",
      "status": {
        "active": "সক্রিয়",
        "inactive": "নিষ্ক্রিয়"
      },
      "columns": {
        "name": "নাম",
        "discount": "ডিসকাউন্ট",
        "usage": "ব্যবহার",
        "validUntil": "বৈধ পর্যন্ত",
        "status": "স্ট্যাটাস",
        "actions": "কার্যক্রম"
      },
      "confirmDelete": "ক্যাম্পেইন মুছুন",
      "confirmDeleteMessage": "আপনি কি \"{{name}}\" মুছতে নিশ্চিত? এই কাজ পূর্বাবস্থায় ফেরানো যাবে না।",
      "searchPlaceholder": "ক্যাম্পেইন খুঁজুন...",
      "emptyMessage": "কোনো ক্যাম্পেইন পাওয়া যায়নি",
      "deactivate": "নিষ্ক্রিয় করুন",
      "activate": "সক্রিয় করুন",
      "createTitle": "নতুন ক্যাম্পেইন",
      "editTitle": "ক্যাম্পেইন সম্পাদনা করুন",
      "formSubtitle": "একটি কুপন কোড বা ডিসকাউন্ট সেট আপ করুন",
      "form": {
        "name": "ক্যাম্পেইন নাম",
        "namePlaceholder": "যেমন গ্রীষ্ম সেল ২০২৪",
        "code": "কুপন কোড",
        "generate": "জেনারেট করুন",
        "discountType": "ডিসকাউন্ট টাইপ",
        "discountValue": "ডিসকাউন্ট মান",
        "maxUses": "সর্বোচ্চ ব্যবহার",
        "unlimited": "সীমাহীন",
        "validUntil": "বৈধ পর্যন্ত",
        "active": "ক্যাম্পেইন সক্রিয়"
      }
    },
    "subscriptions": {
      "subtitle": "সিস্টেম সাবস্ক্রাইবার দেখুন এবং পরিচালনা করুন",
      "status": {
        "active": "সক্রিয়",
        "paused": "বিরতিতে আছে",
        "cancelled": "বাতিল",
        "expired": "মেয়াদ শেষ"
      },
      "columns": {
        "user": "ব্যবহারকারী",
        "plan": "প্ল্যান",
        "price": "মূল্য",
        "nextBilling": "পরবর্তী বিলিং",
        "status": "স্ট্যাটাস"
      },
      "perMonth": "/মাস",
      "searchPlaceholder": "সাবস্ক্রিপশন খুঁজুন...",
      "emptyMessage": "কোনো সাবস্ক্রিপশন পাওয়া যায়নি",
      "actions": {
        "changePlan": "প্ল্যান পরিবর্তন করুন",
        "pause": "বিরতি দিন",
        "resume": "পুনরায় শুরু করুন",
        "cancel": "বাতিল করুন",
        "delete": "মুছুন"
      },
      "editPlan": {
        "title": "সাবস্ক্রিপশন প্ল্যান পরিবর্তন করুন",
        "user": "ব্যবহারকারী",
        "currentPlan": "বর্তমান প্ল্যান",
        "newPlan": "নতুন প্ল্যান নির্বাচন করুন"
      },
      "addSubscription": {
        "title": "সাবস্ক্রিপশন যোগ করুন",
        "userEmail": "ব্যবহারকারী ইমেইল",
        "emailPlaceholder": "ব্যবহারকারী ইমেইল লিখুন",
        "duration": "সময়কাল (দিন)",
        "selectPlan": "প্ল্যান নির্বাচন করুন"
      },
      "fillAllFields": "অনুগ্রহ করে সব ফিল্ড পূরণ করুন",
      "userNotFound": "ব্যবহারকারী পাওয়া যায়নি",
      "selectOneToEdit": "সম্পাদনা করতে ঠিক একটি সাবস্ক্রিপশন নির্বাচন করুন",
      "selectToDelete": "মুছতে সাবস্ক্রিপশন নির্বাচন করুন",
      "confirmDeleteMultiple": "{{count}}টি সাবস্ক্রিপশন মুছবেন?",
      "selected": "নির্বাচিত",
      "confirmDelete": "আপনি কি {{user}}-এর সাবস্ক্রিপশন মুছতে নিশ্চিত? এই কাজ পূর্বাবস্থায় ফেরানো যাবে না।"
    },
    "marketingDashboard": {
      "subtitle": "মার্কেটিং ওভারভিউ",
      "refresh": "রিফ্রেশ",
      "totalSubscribers": "মোট সাবস্ক্রাইবার",
      "emailOpenRate": "ইমেইল ওপেন রেট",
      "pushClickRate": "পুশ ক্লিক রেট",
      "activeSegments": "সক্রিয় সেগমেন্ট",
      "campaignStatus": {
        "active": "সক্রিয়",
        "completed": "সম্পন্ন",
        "scheduled": "নির্ধারিত",
        "draft": "খসড়া"
      }
    },
    "transactions": {
      "subtitle": "পেমেন্ট ইতিহাস দেখুন",
      "exportCsv": "CSV রপ্তানি",
      "status": {
        "completed": "সম্পন্ন",
        "pending": "মুলতুবি",
        "failed": "ব্যর্থ",
        "refunded": "ফেরত দেওয়া হয়েছে"
      },
      "columns": {
        "id": "ID",
        "user": "ব্যবহারকারী",
        "amount": "পরিমাণ",
        "type": "ধরন",
        "status": "স্ট্যাটাস",
        "date": "তারিখ"
      },
      "filters": {
        "all": "সব"
      },
      "searchPlaceholder": "লেনদেন খুঁজুন...",
      "emptyMessage": "কোনো লেনদেন পাওয়া যায়নি",
      "details": "লেনদেনের বিবরণ",
      "email": "ইমেইল"
    },
    "pushNotifications": {
      "subtitle": "ব্যবহারকারীদের কাছে বিজ্ঞপ্তি তৈরি এবং পাঠান",
      "newNotification": "নতুন বিজ্ঞপ্তি",
      "status": {
        "draft": "খসড়া",
        "sent": "পাঠানো হয়েছে",
        "scheduled": "নির্ধারিত"
      },
      "columns": {
        "title": "শিরোনাম",
        "status": "স্ট্যাটাস",
        "sent": "পাঠানো হয়েছে",
        "opened": "খোলা হয়েছে",
        "scheduledAt": "নির্ধারিত সময়",
        "created": "তৈরি করা হয়েছে",
        "actions": "কার্যক্রম"
      },
      "filters": {
        "all": "সব"
      },
      "searchPlaceholder": "বিজ্ঞপ্তি খুঁজুন...",
      "emptyMessage": "কোনো বিজ্ঞপ্তি পাওয়া যায়নি",
      "createModal": "নতুন পুশ বিজ্ঞপ্তি",
      "editModal": "বিজ্ঞপ্তি সম্পাদনা করুন",
      "scheduleModal": "বিজ্ঞপ্তি নির্ধারণ করুন",
      "titleLabel": "শিরোনাম",
      "bodyLabel": "বডি",
      "dateTimeLabel": "তারিখ এবং সময়",
      "cancel": "বাতিল",
      "create": "বিজ্ঞপ্তি তৈরি করুন",
      "schedule": "নির্ধারণ করুন",
      "send": "এখনই পাঠান",
      "confirmSend": "\"{{title}}\" বিজ্ঞপ্তি পাঠাবেন?",
      "confirmDelete": "\"{{title}}\" বিজ্ঞপ্তি মুছে ফেলবেন?",
      "fillRequired": "অনুগ্রহ করে শিরোনাম এবং বডি পূরণ করুন"
    }
  },
  "placeholder": {
    "email": "[bn] your@email.com",
    "password": "[bn] ••••••••",
    "pin": "[bn] ••••",
    "dateRange": {
      "from": "[bn] From (YYYY-MM-DD)",
      "to": "[bn] To (YYYY-MM-DD)"
    },
    "amount": {
      "min": "[bn] Min",
      "max": "[bn] Max",
      "price": "[bn] 0.00"
    },
    "chatMessage": "[bn] Type here...",
    "deepLink": "[bn] bayitplus://content/123",
    "scheduleDateTime": "[bn] YYYY-MM-DDTHH:mm",
    "roomCode": "[bn] ABCD1234",
    "time": {
      "start": "[bn] 08:00",
      "end": "[bn] 10:00"
    },
    "filter": {
      "userId": "[bn] Enter user ID"
    },
    "datetime": "[bn] YYYY-MM-DDTHH:mm",
    "number": "[bn] 0",
    "chat": "[bn] Type your message..."
  },
  "components": {
    "select": {
      "default": "[bn] Select..."
    }
  },
  "plans": {
    "basic": {
      "name": "বেসিক",
      "features": [
        "সব VOD কন্টেন্ট",
        "রেডিও ও পডকাস্ট",
        "১টি ডিভাইসে দেখুন",
        "SD মান"
      ],
      "notIncluded": "[bn] ['Live channels', 'AI Assistant', 'Offline viewing']"
    },
    "premium": {
      "name": "প্রিমিয়াম",
      "features": [
        "সব VOD কন্টেন্ট",
        "লাইভ চ্যানেল",
        "রেডিও ও পডকাস্ট",
        "স্মার্ট AI সহায়ক",
        "২টি ডিভাইসে দেখুন",
        "HD মান"
      ],
      "notIncluded": "[bn] ['Offline viewing', 'Family profiles']"
    },
    "family": {
      "name": "ফ্যামিলি",
      "features": [
        "সব VOD কন্টেন্ট",
        "লাইভ চ্যানেল",
        "৪টি ডিভাইসে দেখুন",
        "4K মান",
        "৫টি ফ্যামিলি প্রোফাইল"
      ],
      "notIncluded": "[bn] []"
    },
    "batchActions": {
      "selectedCount": "[bn] {{count}} selected",
      "selectedCount_one": "[bn] {{count}} selected",
      "selectedCount_other": "[bn] {{count}} selected",
      "clear": "[bn] Clear"
    },
    "costDashboard": {
      "title": "[bn] Cost Dashboard",
      "costBreakdown": "[bn] Cost Breakdown",
      "loadingBreakdown": "[bn] Loading breakdown...",
      "aiCosts": "[bn] AI Costs",
      "infrastructure": "[bn] Infrastructure",
      "thirdParty": "[bn] Third-party",
      "thirdPartyApis": "[bn] Third-party APIs",
      "translation": "[bn] Translation",
      "search": "[bn] Search",
      "percentOfTotal": "[bn] % of total",
      "components": "[bn] Components",
      "topSpenders": {
        "title": "[bn] Top 20 Spenders (Monthly)",
        "loading": "[bn] Loading top spenders...",
        "rank": "[bn] Rank",
        "userId": "[bn] User ID",
        "costRange": "[bn] Cost Range",
        "privacyNote": "[bn] User IDs are hashed and costs are aggregated into ranges for privacy protection."
      },
      "categories": {
        "permanent": "[bn] Permanent",
        "transient": "[bn] Transient",
        "permanentVsTransient": "[bn] Permanent vs Transient",
        "permanentFixed": "[bn] Permanent (Fixed)",
        "transientVariable": "[bn] Transient (Variable)",
        "permanentDesc": "[bn] Infrastructure costs that occur monthly regardless of usage",
        "transientDesc": "[bn] Usage-based costs that fluctuate with platform activity",
        "detailedBreakdown": "[bn] Detailed Breakdown",
        "costItem": "[bn] Cost Item",
        "category": "[bn] Category",
        "amount": "[bn] Amount"
      },
      "timeline": {
        "title": "[bn] Cost Timeline",
        "loading": "[bn] Loading timeline...",
        "amountLabel": "[bn] Amount ($)",
        "revenue": "[bn] Revenue",
        "totalCost": "[bn] Total Cost",
        "netProfit": "[bn] Net Profit",
        "showingData": "[bn] Showing data from {{start}} to {{end}}"
      },
      "plSummary": {
        "netProfitLoss": "[bn] Net Profit/Loss",
        "margin": "[bn] margin",
        "revenue": "[bn] REVENUE",
        "totalCosts": "[bn] TOTAL COSTS"
      }
    }
  },
  "subscribe": {
    "title": "আপনার প্ল্যান বেছে নিন",
    "subtitle": "যেকোনো প্ল্যানে ৭ দিনের বিনামূল্যে ট্রায়াল। যেকোনো সময় বাতিল করুন।",
    "monthly": "মাসিক",
    "yearly": "বার্ষিক",
    "save2Months": "[bn] Save 2 months",
    "popular": "সবচেয়ে জনপ্রিয়",
    "period": "/মাস",
    "perYear": "[bn] /year",
    "select": "প্ল্যান নির্বাচন করুন",
    "selected": "[bn] Selected",
    "processing": "[bn] Processing...",
    "startTrial": "বিনামূল্যে ট্রায়াল শুরু করুন",
    "noCharge": "[bn] Your credit card won't be charged during the trial period"
  },
  "notFound": {
    "title": "পৃষ্ঠা পাওয়া যায়নি",
    "description": "আপনি যে পৃষ্ঠাটি খুঁজছেন তা বিদ্যমান নেই।",
    "homeButton": "হোমে যান",
    "searchButton": "খুঁজুন",
    "orTry": "[bn] Or try:",
    "liveChannel": "[bn] Live",
    "vodLabel": "[bn] Movies",
    "podcastsLabel": "[bn] Podcasts"
  },
  "profiles": {
    "addProfile": "[bn] Add Profile",
    "enterPin": "[bn] Enter PIN",
    "selectError": "[bn] Error selecting profile",
    "wrongPin": "[bn] Incorrect PIN",
    "loading": "[bn] Loading profiles...",
    "manage": "[bn] Manage Profiles",
    "whoIsWatching": "[bn] Who's Watching?",
    "manageProfiles": "[bn] Manage Profiles",
    "kids": "বাচ্চারা",
    "addIcon": "+"
  },
  "watch": {
    "notFound": "[bn] Content not found",
    "backToHome": "[bn] Back to Home",
    "episodes": "[bn] Episodes",
    "addToList": "[bn] Add to List",
    "like": "[bn] Like",
    "share": "[bn] Share",
    "cast": "[bn] Cast",
    "episodesList": "[bn] Episodes",
    "schedule": "[bn] Schedule",
    "now": "[bn] Now",
    "related": "[bn] Related Content",
    "deleteEpisode": "[bn] Delete Episode",
    "confirmDeleteEpisode": "[bn] Delete this episode?"
  },
  "live": {
    "title": "[bn] Live TV",
    "next": "[bn] Next:",
    "noChannels": "[bn] No channels available",
    "tryLater": "[bn] Try again later",
    "categories": {
      "all": "[bn] All",
      "news": "[bn] News",
      "entertainment": "[bn] Entertainment",
      "sports": "[bn] Sports",
      "kids": "[bn] Kids",
      "music": "[bn] Music"
    }
  },
  "judaism": {
    "title": "ইহুদি ধর্ম",
    "items": "আইটেম",
    "empty": "কোনো কন্টেন্ট নেই",
    "emptyHint": "[bn] Try selecting another category",
    "dashboard": "[bn] Your Jewish Dashboard",
    "categories": {
      "news": "[bn] Jewish News",
      "community": "[bn] Community"
    },
    "shabbat": {
      "title": "শাব্বাত সময়",
      "shabbatShalom": "শাব্বাত শালোম!",
      "shabbatMode": "[bn] Shabbat Mode",
      "endsIn": "[bn] Shabbat ends in",
      "candleLighting": "মোমবাতি জ্বালানো",
      "havdalah": "হাভদালা",
      "parashat": "[bn] Parashat",
      "friday": "[bn] Friday",
      "saturday": "[bn] Saturday",
      "noData": "[bn] Unable to load Shabbat times"
    },
    "erevShabbat": {
      "title": "[bn] Erev Shabbat",
      "prepareFor": "[bn] Prepare for Shabbat",
      "inTime": "[bn] in {{time}}",
      "featuredContent": "[bn] Shabbat Content",
      "noContent": "[bn] Shabbat content coming soon!",
      "shabbatShalom": "[bn] Shabbat Shalom!",
      "timeUntil": "[bn] Time until Shabbat",
      "shabbatSongs": "[bn] Shabbat Songs",
      "parashaStudy": "[bn] Parasha",
      "shabbatRecipes": "[bn] Recipes",
      "prayers": "[bn] Prayers"
    }
  },
  "children": {
    "title": "শিশু",
    "items": "আইটেম",
    "empty": "কোনো কন্টেন্ট নেই",
    "emptyHint": "[bn] Try another category",
    "exitKidsMode": "কিডস মোড থেকে বের হন",
    "exitDescription": "[bn] Enter parent code to exit",
    "parentCode": "[bn] Parent code",
    "confirm": "[bn] Confirm",
    "wrongCode": "[bn] Incorrect code",
    "noContent": "[bn] No content available",
    "tryAnotherCategory": "[bn] Try selecting another category",
    "categories": {
      "all": "সব",
      "cartoons": "কার্টুন",
      "educational": "শিক্ষামূলক",
      "music": "সংগীত",
      "hebrew": "[bn] Hebrew",
      "stories": "গল্প",
      "jewish": "ইহুদি"
    },
    "ageRatings": {
      "3": "[bn] Ages 3+",
      "5": "[bn] Ages 5+",
      "7": "[bn] Ages 7+",
      "10": "[bn] Ages 10+",
      "12": "[bn] Ages 12+"
    },
    "moderation": {
      "pending": "[bn] Pending Review",
      "approved": "[bn] Approved",
      "rejected": "[bn] Rejected"
    },
    "admin": {
      "stats": "[bn] Kids Content Manager",
      "seedContent": "[bn] Seed Content",
      "importArchive": "[bn] Import Archive.org",
      "syncPodcasts": "[bn] Sync Podcasts",
      "syncYouTube": "[bn] Sync YouTube",
      "tagVod": "[bn] Tag VOD",
      "pendingModeration": "[bn] Pending Moderation"
    }
  },
  "youngsters": {
    "title": "[bn] Youngsters",
    "items": "[bn] items",
    "empty": "[bn] No content available",
    "emptyHint": "[bn] Try another category",
    "exitYoungstersMode": "[bn] Exit Youngsters Mode",
    "exitDescription": "[bn] Enter parent code to exit",
    "parentCode": "[bn] Parent code",
    "confirm": "[bn] Confirm",
    "wrongCode": "[bn] Incorrect code",
    "noContent": "[bn] No content available",
    "tryAnotherCategory": "[bn] Try selecting another category",
    "categories": {
      "all": "[bn] All",
      "trending": "[bn] Trending",
      "news": "[bn] News",
      "culture": "[bn] Culture",
      "educational": "[bn] Educational",
      "music": "[bn] Music",
      "entertainment": "[bn] Entertainment",
      "sports": "[bn] Sports",
      "tech": "[bn] Technology",
      "judaism": "[bn] Judaism"
    },
    "ageGroups": {
      "middle-school": "[bn] Middle School (12-14)",
      "high-school": "[bn] High School (15-17)"
    },
    "moderation": {
      "pending": "[bn] Pending Review",
      "approved": "[bn] Approved",
      "rejected": "[bn] Rejected"
    },
    "admin": {
      "stats": "[bn] Youngsters Content Manager",
      "seedContent": "[bn] Seed Content",
      "importArchive": "[bn] Import Archive.org",
      "syncPodcasts": "[bn] Sync Podcasts",
      "syncYouTube": "[bn] Sync YouTube",
      "tagVod": "[bn] Tag VOD",
      "pendingModeration": "[bn] Pending Moderation"
    }
  },
  "chatbot": {
    "title": "Bayit+ সহায়ক",
    "greeting": "হ্যালো! আমি Bayit+ স্মার্ট সহায়ক। আজ আমি আপনাকে কীভাবে সাহায্য করতে পারি?",
    "openChat": "[bn] Open chat",
    "welcome": "[bn] Hello! I'm the Bayit+ smart assistant. How can I help you today? Click the microphone and speak, or type a message.",
    "placeholder": "এখানে টাইপ করুন...",
    "recording": "[bn] Recording... click again to stop",
    "transcribing": "[bn] Transcribing...",
    "stopRecording": "[bn] Stop recording",
    "startRecording": "[bn] Start voice recording",
    "recommendations": "[bn] Here are some recommendations:",
    "showMultipleSuccess": "[bn] Showing {{count}} content items in widgets",
    "showMultipleNotFound": "[bn] Could not find the requested content. Please try different names.",
    "resolvingContent": "[bn] Finding your content...",
    "errors": {
      "micPermission": "[bn] Could not access microphone. Please check microphone permissions in your browser.",
      "transcribeFailed": "[bn] Could not transcribe the recording. Please try again.",
      "general": "[bn] Sorry, something went wrong. Please try again."
    },
    "suggestions": {
      "whatToWatch": "[bn] What to watch today?",
      "israeliMovies": "[bn] Recommended Israeli movies",
      "whatsOnNow": "[bn] What's on now?",
      "popularPodcasts": "[bn] Popular podcasts"
    },
    "voiceCommands": {
      "showChannels": "[bn] Show me channels...",
      "playChess": "[bn] Start a chess game with...",
      "multiContent": "[bn] Show side by side..."
    }
  },
  "chat": {
    "title": "[bn] Bayit+ Assistant",
    "greeting": "[bn] Hello! I'm Bayit+ smart assistant. How can I help you today? Click the microphone and speak, or type a message."
  },
  "subtitles": {
    "nikud": "নিকুদ",
    "selection": "নির্বাচন",
    "translation": "অনুবাদ",
    "translating": "অনুবাদ হচ্ছে...",
    "close": "বন্ধ করুন",
    "unavailable": "অনুবাদ উপলব্ধ নেই",
    "off": "বন্ধ",
    "none": "কোনোটি নয়",
    "autoGenerated": "স্বয়ংক্রিয়ভাবে তৈরি",
    "selectLanguage": "সাবটাইটেল ভাষা নির্বাচন করুন",
    "liveTranslate": "লাইভ অনুবাদ",
    "translateTo": "এতে অনুবাদ করুন",
    "downloadMore": "আরও সাবটাইটেল ডাউনলোড করুন...",
    "downloading": "OpenSubtitles খুঁজছে...",
    "opensubtitlesSource": "OpenSubtitles.com থেকে",
    "downloadSuccess": "{{count}}টি সাবটাইটেল ডাউনলোড হয়েছে",
    "noSubtitlesFound": "এই কন্টেন্টের জন্য কোনো সাবটাইটেল পাওয়া যায়নি",
    "smartSubs": "স্মার্ট সাবস",
    "smartSubsDescription": "দ্বৈত ভিউ: সরলীকৃত হিব্রু + ইংরেজি রুট হাইলাইটিং সহ",
    "smartSubsDualView": "দ্বৈত ভিউ",
    "shoreshToggle": "রুট হাইলাইটিং",
    "shoreshOn": "Shoresh হাইলাইটিং সক্রিয়",
    "shoreshOff": "Shoresh হাইলাইটিং নিষ্ক্রিয়",
    "nikudLive": "Nikud সহ হিব্রু",
    "nikudLiveDescription": "সহজ পঠনের জন্য ডায়াক্রিটিক্যাল চিহ্ন সহ স্বরযুক্ত হিব্রু সাবটাইটেল",
    "nikudEnabled": "Nikud সাবটাইটেল সক্রিয়",
    "nikudDisabled": "Nikud সাবটাইটেল নিষ্ক্রিয়",
    "nikudSubtitleLabel": "Nikud সহ হিব্রু: {{text}}",
    "available": "সাবটাইটেল",
    "clickToEnable": "লাইভ অনুবাদ সক্রিয় করতে ক্লিক করুন",
    "connectionError": "লাইভ অনুবাদ ত্রুটি",
    "inputLanguageTooltip": "ইনপুট ভাষা পরীক্ষা করুন",
    "premiumRequired": "প্রিমিয়াম সাবস্ক্রিপশন প্রয়োজন",
    "selectInputLanguage": "ইনপুট ভাষা নির্বাচন করুন",
    "translateActive": "লাইভ অনুবাদ সক্রিয়",
    "noEnglishSubtitles": "এই কন্টেন্টের জন্য কোনো ইংরেজি সাবটাইটেল উপলব্ধ নেই।",
    "hebrewMode": {
      "title": "হিব্রু ডিসপ্লে মোড",
      "unavailable": "উপলব্ধ নেই",
      "generate": "তৈরি করুন",
      "regular": {
        "title": "সাধারণ হিব্রু",
        "description": "স্বর চিহ্ন ছাড়া স্ট্যান্ডার্ড হিব্রু টেক্সট"
      },
      "nikud": {
        "title": "Nikud সহ হিব্রু",
        "description": "সহজ পঠনের জন্য স্বর চিহ্ন সহ স্বরযুক্ত হিব্রু",
        "unavailableReason": "এই কন্টেন্টের জন্য AI প্রসেসিং উপলব্ধ নেই"
      },
      "shoresh": {
        "title": "Shoresh (মূল শব্দ)",
        "description": "মূল বিশ্লেষণ সহ হিব্রু শব্দ: শব্দ [মূল]",
        "unavailableReason": "এই কন্টেন্টের জন্য মূল শব্দ বিশ্লেষণ উপলব্ধ নেই"
      }
    },
    "englishMode": {
      "title": "ইংরেজি ডিসপ্লে মোড",
      "unavailable": "উপলব্ধ নেই",
      "generate": "তৈরি করুন",
      "firstTimeHint": "এই AI-চালিত মোডগুলি ইংরেজি বাক্য গঠন শেখার সময় হিব্রু বজায় রাখতে সাহায্য করে। প্রতিটি মোড একটি অনন্য শেখার অভিজ্ঞতা প্রদান করে।",
      "regular": {
        "title": "সাধারণ ইংরেজি",
        "description": "স্ট্যান্ডার্ড ইংরেজি সাবটাইটেল"
      },
      "heblish": {
        "title": "হেবলিশ",
        "description": "নিমগ্ন শেখার জন্য হিব্রু শব্দ ইনজেকশন সহ ইংরেজি",
        "unavailableReason": "এই কন্টেন্টের জন্য Heblish প্রসেসিং উপলব্ধ নেই"
      },
      "grammarFlip": {
        "title": "গ্রামার-ফ্লিপ",
        "description": "ইংরেজি বাক্য গঠন সহ হিব্রু শব্দ (কর্তা-ক্রিয়া-কর্ম)",
        "unavailableReason": "এই কন্টেন্টের জন্য Grammar-Flip প্রসেসিং উপলব্ধ নেই"
      },
      "slangSynthesis": {
        "title": "স্ল্যাং সিন্থেসিস",
        "description": "আকর্ষণীয় কন্টেন্টের জন্য আধুনিক ইসরায়েলি এবং আমেরিকান স্ল্যাং মিশ্রণ",
        "unavailableReason": "এই কন্টেন্টের জন্য Slang Synthesis প্রসেসিং উপলব্ধ নেই"
      }
    },
    "loading": "সাবটাইটেল লোড হচ্ছে...",
    "error": {
      "title": "সাবটাইটেল ত্রুটি",
      "retry": "আবার চেষ্টা করুন",
      "loadFailed": "সাবটাইটেল লোড করতে ব্যর্থ",
      "cuesFailed": "সাবটাইটেল টেক্সট লোড করতে ব্যর্থ",
      "networkError": "নেটওয়ার্ক ত্রুটি - আপনার সংযোগ পরীক্ষা করুন",
      "serverError": "সার্ভার ত্রুটি - পরে আবার চেষ্টা করুন"
    },
    "aiModesAvailable": "উপলব্ধ AI মোড",
    "aiModesTitle": "AI সাবটাইটেল মোড",
    "fetchSubtitles": "সাবটাইটেল আনুন",
    "fontSize": "ফন্ট সাইজ",
    "mode": {
      "engrew": "এনগ্রু",
      "heblish": "হেবলিশ",
      "shoresh": "শোরেশ",
      "standard": "স্ট্যান্ডার্ড"
    },
    "opensubtitles": "OpenSubtitles",
    "searchExternal": "বহিরাগত সাবটাইটেল অনুসন্ধান করুন",
    "settingsTitle": "সাবটাইটেল সেটিংস",
    "showBackground": "পটভূমি দেখান",
    "singleMode": "একক মোড",
    "splitMode": "স্প্লিট মোড",
    "primary_language": "প্রাথমিক ভাষা",
    "secondary_language": "সেকেন্ডারি ভাষা",
    "layout_mode": "লেআউট মোড",
    "interactive_title": "ইন্টারঅ্যাক্টিভ সাবটাইটেল"
  },
  "video": {
    "watchTrailer": "[bn] Watch Trailer",
    "closeTrailer": "[bn] Close Trailer",
    "deleteConfirm": "[bn] Delete this episode?"
  },
  "recordings": {
    "title": "আমার রেকর্ডিং",
    "subtitle": "আপনার রেকর্ড করা লাইভ স্ট্রিম দেখুন এবং পরিচালনা করুন",
    "record": "রেকর্ড",
    "recording": "রেকর্ডিং হচ্ছে",
    "storageUsed": "[bn] Storage Used",
    "totalRecordings": "[bn] Total Recordings",
    "maxDuration": "[bn] Max Duration",
    "noRecordings": "কোনো রেকর্ডিং নেই",
    "noRecordingsHint": "[bn] Start recording from any live channel!",
    "confirmDelete": "[bn] Are you sure you want to delete this recording? This action cannot be undone.",
    "deleteRecording": "[bn] Delete Recording",
    "deleteFailed": "[bn] Failed to delete recording",
    "expires": "[bn] Expires",
    "subtitlesAvailable": "[bn] Subtitles Available",
    "recordingSaved": "[bn] Recording Saved!",
    "savedSuccess": "[bn] Recording saved successfully! Duration: {{duration}}",
    "viewInMyRecordings": "[bn] View in My Recordings",
    "error": "[bn] Recording Error",
    "startFailed": "[bn] Failed to start recording. Please try again.",
    "stopFailed": "[bn] Failed to stop recording. Please try again.",
    "page": "[bn] Page"
  },
  "chess": {
    "title": "[bn] Chess",
    "welcome": "[bn] Welcome to Chess",
    "subtitle": "[bn] Play chess with friends and family around the world",
    "createGame": "[bn] Create New Game",
    "joinGame": "[bn] Join Game",
    "gameCode": "[bn] Game Code",
    "enterGameCode": "[bn] Enter Game Code",
    "invalidGameCode": "[bn] Invalid game code. Must be 6 characters.",
    "joinFailed": "[bn] Failed to join game",
    "join": "[bn] Join",
    "create": "[bn] Create",
    "chooseColor": "[bn] Choose Your Color",
    "white": "[bn] White",
    "black": "[bn] Black",
    "chatPlaceholder": "[bn] Type a message... (@bot for advice)",
    "botHint": "[bn] Tag @bot in your message to get chess advice from our AI assistant",
    "bot": "[bn] Chess Assistant",
    "mute": "[bn] Mute",
    "unmute": "[bn] Unmute",
    "speaking": "[bn] participants",
    "resign": "[bn] Resign",
    "offerDraw": "[bn] Offer Draw",
    "newGame": "[bn] New Game",
    "checkmate": "[bn] Checkmate!",
    "stalemate": "[bn] Stalemate",
    "draw": "[bn] Draw",
    "resigned": "[bn] Game Resigned",
    "reconnecting": "[bn] Reconnecting...",
    "moveHistory": "[bn] Move History",
    "noMoves": "[bn] No moves yet",
    "showHints": "[bn] Show Guide Hints",
    "yourTurn": "[bn] Your Turn",
    "opponentTurn": "[bn] Opponent's Turn",
    "waitingForOpponent": "[bn] Waiting for opponent...",
    "gameOver": "[bn] Game Over",
    "sendingInvite": "[bn] Sending game invite to {{name}}...",
    "inviteSent": "[bn] Game invite sent to {{name}}! Game code: {{code}}",
    "inviteFailed": "[bn] Could not find that user. Please check the name and try again.",
    "inviteReceived": "[bn] {{name}} invited you to a chess game!",
    "joinInvite": "[bn] Join Game",
    "challenge": "[bn] Challenge",
    "playedAsWhite": "[bn] Played as White",
    "playedAsBlack": "[bn] Played as Black",
    "gameMode": "[bn] Game Mode",
    "playVsFriend": "[bn] Play vs Friend",
    "playVsBot": "[bn] Play vs Bot",
    "difficulty": "[bn] Difficulty",
    "easy": "[bn] Easy",
    "medium": "[bn] Medium",
    "hard": "[bn] Hard",
    "chessBot": "[bn] Chess Bot",
    "chat": {
      "title": "[bn] Chat",
      "inputPlaceholder": "[bn] Type a message..."
    },
    "acceptDraw": "[bn] Accept Draw",
    "acceptInvite": "[bn] Accept Invite",
    "blackCaptured": "[bn] Black Captured",
    "blackTurn": "[bn] Black's Turn",
    "challengeFriend": "[bn] Challenge Friend",
    "challengeViaWhatsApp": "[bn] Challenge via WhatsApp",
    "copyCode": "[bn] Copy Code",
    "declineDraw": "[bn] Decline Draw",
    "declineInvite": "[bn] Decline Invite",
    "drawOffered": "[bn] Draw Offered",
    "joinByGameCode": "[bn] Join by Game Code",
    "noFriendsYet": "[bn] No friends yet",
    "offline": "[bn] Offline",
    "online": "[bn] Online",
    "opponent": "[bn] Opponent",
    "whiteCaptured": "[bn] White Captured",
    "whiteTurn": "[bn] White's Turn",
    "you": "[bn] You"
  },
  "friends": {
    "title": "[bn] Friends & Opponents",
    "subtitle": "[bn] Connect with players and challenge friends",
    "myFriends": "[bn] My Friends",
    "requests": "[bn] Requests",
    "findPlayers": "[bn] Find Players",
    "friendsLabel": "[bn] Friends",
    "pendingLabel": "[bn] Pending",
    "add": "[bn] Add Friend",
    "remove": "[bn] Remove",
    "accept": "[bn] Accept",
    "reject": "[bn] Reject",
    "cancel": "[bn] Cancel",
    "noFriends": "[bn] No friends yet",
    "noFriendsDesc": "[bn] Search for players and send friend requests",
    "lastGame": "[bn] Last game: {{time}}",
    "friendsSince": "[bn] Friends since {{date}}",
    "incomingRequests": "[bn] Incoming Requests",
    "outgoingRequests": "[bn] Outgoing Requests",
    "noIncoming": "[bn] No incoming requests",
    "noOutgoing": "[bn] No outgoing requests",
    "sentAt": "[bn] Sent {{time}}",
    "searchPlaceholder": "[bn] Search by name...",
    "noResults": "[bn] No players found",
    "noResultsDesc": "[bn] Try searching with a different name",
    "requestSent": "[bn] Friend request sent!",
    "requestAccepted": "[bn] Friend request accepted!",
    "requestRejected": "[bn] Friend request rejected",
    "requestCancelled": "[bn] Friend request cancelled",
    "friendRemoved": "[bn] Friend removed",
    "searchFailed": "[bn] Failed to search users",
    "requestFailed": "[bn] Failed to send request",
    "acceptFailed": "[bn] Failed to accept request",
    "rejectFailed": "[bn] Failed to reject request",
    "cancelFailed": "[bn] Failed to cancel request",
    "removeFailed": "[bn] Failed to remove friend",
    "friendsCount": "[bn] {{count}} friends",
    "gamesCount": "[bn] {{count}} games",
    "alreadyFriends": "[bn] Friends"
  },
  "stats": {
    "statistics": "[bn] Statistics",
    "matchHistory": "[bn] Match History",
    "headToHead": "[bn] Head to Head",
    "gamesPlayed": "[bn] Games Played",
    "wins": "[bn] Wins",
    "losses": "[bn] Losses",
    "draws": "[bn] Draws",
    "winRate": "[bn] Win Rate",
    "rating": "[bn] Rating",
    "peakRating": "[bn] Peak Rating",
    "peak": "[bn] Peak",
    "winStreak": "[bn] Win Streak",
    "currentStreak": "[bn] Current Streak",
    "bestStreak": "[bn] Best Streak",
    "performance": "[bn] Performance",
    "achievements": "[bn] Achievements",
    "currentRating": "[bn] Current Rating",
    "totalGames": "[bn] Total Games",
    "noGames": "[bn] No games played yet",
    "moves": "[bn] moves",
    "won": "[bn] Won",
    "lost": "[bn] Lost",
    "draw": "[bn] Draw",
    "overall": "[bn] Overall Record",
    "yourWins": "[bn] Your Wins",
    "theirWins": "[bn] Their Wins",
    "totalGamesPlayed": "[bn] Total: {{count}} games",
    "recentGames": "[bn] Recent Games"
  },
  "support": {
    "title": "সাপোর্ট সেন্টার",
    "subtitle": "আজ আমরা কীভাবে আপনাকে সাহায্য করতে পারি?",
    "tabs": {
      "docs": "ডকুমেন্টেশন",
      "faq": "FAQ",
      "contact": "যোগাযোগ",
      "tickets": "আমার টিকেট"
    },
    "categories": {
      "title": "[bn] Browse Documentation",
      "loading": "[bn] Loading documentation...",
      "loadError": "[bn] Failed to load categories",
      "articleCount": "[bn] {{count}} articles",
      "gettingStarted": "[bn] Getting Started",
      "features": "[bn] Features",
      "troubleshooting": "[bn] Troubleshooting",
      "account": "[bn] Account"
    },
    "docs": {
      "loading": "[bn] Loading document...",
      "loadError": "[bn] Failed to load document",
      "backToList": "[bn] Back to documentation"
    },
    "search": {
      "placeholder": "[bn] Search documentation...",
      "noResults": "[bn] No results found"
    },
    "faq": {
      "title": "[bn] Frequently Asked Questions",
      "loading": "[bn] Loading FAQ...",
      "loadError": "[bn] Failed to load FAQ",
      "empty": "[bn] No FAQ items in this category",
      "categories": {
        "all": "[bn] All Topics",
        "general": "[bn] General",
        "billing": "[bn] Billing",
        "technical": "[bn] Technical",
        "features": "[bn] Features"
      }
    },
    "contact": {
      "voiceTitle": "[bn] Voice Support",
      "voiceDescription": "[bn] Click the avatar button or say \"Jarvis\" to start a voice conversation with our AI assistant.",
      "ticketTitle": "[bn] Create Support Ticket",
      "ticketDescription": "[bn] Need human assistance? Create a support ticket and our team will respond within 24 hours.",
      "createTicket": "[bn] Create Ticket",
      "emailTitle": "[bn] Email Support",
      "emailDescription": "[bn] Prefer email? Reach us at support@bayit.tv for any questions or concerns."
    },
    "ticket": {
      "title": "[bn] Create Support Ticket",
      "subject": "[bn] Subject",
      "subjectPlaceholder": "[bn] Brief description of your issue",
      "message": "[bn] Message",
      "messagePlaceholder": "[bn] Describe your issue in detail...",
      "categoryLabel": "[bn] Category",
      "priorityLabel": "[bn] Priority",
      "submit": "[bn] Submit Ticket",
      "category": {
        "billing": "[bn] Billing",
        "technical": "[bn] Technical",
        "feature": "[bn] Feature Request",
        "general": "[bn] General"
      },
      "priority": {
        "low": "[bn] Low",
        "medium": "[bn] Medium",
        "high": "[bn] High",
        "urgent": "[bn] Urgent"
      },
      "status": {
        "open": "[bn] Open",
        "in_progress": "[bn] In Progress",
        "resolved": "[bn] Resolved",
        "closed": "[bn] Closed"
      },
      "created": "[bn] Created",
      "error": {
        "required": "[bn] Please fill in all required fields",
        "submit": "[bn] Failed to create ticket. Please try again."
      }
    },
    "tickets": {
      "title": "[bn] My Support Tickets",
      "loading": "[bn] Loading tickets...",
      "loadError": "[bn] Failed to load tickets",
      "empty": "[bn] No support tickets yet",
      "emptyFilter": "[bn] No tickets with this status",
      "create": "[bn] New Ticket",
      "createFirst": "[bn] Create Your First Ticket",
      "filter": {
        "all": "[bn] All",
        "open": "[bn] Open",
        "inProgress": "[bn] In Progress",
        "resolved": "[bn] Resolved"
      }
    },
    "voice": {
      "title": "[bn] Voice Assistant",
      "listening": "[bn] I'm listening...",
      "thinking": "[bn] Let me think about that...",
      "speaking": "[bn] Speaking...",
      "error": "[bn] Sorry, I didn't catch that. Try again?",
      "ready": "[bn] What would you like to know?",
      "listeningNow": "[bn] Listening...",
      "wakeWordHint": "[bn] Say \"Jarvis\" to speak"
    },
    "wizard": {
      "role": "[bn] Your Guide"
    }
  },
  "jerusalem": {
    "title": "[bn] Jerusalem Connection",
    "subtitle": "[bn] Stay connected to the heart of Israel",
    "noContent": "[bn] No Jerusalem content available",
    "sources": "[bn] Sources",
    "kotelLive": "[bn] Western Wall Live",
    "categories": {
      "kotel": "[bn] Western Wall",
      "idf-ceremony": "[bn] IDF Ceremonies",
      "diaspora-connection": "[bn] Diaspora Connection",
      "holy-sites": "[bn] Holy Sites",
      "jerusalem-events": "[bn] Jerusalem Events",
      "general": "[bn] Jerusalem"
    }
  },
  "telAviv": {
    "title": "[bn] Tel Aviv Connection",
    "subtitle": "[bn] The city that never stops",
    "noContent": "[bn] No Tel Aviv content available",
    "sources": "[bn] Sources",
    "beachLive": "[bn] Beach Webcam",
    "categories": {
      "beaches": "[bn] Beaches",
      "nightlife": "[bn] Nightlife",
      "culture": "[bn] Culture & Art",
      "music": "[bn] Music Scene",
      "food": "[bn] Food & Dining",
      "tech": "[bn] Tech & Startups",
      "events": "[bn] Events",
      "general": "[bn] Tel Aviv"
    }
  },
  "voiceOnboarding": {
    "welcome": {
      "title": "[bn] Welcome to Voice Control",
      "description": "[bn] Control Bayit+ with your voice for a hands-free experience."
    },
    "features": {
      "voiceCommands": "ভয়েস কমান্ড",
      "voiceCommandsDesc": "স্বাভাবিক কথার মাধ্যমে নেভিগেট করুন, অনুসন্ধান করুন এবং প্লেব্যাক নিয়ন্ত্রণ করুন",
      "tts": "টেক্সট-টু-স্পিচ",
      "ttsDesc": "উচ্চস্বরে প্রতিক্রিয়া এবং বিষয়বস্তু বিবরণ শুনুন",
      "wakeWord": "ওয়েক ওয়ার্ড",
      "wakeWordDesc": "যেকোনো সময় ভয়েস কন্ট্রোল সক্রিয় করতে 'Bayit' বলুন"
    },
    "getStarted": "শুরু করুন",
    "permissions": {
      "title": "মাইক্রোফোন অ্যাক্সেস",
      "description": "আপনার কমান্ড শুনতে ভয়েস কন্ট্রোলের জন্য মাইক্রোফোন অ্যাক্সেস প্রয়োজন",
      "privacy": "আপনার ভয়েস ডেটা নিরাপদে প্রক্রিয়া করা হয় এবং কখনও সংরক্ষণ করা হয় না"
    },
    "permissionsGranted": "মাইক্রোফোন অ্যাক্সেস দেওয়া হয়েছে",
    "permissionRequired": {
      "title": "অনুমতি প্রয়োজন",
      "message": "ভয়েস কন্ট্রোল ব্যবহার করতে আপনার ডিভাইস সেটিংসে মাইক্রোফোন অ্যাক্সেস সক্ষম করুন"
    },
    "grantPermissions": "অনুমতি দিন",
    "testWakeWord": {
      "title": "ওয়েক ওয়ার্ড পরীক্ষা করুন",
      "description": "ভয়েস অ্যাক্টিভেশন পরীক্ষা করতে 'Bayit' বলুন",
      "success": "চমৎকার! ভয়েস অ্যাক্টিভেশন কাজ করছে"
    },
    "startTest": "পরীক্ষা শুরু করুন",
    "complete": {
      "title": "সব প্রস্তুত!",
      "description": "ভয়েস কন্ট্রোল এখন সক্রিয়। এই কমান্ডগুলি চেষ্টা করুন:",
      "tryCommands": "এই কমান্ডগুলি চেষ্টা করুন",
      "examples": {
        "search": "\"Fauda খুঁজুন\"",
        "play": "\"সংবাদ চালান\"",
        "navigate": "\"লাইভ টিভিতে যান\"",
        "control": "\"থামুন\" বা \"ভলিউম বাড়ান\""
      },
      "startUsing": "ভয়েস কন্ট্রোল ব্যবহার শুরু করুন"
    },
    "skip": "এখন এড়িয়ে যান",
    "buttons": {
      "back": "[bn] Back"
    },
    "completion": {
      "message": "[bn] Voice features are ready to use.",
      "title": "[bn] Voice Setup Complete"
    },
    "title": "[bn] Voice Setup",
    "training": {
      "message": "[bn] Read the phrases aloud to train voice recognition.",
      "title": "[bn] Voice Training"
    }
  },
  "taxonomy": {
    "sections": {
      "movies": "[bn] Movies",
      "series": "[bn] Series",
      "kids": "[bn] Kids",
      "youngsters": "[bn] Youngsters",
      "music": "[bn] Music",
      "documentaries": "[bn] Documentaries",
      "podcasts": "[bn] Podcasts",
      "live": "[bn] Live TV"
    },
    "subcategories": {
      "learning-hebrew": "[bn] Learning Hebrew",
      "young-science": "[bn] Young Science",
      "math-fun": "[bn] Fun Math",
      "nature-animals": "[bn] Nature & Animals",
      "interactive": "[bn] Interactive",
      "hebrew-songs": "[bn] Hebrew Songs",
      "nursery-rhymes": "[bn] Nursery Rhymes",
      "kids-movies": "[bn] Kids Movies",
      "kids-series": "[bn] Kids Series",
      "jewish-holidays": "[bn] Jewish Holidays",
      "torah-stories": "[bn] Torah Stories",
      "bedtime-stories": "[bn] Bedtime Stories",
      "tiktok-trends": "[bn] TikTok Trends",
      "viral-videos": "[bn] Viral Videos",
      "memes": "[bn] Memes",
      "israel-news": "[bn] Israel News",
      "world-news": "[bn] World News",
      "science-news": "[bn] Science News",
      "sports-news": "[bn] Sports News",
      "music-culture": "[bn] Music Culture",
      "film-culture": "[bn] Film Culture",
      "art-culture": "[bn] Art Culture",
      "food-culture": "[bn] Food Culture",
      "study-help": "[bn] Study Help",
      "career-prep": "[bn] Career Prep",
      "life-skills": "[bn] Life Skills",
      "teen-movies": "[bn] Teen Movies",
      "teen-series": "[bn] Teen Series",
      "gaming": "[bn] Gaming",
      "coding": "[bn] Coding",
      "gadgets": "[bn] Gadgets",
      "bar-bat-mitzvah": "[bn] Bar/Bat Mitzvah",
      "teen-torah": "[bn] Teen Torah",
      "jewish-history": "[bn] Jewish History",
      "learning-hebrew.description": "শিশুদের জন্য হিব্রুতে পড়া, লেখা এবং শব্দভাণ্ডার শেখা",
      "young-science.description": "শিশুদের জন্য উপযোগী পরীক্ষা-নিরীক্ষা এবং বৈজ্ঞানিক ব্যাখ্যা",
      "math-fun.description": "মজাদার এবং খেলাধুলার মাধ্যমে সংখ্যা ও গণিত শেখা",
      "nature-animals.description": "কৌতূহলী শিশুদের জন্য প্রাণী ও প্রকৃতির জগত",
      "interactive.description": "শিশুদের জন্য ইন্টারঅ্যাক্টিভ এবং অংশগ্রহণমূলক বিষয়বস্তু",
      "hebrew-songs.description": "ক্লাসিক এবং নতুন ইসরায়েলি শিশুদের গান",
      "nursery-rhymes.description": "ছোট শিশু এবং বাচ্চাদের জন্য গান ও সুর",
      "kids-movies.description": "শিশুদের জন্য উপযুক্ত পূর্ণদৈর্ঘ্য চলচ্চিত্র",
      "kids-series.description": "শিশুদের জন্য অ্যানিমেটেড সিরিজ এবং টিভি শো",
      "jewish-holidays.description": "শিশুদের জন্য ইহুদি ছুটি এবং ঐতিহ্য সম্পর্কে বিষয়বস্তু",
      "torah-stories.description": "তোরাহ এবং ইহুদি ঐতিহ্য থেকে গল্প",
      "bedtime-stories.description": "ঘুমানোর সময়ের জন্য আরামদায়ক গল্প",
      "tiktok-trends.description": "TikTok-এ জনপ্রিয় ট্রেন্ড এবং চ্যালেঞ্জ",
      "viral-videos.description": "সোশ্যাল মিডিয়ায় জনপ্রিয় ভাইরাল ভিডিও",
      "memes.description": "মজার মিম এবং ইন্টারনেট সংস্কৃতি",
      "israel-news.description": "কিশোরদের জন্য উপযোগী ইসরায়েল সংবাদ",
      "world-news.description": "যুবকদের জন্য আন্তর্জাতিক সংবাদ",
      "science-news.description": "বৈজ্ঞানিক আবিষ্কার এবং প্রযুক্তিগত উদ্ভাবন",
      "sports-news.description": "খেলাধুলার আপডেট এবং খেলার ফলাফল",
      "music-culture.description": "সংগীত জগত, শিল্পী এবং উৎসব",
      "film-culture.description": "সিনেমা, সিরিজ এবং পর্যালোচনা",
      "art-culture.description": "শিল্প, গ্যালারি এবং সৃজনশীলতা",
      "food-culture.description": "রান্না, রেসিপি এবং খাদ্য সংস্কৃতি",
      "study-help.description": "পরীক্ষা, সারাংশ এবং পরীক্ষার প্রস্তুতিতে সাহায্য",
      "career-prep.description": "বিশ্ববিদ্যালয় এবং কর্মজীবনের প্রস্তুতি",
      "life-skills.description": "জীবন দক্ষতা, অর্থ ব্যবস্থাপনা এবং স্বাধীনতা",
      "teen-movies.description": "কিশোরদের জন্য প্রস্তাবিত চলচ্চিত্র",
      "teen-series.description": "কিশোরদের জন্য জনপ্রিয় সিরিজ",
      "gaming.description": "ভিডিও গেম, ই-স্পোর্টস এবং গেমিং",
      "coding.description": "প্রোগ্রামিং, কোডিং এবং সফটওয়্যার উন্নয়ন",
      "gadgets.description": "গ্যাজেট, প্রযুক্তি এবং পর্যালোচনা",
      "bar-bat-mitzvah.description": "বার/বাত মিৎজভা প্রস্তুতি এবং উদযাপন",
      "teen-torah.description": "কিশোরদের জন্য তোরাহ পাঠ এবং সাপ্তাহিক পরশা",
      "jewish-history.description": "ইহুদি জনগণের ইতিহাস"
    }
  },
  "passkey": {
    "manager": {
      "title": "[bn] Passkeys",
      "subtitle": "[bn] Manage your passkeys for secure content access"
    },
    "unsupported": "[bn] Passkeys are not supported on this device",
    "fetchError": "[bn] Failed to load passkeys",
    "registerError": "[bn] Failed to register passkey",
    "deleteError": "[bn] Failed to delete passkey",
    "cancelled": "[bn] Passkey operation was cancelled",
    "noPasskeys": "[bn] No passkeys registered yet. Add one to unlock private content.",
    "unknownDevice": "[bn] Unknown Device",
    "created": "[bn] Created",
    "lastUsed": "[bn] Last used",
    "never": "[bn] Never",
    "addPasskey": "[bn] Add Passkey",
    "deleteConfirmTitle": "[bn] Delete Passkey?",
    "deleteConfirmText": "[bn] This passkey will no longer be able to unlock content. You can always add it again later.",
    "unlock": "[bn] Unlock",
    "unlockContent": "[bn] Unlock Private Content",
    "unlockDescription": "[bn] Use your passkey to access private movies and series",
    "auth": {
      "title": "[bn] Unlock Content",
      "description": "[bn] Use your fingerprint, face, or device PIN to unlock private movies and series.",
      "unlock": "[bn] Unlock with Passkey",
      "authenticating": "[bn] Authenticating...",
      "success": "[bn] Content Unlocked!",
      "cancelled": "[bn] Authentication was cancelled",
      "error": "[bn] Authentication failed. Please try again."
    },
    "qr": {
      "useQR": "[bn] Use Phone to Unlock",
      "scanWithPhone": "[bn] Scan with your phone",
      "instruction": "[bn] Open the camera on your phone and scan the QR code to authenticate",
      "error": "[bn] Failed to generate QR code",
      "expired": "[bn] QR code expired. Please try again."
    }
  },
  "olorin": {
    "errors": {
      "session_not_found": "[bn] Session not found",
      "session_different_partner": "[bn] Session belongs to different partner",
      "session_invalid_status": "[bn] Session is {status}, cannot add transcript",
      "max_sessions_reached": "[bn] Maximum concurrent sessions ({limit}) reached",
      "invalid_api_key": "[bn] Invalid API key",
      "missing_api_key": "[bn] Missing {header} header",
      "capability_disabled": "[bn] Capability '{capability}' is currently disabled",
      "capability_not_enabled": "[bn] Capability '{capability}' not enabled for this partner",
      "source_language_not_supported": "[bn] Source language '{language}' not supported. Supported: {supported}",
      "target_language_not_supported": "[bn] Target language '{language}' not supported. Supported: {supported}",
      "partner_not_found": "[bn] Partner not found",
      "partner_registration_failed": "[bn] Failed to register partner",
      "no_updates_provided": "[bn] No updates provided",
      "webhook_config_failed": "[bn] Failed to configure webhook",
      "webhook_url_not_configured": "[bn] Webhook URL not configured",
      "webhook_secret_not_configured": "[bn] Webhook secret not configured",
      "search_failed": "[bn] Search failed",
      "indexing_failed": "[bn] Indexing failed",
      "detection_failed": "[bn] Detection failed",
      "explanation_failed": "[bn] Failed to get explanation",
      "reference_not_found": "[bn] Reference '{reference_id}' not found",
      "enrichment_failed": "[bn] Enrichment failed",
      "get_references_failed": "[bn] Failed to get references",
      "create_session_failed": "[bn] Failed to create session",
      "add_transcript_failed": "[bn] Failed to add transcript",
      "generate_recap_failed": "[bn] Failed to generate recap"
    }
  },
  "portal": {
    "nav": {
      "home": "হোম",
      "features": "বৈশিষ্ট্য",
      "solutions": "সমাধান",
      "pricing": "মূল্য নির্ধারণ",
      "demo": "লাইভ ডেমো",
      "contact": "যোগাযোগ",
      "getStarted": "শুরু করুন"
    },
    "hero": {
      "ctaExplore": "বৈশিষ্ট্য দেখুন",
      "ctaDemo": "ডেমো অনুরোধ করুন"
    },
    "cta": {
      "title": "শুরু করতে প্রস্তুত?",
      "subtitle": "আসুন আলোচনা করি কীভাবে আমরা আপনার ব্যবসা রূপান্তরিত করতে সাহায্য করতে পারি",
      "button": "আমাদের সাথে যোগাযোগ করুন"
    },
    "contactPage": {
      "title": "যোগাযোগ করুন",
      "subtitle": "আমাদের সমাধানে আগ্রহী? আসুন কথা বলি",
      "formTitle": "আমাদের একটি বার্তা পাঠান",
      "infoTitle": "যোগাযোগের তথ্য",
      "form": {
        "name": "সম্পূর্ণ নাম",
        "email": "ইমেল ঠিকানা",
        "company": "কোম্পানির নাম",
        "phone": "ফোন নম্বর",
        "message": "আপনার বার্তা",
        "messagePlaceholder": "আপনার প্রয়োজন সম্পর্কে আমাদের বলুন..."
      },
      "submit": "বার্তা পাঠান",
      "sending": "পাঠানো হচ্ছে...",
      "success": "বার্তা সফলভাবে পাঠানো হয়েছে! আমরা শীঘ্রই আপনার সাথে যোগাযোগ করব।",
      "error": "বার্তা পাঠাতে ব্যর্থ। অনুগ্রহ করে পুনরায় চেষ্টা করুন।",
      "scheduleTitle": "কল শিডিউল করতে পছন্দ করেন?",
      "scheduleSubtitle": "আমাদের দলের সাথে একটি ব্যক্তিগত ডেমো বুক করুন",
      "scheduleCta": "ডেমো কল শিডিউল করুন"
    },
    "pricingPage": {
      "title": "সাশ্রয়ী",
      "titleHighlight": "মূল্য পরিকল্পনা",
      "subtitle": "আপনার প্রয়োজন অনুসারে পরিকল্পনা চয়ন করুন",
      "comparisonTitle": "বৈশিষ্ট্য তুলনা",
      "faqTitle": "প্রায়শই জিজ্ঞাসিত প্রশ্ন",
      "faq": {
        "q1": "মূল্য নির্ধারণ কীভাবে গণনা করা হয়?",
        "a1": "মূল্য নির্ধারণ আপনার নির্দিষ্ট প্রয়োজন এবং ব্যবহারের উপর ভিত্তি করে। কাস্টম উদ্ধৃতির জন্য আমাদের সাথে যোগাযোগ করুন।",
        "q2": "আমি কি পরে আমার পরিকল্পনা আপগ্রেড করতে পারি?",
        "a2": "হ্যাঁ, আপনি যেকোনো সময় আপগ্রেড করতে পারেন। আমরা আপনার ডেটা নির্বিঘ্নে স্থানান্তরিত করতে সাহায্য করব।",
        "q3": "কোন সমর্থন অন্তর্ভুক্ত?",
        "a3": "সমস্ত পরিকল্পনায় ইমেল সমর্থন অন্তর্ভুক্ত। পেশাদার এবং এন্টারপ্রাইজ পরিকল্পনায় নিবেদিত অ্যাকাউন্ট ম্যানেজারদের সাথে অগ্রাধিকার সমর্থন অন্তর্ভুক্ত।"
      },
      "professional": {
        "name": "পেশাদার",
        "price": "উদ্ধৃতির জন্য যোগাযোগ করুন",
        "priceNote": "কাস্টম মূল্য নির্ধারণ",
        "description": "উন্নত প্রয়োজন সহ ক্রমবর্ধমান ব্যবসার জন্য",
        "cta": "উদ্ধৃতি পান"
      },
      "enterprise": {
        "name": "এন্টারপ্রাইজ",
        "price": "কাস্টম",
        "priceNote": "ভলিউম ভিত্তিক",
        "description": "বড় সংস্থা এবং এন্টারপ্রাইজ স্থাপনার জন্য",
        "cta": "বিক্রয়ের সাথে যোগাযোগ করুন"
      },
      "ctaTitle": "শুরু করতে প্রস্তুত?",
      "ctaSubtitle": "আসুন আপনার প্রয়োজনীয়তা নিয়ে আলোচনা করি এবং নিখুঁত পরিকল্পনা খুঁজে পাই",
      "ctaButton": "বিক্রয়ের সাথে যোগাযোগ করুন"
    },
    "featuresPage": {
      "title": "শক্তিশালী",
      "titleHighlight": "বৈশিষ্ট্য",
      "subtitle": "সফল হওয়ার জন্য আপনার যা প্রয়োজন সব",
      "techSpecsTitle": "প্রযুক্তিগত স্পেসিফিকেশন",
      "workflowTitle": "এটি কিভাবে কাজ করে",
      "workflow": {
        "s1": {
          "title": "আমদানি",
          "description": "আপনার সামগ্রী আপলোড এবং সংগঠিত করুন"
        },
        "s2": {
          "title": "কনফিগার করুন",
          "description": "আপনার পছন্দ এবং সেটিংস সেট করুন"
        },
        "s3": {
          "title": "স্থাপন করুন",
          "description": "আপনার সমাধান নিয়ে লাইভ যান"
        },
        "s4": {
          "title": "মনিটর করুন",
          "description": "কর্মক্ষমতা ট্র্যাক এবং অপ্টিমাইজ করুন"
        }
      },
      "ctaTitle": "বৈশিষ্ট্য অন্বেষণ করতে প্রস্তুত?",
      "ctaSubtitle": "ব্যক্তিগত ডেমো সহ কর্মে সমস্ত বৈশিষ্ট্য দেখুন",
      "ctaButton": "ডেমো শিডিউল করুন"
    },
    "demoPage": {
      "title": "আমাদের দেখুন",
      "titleHighlight": "প্ল্যাটফর্ম",
      "subtitle": "আমাদের সমাধানের শক্তি অনুভব করুন",
      "scheduleCta": "লাইভ ডেমো শিডিউল করুন",
      "stepsTitle": "এটি কিভাবে কাজ করে",
      "steps": {
        "analyze": {
          "title": "বিশ্লেষণ করুন",
          "description": "কর্মক্ষমতা ট্র্যাক এবং উন্নত করুন"
        }
      },
      "featuresTitle": "প্ল্যাটফর্ম হাইলাইট",
      "platformsTitle": "উপলব্ধ",
      "ctaTitle": "আপনার কাস্টম ডেমোর জন্য প্রস্তুত?",
      "ctaSubtitle": "আপনার প্রয়োজন অনুসারে একটি ব্যক্তিগত প্রদর্শন শিডিউল করুন",
      "ctaButton": "ডেমো শিডিউল করুন"
    },
    "workflow": {
      "sectionTitle": "বুদ্ধিমান ওয়ার্কফ্লো",
      "sectionSubtitle": "৪ ধাপে সুবিন্যস্ত প্রক্রিয়া",
      "step1": {
        "title": "সেটআপ",
        "description": "আপনার অ্যাকাউন্ট এবং পছন্দ কনফিগার করুন"
      },
      "step2": {
        "title": "কাস্টমাইজ করুন",
        "description": "আপনার প্রয়োজনের জন্য সেটিংস কাস্টমাইজ করুন"
      },
      "step3": {
        "title": "স্থাপন করুন",
        "description": "আপনার সমাধান চালু করুন"
      },
      "step4": {
        "title": "মনিটর করুন",
        "description": "কর্মক্ষমতা ট্র্যাক এবং অপ্টিমাইজ করুন"
      }
    }
  },
  "trivia": {
    "didYouKnow": "আপনি কি জানেন?",
    "dismissHint": "তথ্য বন্ধ করুন",
    "settings": {
      "displayLanguages": "প্রদর্শন ভাষা",
      "languageHint": "প্রতিটি তথ্যের জন্য 1-3টি ভাষা নির্বাচন করুন",
      "language": "ভাষা",
      "selectLanguage": "এই ভাষা নির্বাচন করুন",
      "deselectLanguage": "এই ভাষা অনির্বাচন করুন",
      "enableDescription": "[bn] Show trivia questions while watching content.",
      "enableTrivia": "[bn] Enable Trivia",
      "title": "[bn] Trivia Settings"
    },
    "aiTrivia": "AI ট্রিভিয়া",
    "tellMeMore": "আরও বলুন",
    "more": "আরও",
    "follow_up": "অনুসরণ করুন"
  },
  "auth": {
    "loginRequired": "[bn] Login Required",
    "loginToWatch": "[bn] Please sign in to watch {{title}}",
    "login": "[bn] Login",
    "signUp": "[bn] Sign Up",
    "biometricEnrollEnable": "[bn] Enable",
    "biometricEnrollMessage": "[bn] Use Face ID or fingerprint for faster sign-in next time.",
    "biometricEnrollSkip": "[bn] Skip",
    "biometricEnrollTitle": "[bn] Enable Biometric Sign-In",
    "biometricSignIn": "[bn] Sign in with Biometrics",
    "signOut": "[bn] Sign Out",
    "register": {
      "createAccount": "অ্যাকাউন্ট তৈরি করুন",
      "email": "ইমেইল",
      "password": "পাসওয়ার্ড",
      "confirmPassword": "পাসওয়ার্ড নিশ্চিত করুন",
      "register": "নিবন্ধন",
      "alreadyHaveAccount": "ইতিমধ্যে অ্যাকাউন্ট আছে? সাইন ইন করুন",
      "passwordStrength": {
        "weak": "দুর্বল",
        "medium": "মাঝারি",
        "strong": "শক্তিশালী"
      }
    }
  },
  "recording": {
    "stop": "রেকর্ডিং বন্ধ করুন",
    "start": "রেকর্ডিং শুরু করুন"
  },
  "discover": {
    "title": "[bn] Discover",
    "subtitle": "১৯টি AI-চালিত বৈশিষ্ট্য অন্বেষণ করুন",
    "description": "Bayit+ আপনার দেখা, শোনা এবং শেখার অভিজ্ঞতা উন্নত করতে AI ব্যবহার করে। আপনার প্ল্যাটফর্মে কী পাওয়া যায় তা আবিষ্কার করুন।",
    "featureCount": "{{count}}টি বৈশিষ্ট্য",
    "tryIt": "চেষ্টা করুন",
    "startWalkthrough": "ওয়াকথ্রু শুরু করুন",
    "availableOn": "এতে পাওয়া যায়",
    "prerequisites": "পূর্বশর্তসমূহ",
    "setup": "সেট আপ করুন",
    "error": {
      "fetchFailed": "Discover বৈশিষ্ট্য লোড করতে ব্যর্থ হয়েছে। আবার চেষ্টা করুন।",
      "unknownFeature": "বৈশিষ্ট্য পাওয়া যায়নি।",
      "featureDisabled": "এই বৈশিষ্ট্যটি বর্তমানে অক্ষম।"
    },
    "availability": {
      "ready": "প্রস্তুত",
      "setupNeeded": "সেটআপ প্রয়োজন",
      "premiumRequired": "প্রিমিয়াম প্রয়োজন",
      "notAvailable": "পাওয়া যাচ্ছে না",
      "platformOnly": "অন্য প্ল্যাটফর্ম"
    },
    "platform": {
      "web": "Web",
      "ios": "iOS",
      "android": "Android",
      "tvos": "Apple TV"
    },
    "category": {
      "watching_movies": "সিনেমা দেখা",
      "watching_live_tv": "লাইভ টিভি দেখা",
      "learn_hebrew": "হিব্রু শিখুন",
      "search_discovery": "অনুসন্ধান ও আবিষ্কার",
      "chat_assistants": "চ্যাট সহকারী"
    },
    "feature": {
      "pause_ask": {
        "name": "বিরতি দিন ও জিজ্ঞাসা করুন",
        "tagline": "যেকোনো দৃশ্য বিরাম দিন এবং আপনার AI সঙ্গীকে জিজ্ঞাসা করুন",
        "description": "দেখার সময় ভিডিও বিরতি দিন এবং বর্তমান দৃশ্য সম্পর্কে প্রশ্ন করুন। আপনার AI চরিত্র সাংস্কৃতিক প্রসঙ্গ ব্যাখ্যা করবে, সংলাপ অনুবাদ করবে বা কাহিনী নিয়ে আলোচনা করবে।"
      },
      "interactive_subtitles": {
        "name": "ইন্টারেক্টিভ সাবটাইটেল",
        "tagline": "তাৎক্ষণিক অনুবাদ ও প্রেক্ষাপটের জন্য যেকোনো সাবটাইটেল শব্দ স্পর্শ করুন",
        "description": "সাবটাইটেলে যেকোনো শব্দে ক্লিক করুন এর অনুবাদ দেখতে, উচ্চারণ শুনতে এবং ব্যবহারের উদাহরণ পেতে। আপনার পছন্দের শো দেখার সময় শব্দভান্ডার তৈরি করুন।"
      },
      "vocabulary": {
        "name": "শব্দভান্ডার নির্মাতা",
        "tagline": "আপনি যে শো দেখেন সেখান থেকে নতুন শব্দ শিখুন",
        "description": "সাবটাইটেল থেকে স্বয়ংক্রিয়ভাবে নতুন হিব্রু শব্দ সংগ্রহ করুন। ফ্ল্যাশকার্ড পর্যালোচনা করুন, অগ্রগতি ট্র্যাক করুন এবং আপনার উপভোগের বিষয়বস্তুর মাধ্যমে শব্দভান্ডার তৈরি করুন।"
      },
      "vod_moments": {
        "name": "VOD মুহূর্ত",
        "tagline": "আপনার পছন্দের বিষয়বস্তু থেকে AI-কিউরেটেড হাইলাইট",
        "description": "চলচ্চিত্র ও শো থেকে AI-তৈরি হাইলাইট ক্লিপ ও মূল মুহূর্ত পান। স্মরণীয় দৃশ্য শেয়ার করুন এবং সেরা অংশগুলো আবার দেখুন।"
      },
      "cultural_context": {
        "name": "সাংস্কৃতিক প্রেক্ষাপট",
        "tagline": "প্রতিটি দৃশ্যের পেছনের সাংস্কৃতিক পটভূমি বুঝুন",
        "description": "আপনি যে বিষয়বস্তু দেখেন তাতে উপস্থিত ইসরায়েলি রীতিনীতি, উৎসব, হাস্যরস এবং সামাজিক নিয়মকানুন ব্যাখ্যা করে রিয়েল-টাইম সাংস্কৃতিক টীকা পান।"
      },
      "bilingual_bridge": {
        "name": "দ্বিভাষিক সেতু",
        "tagline": "দেখার সময় পাশাপাশি হিব্রু-বাংলা শেখা",
        "description": "হাইলাইট করা শব্দভান্ডার সহ দ্বৈত-ভাষা সাবটাইটেল দেখুন। স্বাভাবিকভাবে বোঝার দক্ষতা বিকাশের জন্য হিব্রু এবং আপনার মাতৃভাষার মধ্যে পরিবর্তন করুন।"
      },
      "ai_companion": {
        "name": "AI সঙ্গী",
        "tagline": "ইসরায়েলি বিষয়বস্তুর মাধ্যমে আপনার ব্যক্তিগত AI গাইড",
        "description": "একটি AI চরিত্র যা আপনার সাথে দেখে, মন্তব্য প্রদান করে, প্রশ্নের উত্তর দেয় এবং ইসরায়েলি মিডিয়ার সূক্ষ্মতা বুঝতে সাহায্য করে।"
      },
      "live_dubbing": {
        "name": "লাইভ ডাবিং",
        "tagline": "লাইভ ইসরায়েলি টিভি চ্যানেলের রিয়েল-টাইম AI ডাবিং",
        "description": "আপনার পছন্দের ভাষায় AI-চালিত রিয়েল-টাইম ডাবিং সহ লাইভ ইসরায়েলি টিভি দেখুন। ভাষার বাধা ছাড়াই সংবাদ, টক শো এবং বিনোদন উপভোগ করুন।"
      },
      "live_subtitles": {
        "name": "লাইভ সাবটাইটেল",
        "tagline": "লাইভ সম্প্রচারের জন্য রিয়েল-টাইম AI সাবটাইটেল",
        "description": "লাইভ ইসরায়েলি টিভি দেখার সময় রিয়েল-টাইমে AI-তৈরি সাবটাইটেল পান। লাইভ বিষয়বস্তুর তাৎক্ষণিক অনুবাদের জন্য আপনার পছন্দের ভাষা বেছে নিন।"
      },
      "live_trivia": {
        "name": "লাইভ ট্রিভিয়া",
        "tagline": "সরাসরি সম্প্রচারিত বিষয়বস্তুর উপর ট্রিভিয়া খেলুন",
        "description": "AI লাইভ সম্প্রচার থেকে বিষয় শনাক্ত করে রিয়েল-টাইমে ট্রিভিয়া প্রশ্ন তৈরি করে। বন্ধুদের সাথে প্রতিযোগিতা করুন এবং টিভি দেখার সময় ইসরায়েলি সংস্কৃতি সম্পর্কে জানুন।"
      },
      "catch_up": {
        "name": "ক্যাচ আপ",
        "tagline": "লাইভ টিভিতে যা মিস করেছেন তার AI সারসংক্ষেপ",
        "description": "একটি লাইভ সম্প্রচারের অংশ মিস করেছেন? AI-তৈরি সারসংক্ষেপ পান যা আপনাকে কী ঘটেছে তা জানাবে, দ্রুত পর্যালোচনার জন্য মূল মুহূর্তগুলো হাইলাইট করা আছে।"
      },
      "scene_search": {
        "name": "দৃশ্য অনুসন্ধান",
        "tagline": "সমস্ত বিষয়বস্তু জুড়ে নির্দিষ্ট দৃশ্য খুঁজুন",
        "description": "আপনার মনে থাকা একটি দৃশ্য বর্ণনা করুন এবং AI সমস্ত উপলব্ধ বিষয়বস্তু জুড়ে তা খুঁজে পাবে। সংলাপ, দৃশ্যমান উপাদান বা কাহিনীর বর্ণনা দিয়ে অনুসন্ধান করুন।"
      },
      "phonetic_mirror": {
        "name": "ফোনেটিক মিরর",
        "tagline": "AI ফিডব্যাকের মাধ্যমে হিব্রু উচ্চারণ অনুশীলন করুন",
        "description": "হিব্রু বলতে বলতে নিজেকে রেকর্ড করুন এবং উচ্চারণ সম্পর্কে তাৎক্ষণিক AI ফিডব্যাক পান। দেশীয় বক্তাদের সাথে আপনার কথা তুলনা করুন এবং সময়ের সাথে উন্নতি ট্র্যাক করুন।"
      },
      "talk_back": {
        "name": "টক ব্যাক",
        "tagline": "আপনার AI চরিত্রের সাথে হিব্রুতে ভয়েস কথোপকথন করুন",
        "description": "আপনার AI চরিত্রের সাথে কথা বলে কথোপকথনমূলক হিব্রু অনুশীলন করুন। স্বাভাবিক কথোপকথনে ব্যাকরণ, শব্দভান্ডার এবং উচ্চারণ সম্পর্কে রিয়েল-টাইম ফিডব্যাক পান।"
      },
      "interactive_mission": {
        "name": "ইন্টারেক্টিভ মিশন",
        "tagline": "AI গাইডেন্সের সাথে মজাদার হিব্রু শেখার চ্যালেঞ্জ",
        "description": "AI-পরিচালিত মিশন সম্পন্ন করুন যা বিষয়বস্তু দেখার সাথে হিব্রু শেখার অনুশীলনকে একত্রিত করে। পুরস্কার অর্জন করুন এবং আপনার ভাষা যাত্রা ট্র্যাক করুন।"
      },
      "glossary": {
        "name": "ব্যক্তিগত শব্দকোষ",
        "tagline": "বিষয়বস্তু থেকে তৈরি আপনার ব্যক্তিগতকৃত হিব্রু অভিধান",
        "description": "আপনি যে সমস্ত হিব্রু শব্দের সম্মুখীন হয়েছেন এবং সংরক্ষণ করেছেন, বিভাগ, ফ্রিকোয়েন্সি এবং দক্ষতার স্তর অনুযায়ী সংগঠিত। যেকোনো সময় পর্যালোচনা করুন এবং অনুশীলন করুন।"
      },
      "llm_search": {
        "name": "AI অনুসন্ধান",
        "tagline": "স্বাভাবিক ভাষার প্রশ্ন দিয়ে বিষয়বস্তু খুঁজুন",
        "description": "স্বাভাবিক ভাষা ব্যবহার করে সম্পূর্ণ Bayit+ লাইব্রেরি অনুসন্ধান করুন। 'পরিবার নিয়ে মজাদার ইসরায়েলি কমেডি' বা 'তেল আবিব সম্পর্কে ডকুমেন্টারি' চাইতে পারেন এবং AI-কিউরেটেড ফলাফল পান।"
      },
      "proactive_voice": {
        "name": "সক্রিয় কণ্ঠ",
        "tagline": "কণ্ঠ-প্রথম AI সহকারী যা আপনার প্রয়োজন আগে থেকে বোঝে",
        "description": "একটি AI সহকারী যা শোনে এবং আপনি যা দেখছেন তার উপর ভিত্তি করে সক্রিয়ভাবে প্রাসঙ্গিক বিষয়বস্তুর পরামর্শ, অনুবাদ এবং শেখার সুযোগ প্রদান করে।"
      },
      "chatbot": {
        "name": "বাইত চ্যাট",
        "tagline": "ইসরায়েলি বিষয়বস্তু সংক্রান্ত যেকোনো বিষয়ে AI-এর সাথে চ্যাট করুন",
        "description": "ইসরায়েলি সংস্কৃতি সম্পর্কে প্রশ্ন করুন, বিষয়বস্তুর সুপারিশ পান, হিব্রু অনুশীলন করুন, বা আপনি যা দেখেছেন তা নিয়ে আলোচনা করুন। আপনার AI সঙ্গী সর্বদা উপলব্ধ।"
      }
    },
    "prereq": {
      "avatar": "আপনার AI চরিত্র তৈরি করুন",
      "subscription": "প্রিমিয়াম সদস্যতা প্রয়োজন",
      "microphone": "মাইক্রোফোন অ্যাক্সেস প্রয়োজন",
      "contentType": "আপনার বিষয়বস্তুর পছন্দ নির্বাচন করুন",
      "preference": "আপনার ভাষার পছন্দ নির্ধারণ করুন",
      "voiceClone": "আপনার ভয়েস ক্লোন সেট আপ করুন"
    },
    "walkthrough": {
      "tryItNow": "[bn] Try it now",
      "watchDemo": "[bn] Watch demo",
      "skip": "[bn] Skip",
      "next": "[bn] Next",
      "done": "[bn] Done",
      "complete": "[bn] Walkthrough complete",
      "stepCounter": "[bn] {{current}} of {{total}}",
      "pause_ask": {
        "step1": "[bn] Navigate to a movie with interactive moments",
        "step2": "[bn] Pause the movie during a scene",
        "step3": "[bn] Tap the Ask a Character button",
        "step4": "[bn] Watch the character respond to you"
      },
      "interactive_subtitles": {
        "step1": "[bn] Start playing a movie with subtitles",
        "step2": "[bn] Tap the Interactive button in the control bar",
        "step3": "[bn] Select your subtitle language",
        "step4": "[bn] Tap any word in the subtitles to learn more"
      },
      "vocabulary": {
        "step1": "[bn] Open a movie with interactive subtitles enabled",
        "step2": "[bn] Tap a word you want to learn",
        "step3": "[bn] Tap Save to Vocabulary",
        "step4": "[bn] Review your saved words in the Vocabulary section"
      },
      "vod_moments": {
        "step1": "[bn] Start watching a movie with interactive moments",
        "step2": "[bn] Wait for an interactive prompt to appear",
        "step3": "[bn] See the AI-generated interaction"
      },
      "cultural_context": {
        "step1": "[bn] Play a movie with Hebrew dialogue",
        "step2": "[bn] Tap on a subtitle with cultural significance",
        "step3": "[bn] Read the AI-generated cultural explanation"
      },
      "bilingual_bridge": {
        "step1": "[bn] Open a movie with bilingual support",
        "step2": "[bn] Select the bilingual subtitle mode",
        "step3": "[bn] Tap a highlighted phrase to see the translation",
        "step4": "[bn] Watch both languages side by side"
      },
      "ai_companion": {
        "step1": "[bn] Start watching any movie",
        "step2": "[bn] Tap the AI Companion button",
        "step3": "[bn] Type a question about the movie",
        "step4": "[bn] Read the contextual AI response"
      },
      "live_dubbing": {
        "step1": "[bn] Navigate to a live TV channel",
        "step2": "[bn] Tap the dubbing button in the control bar",
        "step3": "[bn] Select your preferred language",
        "step4": "[bn] Listen to the real-time AI dubbing"
      },
      "live_subtitles": {
        "step1": "[bn] Navigate to a live TV channel",
        "step2": "[bn] Tap the subtitles button",
        "step3": "[bn] Select your subtitle language",
        "step4": "[bn] Watch the real-time subtitles appear"
      },
      "live_trivia": {
        "step1": "[bn] Navigate to a live TV channel",
        "step2": "[bn] Tap the trivia button",
        "step3": "[bn] Answer the AI-generated questions"
      },
      "catch_up": {
        "step1": "[bn] Navigate to a live broadcast",
        "step2": "[bn] Select the catch-up option",
        "step3": "[bn] Tap to generate an AI summary",
        "step4": "[bn] Read the summary of what you missed"
      },
      "scene_search": {
        "step1": "[bn] Navigate to a recorded broadcast",
        "step2": "[bn] Type what you are looking for",
        "step3": "[bn] Tap on the matching scene",
        "step4": "[bn] Watch the scene from that point"
      },
      "phonetic_mirror": {
        "step1": "[bn] Open the Phonetic Mirror in Zeh Ani",
        "step2": "[bn] Read the Hebrew phrase shown",
        "step3": "[bn] Speak the phrase into your microphone",
        "step4": "[bn] Review the AI pronunciation feedback"
      },
      "talk_back": {
        "step1": "[bn] Open Talk Back in Zeh Ani",
        "step2": "[bn] Listen to your avatar speak Hebrew",
        "step3": "[bn] Respond in Hebrew using your microphone",
        "step4": "[bn] Review the AI feedback on your response"
      },
      "interactive_mission": {
        "step1": "[bn] Open Interactive Missions",
        "step2": "[bn] Select a mission level",
        "step3": "[bn] Follow the AI-guided exercises",
        "step4": "[bn] Complete the mission and earn rewards"
      },
      "glossary": {
        "step1": "[bn] Open the Hebrew Glossary",
        "step2": "[bn] Search for a Hebrew word",
        "step3": "[bn] Listen to the pronunciation"
      },
      "llm_search": {
        "step1": "[bn] Open the Search tab",
        "step2": "[bn] Type a natural language query",
        "step3": "[bn] Browse the AI-curated results"
      },
      "proactive_voice": {
        "step1": "[bn] Open the Voice Suggestions feature",
        "step2": "[bn] Tap and hold to speak",
        "step3": "[bn] Hear the personalized recommendations"
      },
      "chatbot": {
        "step1": "[bn] Open the AI Assistant",
        "step2": "[bn] Type your question or request",
        "step3": "[bn] Read the AI response"
      }
    }
  },
  "byoc": {
    "home": {
      "title": "[bn] Bring Your Own Content",
      "subtitle": "[bn] Connect your IPTV, Plex, or YouTube sources and enjoy Bayit+ AI features on your own content",
      "connectButton": "[bn] Connect Sources",
      "aiFeatures": {
        "dubbing": "[bn] AI Dubbing available",
        "subtitles": "[bn] Live Subtitles available"
      }
    },
    "pageSubtitle": "আপনার নিজের কন্টেন্ট নিয়ে আসুন - IPTV এবং স্ট্রিমিং সোর্স যোগ করুন",
    "addSource": "সোর্স যোগ করুন",
    "sync": "সিঙ্ক করুন",
    "remove": "সরান",
    "channelCount": "{{count}} চ্যানেল",
    "empty": {
      "title": "কোনো সোর্স যোগ করা হয়নি",
      "subtitle": "Bayit+ এর পাশাপাশি আপনার নিজের কন্টেন্ট দেখতে আপনার IPTV, Xtream বা স্ট্রিমিং সোর্স যোগ করুন"
    },
    "source": {
      "iptv": "IPTV সোর্স",
      "xtream": "Xtream Codes"
    },
    "sourceType": {
      "iptv": "IPTV / M3U",
      "xtream": "Xtream Codes"
    },
    "addIptv": {
      "title": "IPTV সোর্স যোগ করুন",
      "subtitle": "M3U বা M3U8 প্লেলিস্ট ফাইলের URL লিখুন",
      "urlPlaceholder": "https://example.com/playlist.m3u",
      "validate": "যাচাই করুন",
      "add": "সোর্স যোগ করুন"
    },
    "addXtream": {
      "title": "Xtream Codes সংযুক্ত করুন",
      "subtitle": "আপনার Xtream Codes সার্ভারের শংসাপত্র লিখুন",
      "serverUrl": "সার্ভার URL",
      "username": "ব্যবহারকারীর নাম",
      "password": "পাসওয়ার্ড",
      "connect": "সংযুক্ত করুন"
    },
    "preview": {
      "title": "প্রিভিউ",
      "channelCount": "{{count}} চ্যানেল পাওয়া গেছে"
    },
    "providers": {
      "title": "জনপ্রিয় প্রদানকারী"
    },
    "wizard": {
      "step1": "সোর্স যোগ করুন",
      "step2": "প্রক্রিয়াকরণ",
      "step3": "পর্যালোচনা",
      "selectSource": "সোর্স ধরন নির্বাচন করুন"
    },
    "normalization": {
      "title": "আপনার কন্টেন্ট প্রক্রিয়া করা হচ্ছে",
      "total": "মোট {{count}} চ্যানেল",
      "matched": "{{count}} মিলেছে",
      "stage": {
        "parsing": "প্লেলিস্ট বিশ্লেষণ করা হচ্ছে...",
        "matching": "চ্যানেল মেলানো হচ্ছে...",
        "enriching": "মেটাডেটা সমৃদ্ধ করা হচ্ছে...",
        "finalizing": "চূড়ান্ত করা হচ্ছে..."
      }
    },
    "review": {
      "title": "আমদানি করা কন্টেন্ট পর্যালোচনা করুন",
      "subtitle": "{{matched}} মিলেছে, {{unmatched}} চ্যানেল মেলেনি",
      "matchedChannels": "মিলিত চ্যানেল",
      "unmatchedChannels": "অমিলিত চ্যানেল",
      "apply": "প্রয়োগ করুন এবং আমদানি করুন"
    },
    "error": {
      "urlRequired": "অনুগ্রহ করে একটি URL লিখুন",
      "noChannels": "এই প্লেলিস্টে কোনো চ্যানেল পাওয়া যায়নি",
      "invalidUrl": "এই URL থেকে প্লেলিস্ট লোড করা যায়নি",
      "allFieldsRequired": "সমস্ত ফিল্ড প্রয়োজন",
      "enrichFailed": "সোর্স বিশ্লেষণ ব্যর্থ হয়েছে",
      "syncFailed": "সোর্স সিঙ্ক ব্যর্থ হয়েছে",
      "normalizationFailed": "কন্টেন্ট প্রক্রিয়াকরণ ব্যর্থ হয়েছে",
      "normalizationPollFailed": "প্রক্রিয়াকরণের সময় সংযোগ হারিয়ে গেছে"
    },
    "plex": {
      "connectPlex": "Plex সংযুক্ত করুন",
      "enterCodeAt": "এই কোডটি লিখুন",
      "waitingForAuth": "অনুমোদনের জন্য অপেক্ষা করা হচ্ছে...",
      "selectServer": "একটি Plex সার্ভার নির্বাচন করুন",
      "connecting": "{{serverName}}-এ সংযোগ করা হচ্ছে...",
      "connected": "সংযুক্ত",
      "label": "Plex"
    },
    "settings": {
      "title": "আপনার কন্টেন্ট সোর্স",
      "refresh": "রিফ্রেশ",
      "noSources": "কোনো কন্টেন্ট সোর্স সংযুক্ত নেই",
      "noSourcesSubtitle": "আপনার Plex, YouTube, IPTV বা Xtream প্রদানকারী সংযুক্ত করুন",
      "removeSource": "সোর্স সরান",
      "plexSubtitle": "আপনার Plex মিডিয়া সার্ভার থেকে স্ট্রিম করুন",
      "youtubeSubtitle": "আপনার YouTube লাইব্রেরি অ্যাক্সেস করুন",
      "iptvXtreamLabel": "IPTV / Xtream",
      "iptvXtreamSubtitle": "M3U প্লেলিস্ট বা Xtream কোড যোগ করুন",
      "youtube": "YouTube",
      "xtreamCodes": "Xtream Codes",
      "iptv": "IPTV"
    }
  },
  "onboarding": {
    "welcome": {
      "title": "Bayit+-এ আপনাকে স্বাগতম",
      "subtitle": "ইসরায়েলি কন্টেন্ট, সংস্কৃতি এবং ভাষা শেখার জন্য আপনার AI-চালিত প্রবেশদ্বার",
      "getStarted": "শুরু করুন"
    },
    "highlight": {
      "dubbing": "লাইভ AI ডাবিং",
      "subtitles": "ইন্টারেক্টিভ সাবটাইটেল",
      "ai": "AI সঙ্গী",
      "learning": "হিব্রু শেখা"
    },
    "voice": {
      "title": "ভয়েস সেটআপ",
      "subtitle": "ভয়েস কমান্ড, হিব্রু উচ্চারণ অনুশীলন এবং হ্যান্ডস-ফ্রি নেভিগেশনের জন্য আপনার মাইক্রোফোন সক্ষম করুন",
      "enable": "মাইক্রোফোন সক্ষম করুন",
      "granted": "মাইক্রোফোন সফলভাবে সক্ষম হয়েছে"
    },
    "tour": {
      "done": "সম্পন্ন"
    },
    "demo": {
      "dubbing": {
        "title": "লাইভ AI ডাবিং",
        "description": "আপনার পছন্দের ভাষায় রিয়েল-টাইম AI ডাবিং সহ ইসরায়েলি টিভি দেখুন",
        "hebrew": "হিব্রু",
        "english": "ইংরেজি"
      },
      "subtitles": {
        "title": "ইন্টারেক্টিভ সাবটাইটেল",
        "description": "তাৎক্ষণিক অনুবাদ এবং উচ্চারণের জন্য সাবটাইটেলের যেকোনো শব্দ ট্যাপ করুন",
        "sample": "পরিবার Shabbat রাতের খাবারের জন্য একত্রিত হয়েছিল",
        "word": "শাব্বাত",
        "translation": "শাব্বাত - সাপ্তাহিক বিশ্রামের দিন"
      },
      "interaction": {
        "title": "AI চরিত্র ইন্টারঅ্যাকশন",
        "description": "যেকোনো দৃশ্য বিরতি দিন এবং সাংস্কৃতিক প্রেক্ষাপট সম্পর্কে আপনার AI সঙ্গীকে জিজ্ঞেস করুন",
        "userMsg": "তারা কোন উৎসব উদযাপন করছে?",
        "aiMsg": "তারা Sukkot উদযাপন করছে, যা তাঁবুর উৎসব। আপনি যে অস্থায়ী কুটির দেখছেন তাকে sukkah বলা হয়।"
      },
      "trivia": {
        "title": "লাইভ ট্রিভিয়া",
        "description": "AI লাইভ সম্প্রচার থেকে ট্রিভিয়া প্রশ্ন তৈরি করে। প্রতিযোগিতা করুন এবং শিখুন!",
        "question": "ইসরায়েলের সরকারি ভাষা কী?",
        "optionA": "আরবি",
        "optionB": "হিব্রু",
        "optionC": "ইংরেজি"
      },
      "catchup": {
        "title": "স্মার্ট ক্যাচ আপ",
        "description": "লাইভ সম্প্রচারের একটি অংশ মিস করেছেন? AI আপনার মিস করা অংশ সংক্ষেপ করে",
        "missed": "মিস করা",
        "summary": "AI সারসংক্ষেপ",
        "live": "এখন লাইভ"
      },
      "byoc": {
        "title": "আপনার নিজস্ব কন্টেন্ট আনুন",
        "description": "আপনার IPTV উৎস আমদানি করুন এবং Bayit+ কন্টেন্টের পাশাপাশি দেখুন",
        "step1": "উৎস যোগ করুন",
        "step2": "AI সমৃদ্ধিকরণ",
        "step3": "দেখুন"
      },
      "zehAni": {
        "title": "আপনার AI চরিত্র তৈরি করুন",
        "description": "একটি ব্যক্তিগতকৃত AI অবতার তৈরি করুন যা আপনার সাথে শিখবে",
        "generated": "AI অবতার"
      }
    }
  },
  "dm": {
    "title": "বার্তা",
    "conversations": "কথোপকথন",
    "conversation": "কথোপকথন",
    "empty": {
      "title": "এখনো কোনো বার্তা নেই",
      "subtitle": "একজন বন্ধুর সাথে কথোপকথন শুরু করুন"
    },
    "input": {
      "placeholder": "একটি বার্তা টাইপ করুন...",
      "send": "পাঠান"
    },
    "translate": "অনুবাদ করুন",
    "react": "প্রতিক্রিয়া জানান",
    "read": "পঠিত",
    "sent": "পাঠানো হয়েছে",
    "loadMore": "পুরানো বার্তা লোড করুন",
    "startConversation": "কথোপকথন শুরু করতে একটি বার্তা পাঠান",
    "reaction": {
      "like": "পছন্দ",
      "love": "ভালোবাসা",
      "laugh": "হাহা",
      "surprise": "ওয়াও",
      "sad": "দুঃখিত"
    },
    "error": {
      "fetchFailed": "বার্তা লোড করতে ব্যর্থ",
      "sendFailed": "বার্তা পাঠাতে ব্যর্থ"
    }
  },
  "household": {
    "empty": {
      "title": "এখনো কোনো পরিবার নেই",
      "subtitle": "আপনার পরিবার পরিচালনা করতে একটি পরিবার তৈরি করুন"
    },
    "create": {
      "namePlaceholder": "পরিবারের নাম",
      "button": "পরিবার তৈরি করুন"
    },
    "members": "সদস্যরা",
    "role": {
      "owner": "মালিক",
      "guardian": "অভিভাবক",
      "child": "শিশু"
    },
    "invite": {
      "title": "সদস্যদের আমন্ত্রণ জানান",
      "emailPlaceholder": "ইমেইল ঠিকানা",
      "send": "আমন্ত্রণ পাঠান",
      "pending": "বিচারাধীন আমন্ত্রণ"
    },
    "removeMember": "সরিয়ে দিন",
    "error": {
      "fetchFailed": "পরিবার লোড করতে ব্যর্থ",
      "createFailed": "পরিবার তৈরি করতে ব্যর্থ",
      "updateFailed": "পরিবার আপডেট করতে ব্যর্থ",
      "deleteFailed": "পরিবার মুছতে ব্যর্থ",
      "inviteFailed": "আমন্ত্রণ পাঠাতে ব্যর্থ",
      "removeFailed": "সদস্য সরিয়ে দিতে ব্যর্থ"
    }
  },
  "aiChat": {
    "retryButton": "[bn] Retry",
    "sendButton": "[bn] Send",
    "title": "[bn] AI Chat",
    "voiceButton": "[bn] Voice"
  },
  "aiOnboarding": {
    "buttons": {
      "back": "[bn] Back"
    },
    "completion": {
      "message": "[bn] You're all set! Start exploring AI features.",
      "title": "[bn] Setup Complete"
    },
    "permissions": {
      "description": "[bn] Grant permissions to enable AI features like voice and camera.",
      "title": "[bn] Permissions"
    },
    "personalization": {
      "description": "[bn] Tell us your preferences to personalize your AI experience.",
      "title": "[bn] Personalization"
    },
    "title": "[bn] AI Setup",
    "welcome": {
      "description": "[bn] Bayit+ uses AI to enhance your viewing experience with dubbing, subtitles, and more.",
      "title": "[bn] Welcome to Bayit+ AI"
    }
  },
  "auth_device_authorized": "[bn] Device authorized",
  "auth_device_code_expired": "[bn] Code expired",
  "auth_device_get_new_code": "[bn] Get new code",
  "auth_device_manual_login": "[bn] Sign in manually",
  "auth_device_visit_uri": "[bn] Visit the URL shown on your TV",
  "avatar": {
    "tapToSpeak": "[bn] Tap to speak",
    "title": "[bn] Avatar"
  },
  "dubbing": {
    "mixer": {
      "dubbedAudio": "[bn] Dubbed Audio",
      "originalAudio": "[bn] Original Audio",
      "title": "[bn] Audio Mixer"
    },
    "settings_title": "[bn] Dubbing Settings",
    "target_language": "[bn] Target Language",
    "voiceSelector": {
      "selected": "[bn] Selected",
      "subtitle": "[bn] Choose a voice for dubbing",
      "title": "[bn] Voice Selection"
    }
  },
  "go_back": "[bn] Go Back",
  "miniPlayer": {
    "closePlayer": "[bn] Close Player",
    "skipBackward": "[bn] Skip Backward",
    "skipForward": "[bn] Skip Forward"
  },
  "retry": "[bn] Retry",
  "search_hint": "[bn] Search channels, movies, shows...",
  "search_no_results": "[bn] No results found",
  "search_prompt": "[bn] What are you looking for?",
  "subscription_required": "[bn] Subscription Required",
  "subscription_upsell_tv": "[bn] Upgrade to watch on TV",
  "talkback": {
    "title": "[bn] Talkback"
  },
  "voiceAssistant": {
    "fabLabel": "[bn] Voice Assistant",
    "modal": {
      "cancel": "[bn] Cancel",
      "setupMessage": "[bn] Set up voice recognition to use the voice assistant.",
      "setupRequired": "[bn] Setup Required",
      "startSetup": "[bn] Start Setup",
      "title": "[bn] Voice Assistant"
    }
  },
  "voiceCommand": {
    "executing": "[bn] Executing...",
    "listening": "[bn] Listening...",
    "noMatch": "[bn] No match found",
    "recognized": "[bn] Recognized"
  },
  "voiceDecision": {
    "cancel": "[bn] Cancel",
    "confirm": "[bn] Confirm",
    "matched": "[bn] Matched"
  },
  "voiceSearch": {
    "listening": "[bn] Listening...",
    "noResults": "[bn] No results found",
    "tapToSpeak": "[bn] Tap to speak",
    "title": "[bn] Voice Search"
  },
  "voiceSettings": {
    "language": "[bn] Language",
    "speechRate": "[bn] Speech Rate",
    "title": "[bn] Voice Settings",
    "ttsProvider": "[bn] TTS Provider",
    "voiceMode": "[bn] Voice Mode",
    "voiceSelection": "[bn] Voice Selection",
    "wakeWord": "[bn] Wake Word"
  },
  "voiceWizard": {
    "buttons": {
      "back": "[bn] Back"
    },
    "calibration": {
      "description": "[bn] Speak normally to calibrate the microphone.",
      "listening": "[bn] Listening...",
      "micButton": "[bn] Start Recording",
      "resultTitle": "[bn] Calibration Result",
      "stopButton": "[bn] Stop Recording",
      "tapToStart": "[bn] Tap to start calibration",
      "title": "[bn] Microphone Calibration"
    },
    "complete": {
      "message": "[bn] Voice wizard setup is complete. You can now use voice features.",
      "title": "[bn] Setup Complete"
    },
    "language": {
      "description": "[bn] Select your preferred language for voice commands.",
      "title": "[bn] Voice Language"
    },
    "permission": {
      "description": "[bn] Microphone access is needed for voice features.",
      "granted": "[bn] Permission Granted",
      "requestButton": "[bn] Grant Permission",
      "title": "[bn] Microphone Permission"
    },
    "title": "[bn] Voice Wizard"
  },
  "watch_now": "[bn] Watch Now",
  "culture": {
    "title": "ইসরায়েলি সংস্কৃতি",
    "description": "জেরুজালেম, তেল আবিব এবং ইসরায়েলি ঐতিহ্য",
    "shabbat": {
      "title": "শাব্বাত মোড",
      "enableShabbatMode": "শাব্বাত মোড সক্রিয় করুন",
      "shabbatTimes": "শাব্বাতের সময়",
      "timesDescription": "মোমবাতি জ্বালানো এবং হাভদালার সময় এখানে প্রদর্শিত হবে",
      "aboutTitle": "শাব্বাত মোড সম্পর্কে",
      "aboutDescription": "সক্রিয় করা হলে, শাব্বাত মোড শাব্বাতের সময় বিজ্ঞপ্তি বিরতি দেবে, স্ক্রিনের উজ্জ্বলতা কমাবে এবং একটি সরলীকৃত ইন্টারফেস সক্রিয় করবে।"
    },
    "judaism": {
      "holidaysAndTorah": "ছুটি ও তোরাহ",
      "parashaOfTheWeek": "সপ্তাহের পারাশা",
      "parashaDescription": "সাপ্তাহিক তোরাহ পাঠ এবং ভাষ্য"
    },
    "morning": {
      "title": "সকালের আচার",
      "description": "উদ্দেশ্য এবং কৃতজ্ঞতার সাথে আপনার দিন শুরু করুন",
      "dailyInspiration": "দৈনিক অনুপ্রেরণা",
      "dailyInspirationDescription": "আপনার সকালের রুটিনের জন্য কিউরেটেড বিষয়বস্তু",
      "modehAni": "মোদে আনি",
      "modehAniDescription": "সকালের কৃতজ্ঞতা প্রার্থনা",
      "netilatYadayim": "নেতিলাত ইয়াদায়িম",
      "netilatYadayimDescription": "আচারিক হাত ধোয়া",
      "shacharit": "শাচারিত",
      "shacharitDescription": "সকালের প্রার্থনা সেবা"
    },
    "glossary": {
      "termDetail": "শব্দ বিবরণ",
      "definition": "সংজ্ঞা",
      "pronunciation": "উচ্চারণ",
      "examples": "উদাহরণ"
    },
    "jerusalem": {
      "title": "জেরুজালেম"
    },
    "telaviv": {
      "title": "তেল আবিব"
    }
  },
  "zehAni": {
    "dashboard": {
      "title": "জেহ আনি",
      "biometricConsent": "বায়োমেট্রিক সম্মতি",
      "activeConsents": "{{count}} সক্রিয় সম্মতি",
      "magicMirror": "ম্যাজিক মিরর",
      "magicMirrorDescription": "দৈনিক শুভেচ্ছা এবং ফেস আইডি",
      "v2vPractice": "V2V অনুশীলন",
      "v2vPracticeDescription": "ভয়েস-টু-ভয়েস উচ্চারণ",
      "avatar3d": "3D অবতার",
      "avatar3dDescription": "আপনার ব্যক্তিগত অবতার মেশ",
      "movieInteractions": "মুভি ইন্টারঅ্যাকশন",
      "movieInteractionsDescription": "মুভির চরিত্রগুলি ব্রাউজ করুন এবং তাদের সাথে কথা বলুন",
      "contacts": "পরিচিতি",
      "contactsDescription": "WhatsApp পরিচিতি শেয়ারিং",
      "feedback": "মতামত",
      "feedbackDescription": "আপনার অভিজ্ঞতা শেয়ার করুন",
      "consent": "সম্মতি",
      "consentDescription": "বায়োমেট্রিক সম্মতি ব্যবস্থাপনা",
      "chess": "দাবা",
      "chessDescription": "বন্ধু এবং পরিবারের সাথে দাবা খেলুন"
    },
    "mirror": {
      "title": "ম্যাজিক মিরর",
      "avatarContentDescription": "অবতার",
      "wordOfTheDay": "আজকের শব্দ",
      "playLipsync": "লিপসিঙ্ক চালান",
      "noAvatarYet": "এখনো কোনো অবতার নেই",
      "noAvatarDescription": "গল্পে নিজেকে দেখতে একটি 3D অবতার তৈরি করুন",
      "createAvatar": "অবতার তৈরি করুন"
    },
    "mode": {
      "title": "অবতার মোড",
      "enableAvatarMode": "অবতার মোড সক্রিয় করুন",
      "enableDescription": "বিষয়বস্তুতে প্রতিক্রিয়া দেখাচ্ছে আপনার অবতার দেখান",
      "avatarPreview": "অবতার প্রিভিউ",
      "avatarPreviewContentDescription": "অবতার প্রিভিউ",
      "noAvatarConfigured": "কোনো অবতার কনফিগার করা হয়নি",
      "reactionStyle": "প্রতিক্রিয়া শৈলী"
    },
    "wardrobe": {
      "title": "ওয়ার্ডরোব",
      "equippedContentDescription": "সজ্জিত"
    },
    "settings": {
      "title": "অবতার সেটিংস",
      "privacy": "গোপনীয়তা",
      "privateAvatarMode": "প্রাইভেট অবতার মোড",
      "privateAvatarDescription": "আপনার অবতার অন্য ব্যবহারকারীদের থেকে লুকান",
      "appearance": "চেহারা",
      "enableAnimations": "অ্যানিমেশন সক্রিয় করুন",
      "animationsDescription": "অবতারের গতিবিধি এবং অভিব্যক্তি অ্যানিমেট করুন",
      "availableOutfits": "উপলব্ধ পোশাক"
    },
    "selfie": {
      "title": "ভিডিও সেলফি",
      "camera": "ক্যামেরা",
      "cameraPreview": "ক্যামেরা প্রিভিউ",
      "startRecording": "রেকর্ডিং শুরু করুন",
      "stopRecording": "রেকর্ডিং থামান",
      "rec": "REC",
      "enterPin": "অবতার তৈরি করতে আপনার PIN প্রবেশ করুন",
      "pinLabel": "PIN",
      "retake": "পুনরায় নিন",
      "creatingAvatar": "আপনার অবতার তৈরি করা হচ্ছে...",
      "avatarCreated": "অবতার সফলভাবে তৈরি হয়েছে",
      "avatarPreviewContentDescription": "অবতার প্রিভিউ",
      "createAnother": "আরেকটি তৈরি করুন"
    },
    "mesh": {
      "title": "3D অবতার",
      "meshViewer": "3D মেশ ভিউয়ার",
      "meshViewerDescription": "3D মেশ ভিউয়ারের জন্য WebView বা GLSurfaceView ইন্টিগ্রেশন প্রয়োজন",
      "skinTone": "ত্বকের টোন",
      "hairStyle": "চুলের স্টাইল",
      "accessories": "আনুষঙ্গিক",
      "saveChanges": "পরিবর্তন সংরক্ষণ করুন"
    },
    "v2v": {
      "title": "ভয়েস অনুশীলন",
      "nextPhrase": "পরবর্তী বাক্যাংশ",
      "stop": "থামান",
      "record": "রেকর্ড করুন",
      "mic": "MIC",
      "viewProgress": "অগ্রগতি দেখুন",
      "analyzingPronunciation": "উচ্চারণ বিশ্লেষণ করা হচ্ছে...",
      "pronunciationFeedback": "উচ্চারণ প্রতিক্রিয়া",
      "similarity": "সাদৃশ্য: {{score}}%",
      "yourProgress": "আপনার অগ্রগতি",
      "transforms": "ট্রান্সফর্ম: {{count}}",
      "improvement": "উন্নতি: {{score}}%",
      "continuePracticing": "অনুশীলন চালিয়ে যান"
    },
    "characters": {
      "title": "চরিত্র",
      "noCharactersFound": "এই মুভির জন্য কোনো চরিত্র পাওয়া যায়নি",
      "characterCount": "{{count}} চরিত্র"
    },
    "interactions": {
      "title": "মুভি ইন্টারঅ্যাকশন",
      "noInteractableMovies": "কোনো ইন্টারঅ্যাকটিভ মুভি উপলব্ধ নেই"
    },
    "feedbackInbox": {
      "title": "মতামত ইনবক্স",
      "refreshContentDescription": "রিফ্রেশ করুন",
      "noFeedbackYet": "এখনো কোনো মতামত নেই",
      "feedbackAppearHere": "আপনার পরিচিতিদের মতামত এখানে প্রদর্শিত হবে",
      "playVoiceMessage": "ভয়েস মেসেজ চালান"
    },
    "addContact": {
      "title": "পরিচিতি যোগ করুন",
      "nameLabel": "নাম",
      "phoneLabel": "ফোন",
      "relationship": "সম্পর্ক",
      "language": "ভাষা"
    },
    "avatar3d": {
      "title": "3D অবতার",
      "glbMeshViewer": "GLB মেশ ভিউয়ার",
      "controls": "নিয়ন্ত্রণ",
      "animate": "অ্যানিমেট",
      "vertices": "শীর্ষবিন্দু",
      "bones": "হাড়",
      "blendShapes": "ব্লেন্ড শেপস",
      "hasGlb": "GLB আছে",
      "status": "স্থিতি: {{value}}"
    }
  }
}
